// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/Satoshi-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../images/let-you-screen/bg-img.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../svg/up-icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../svg/fill-star.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../svg/purple-tick.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../svg/next-icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../svg/previous-icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../images/upload-id/bg-img.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../images/upload-id/overlay.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../images/upload-id/selfie-overlay.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../images/finger-print/print-border.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../images/finger-print/finger-print-img.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../images/finger-print/finger-print-img-white.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../svg/faq-plus.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../svg/faq-minus.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../svg/faq-down.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../images/payment/visa-card.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../images/payment/left-icon.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../svg/white-up-icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../images/finger-print/scan-code1.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../images/finger-print/print-border2.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*------------------------------------------------------------------
Project: PayFast E-Wallet
Author: The_Krishna     
Last change: 03/06/2024
Primary use:  Online Payment App
-------------------------------------------------------------------*/
/*----------------Table of contents Start---------------------------
1.Default CSS
2.Splash screen CSS
3.Onboarding screen CSS
4.Let you screen CSS
5.Sign In screen CSS
6.Sign up screen CSS
7.Verify phone number screen CSS
8.Confirm otp CSS
9.Send money to all screen CSS
10.Pay Bill  CSS 
11.Send quick response2 CSS
12.Language CSS
13.About us CSS
14.Personal info slider CSS
15.Reason for using payfast CSS
16.Finger Print CSS
17.Forget password CSS
18.Notification screen CSS
19.Deactive account CSS
20.Electricity bill 1 Screen
21.Paid screen Screen
22.Faq css
23.Feedback section css
24.Contact us css
25.Notifiaction setting css
26.Setting screen css
27.Send money1 css
28.Send money4 css
29.Send money css
30.Taxes css
31.Marketing css
32.Data privacy css
33.Delete deactivate css
35.Transfer to bank css
36.Invite friend css
37.Logout popup css
38.Personal info css
39.Activity css
40.Delete account css
41.Add new card css
42.Old invoice css
43.Invoice css
44.Tracking css
45.Preapproved-payment1 css
46.Spilt css
47.Transfer-to-bank-success css
48.Line chart css
49.Homescreen css
50.Bottom tabbar css
51.Face recognition css
52.QR code payment css
53.Create new password CSS
54.Keyframe Animation
---------Table of contents End-----------------------------------*/
/*------------------------ [Color codes] ------------------------                  
Background:#ffffff,#7B51F1,#F5F5F5   
Content:#5A5C5E,#121212      
-------------------------------------------------------------------*/
/************************ 1.Default CSS ***************************/
html {
    scroll-behavior: smooth;
    -webkit-text-size-adjust: 100%;
    width: 100%;
    height: 100%;
}
*,
::after,
::before {
    box-sizing: border-box;
}
a:focus,
a {
    outline: none;
    text-decoration: none;
    cursor: pointer;
}
h1,
h2,
h3,
h4,
h5,
h6,
p {
    margin: 0;
    padding: 0;
}
body {
    max-width: 600px;
    margin: 0 auto;
    height: 100%;
    background-color: var(--primary-color);
}
ul {
    padding: 0;
    margin: 0;
}
.container {
    padding: 0 16px !important;
}
svg {
    vertical-align: middle;
}
input {
    outline-width: 0;
    outline-offset: 0;
    outline: 0;
}
textarea {
    outline-width: 0;
    outline-offset: 0;
    outline: 0;
}
.nav-link:focus-visible {
    outline: none !important;
    box-shadow: none !important;
}
.form-control:focus {
    box-shadow: none !important;
    background: var(--9, #F5F5F5);
    border: none;
}
.site-content {
    width: 100%;
    height: 100%;
}
.mt-16 {
    margin-top: 16px !important;
}
.mt-32 {
    margin-top: 32px !important;
}
.mt-24 {
    margin-top: 24px !important;
}
.mt-12 {
    margin-top: 12px !important;
}
.mt-8 {
    margin-top: 8px !important;
}
.color-purple {
    color: #7B51F1 !important;
}
.color-green {
    color: #00A266 !important;
}
.color-black {
    color: var(--text-color) !important;
}
.color-red,
.red-color {
    color: var(--8, #FB4945) !important;
}
#verify-no-main,
#notification-allow-main,
#reason-using-payfast-main,
#create-new-pin-main,
#forget-password-main,
#confirm-otp-main,
#create-new-password-main,
#send-money1,
#delete-deactivate-main,
#feedback-main,
#personal-info,
#add-new-card,
#bank-and-card-main,
#old-invoice,
#add-new-item,
#tracking-main,
#preapproved-refund,
#spilt8-main,
#spilt7-main,
#spilt6-main,
#spilt5-main,
#spilt4-main,
#spilt3-main,
#electricity1,
#internet1,
#transfer-to-bank-success,
#transfer-to-bank-review,
#send-money-successfull,
#send-money-review,
#Qrcode-main,
#transfer-to-bank-main {
    padding-bottom: 100px !important;
}
#deactive-main,
#payment-main,
#add-tax-main,
#delete-account,
#activity-main .favourite-list {
    padding-bottom: 80px;
}
#invite-friend-main,
#contact-us-main,
#about-us,
#data-privacy,
#faq-main,
#notification-setting,
#language-screen,
#currency-page,
#security-main,
#automatic-payment,
#customer-main,
#setting-main,
#taxes-main,
#request-payment,
#send-money-main,
#preapproved-payment1,
.split2-main,
#pay-bill {
    padding-bottom: 20px;
}
@font-face {
    font-family: "Satoshi";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    font-weight: 500;
    font-display: swap;
    font-style: normal;
}
.split6-screen-content-top,
#old-invoice .feedback-form,
.send-money4-top,
.boder-bottom-activity,
.chart-border,
.border-main {
    border-bottom: 2px solid var(--sub-bg-color);
    padding-bottom: 24px;
}
.delete-content,
.marketing-content,
.about-us-screen-full,
.boder-top {
    border-bottom: 1px solid var(--sub-bg-color);
    padding-bottom: 24px;
}
.change-lan-sec,
.delete-account-bottom,
.setting-center-border,
.send-money-contact-tab.setting-border,
.notification-option-wrap,
#reason-using-payfast-main .change-lan-sec:last-child,
.photo-content-details a,
.Char-content {
    border-bottom: 1px solid var(--sub-bg-color);
}
.loader-mask-splash {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: var(--primary-color);
    z-index: 99999;
}
.flash-btn,
.upload-id-button-content,
#loader,
.mobile-message-main,
.notification-icon-img,
.paid-button1 a,
.paid-button2 a,
.contact-us-mobile-btn,
.notification-option-switch,
.setting-icon,
.contact-icon,
.tax-plus-btn,
.bank-img,
.custom-radio-sel-friend,
.logout-button-main,
.add-item-btn a,
.spilt8-btn,
.transfer-logo,
.pie-chart .chart-container,
.concentric-circles,
.circle,
.scan1,
#splash-screen-page,
.slider-sec-btn a,
.back-btn,
.form-sign-in-password-btn a,
.otp-section,
.verify-number-btn a,
.pay-bill-img,
.allow-btn a,
.done-btn a,
.shape,
.select-img,
.select-sec,
.plus-id-btn a,
.plus-id-btn,
.verify-id-btn a {
    display: flex;
    align-items: center;
    justify-content: center;
}
.bg-green {
    background: #00A266 !important;
}
/************************ 2.Splash CSS ***************************/
#splash-screen-page {
    height: 100vh;
    width: 100%;
}
.splash-screen-content,
.profile-img-content {
    text-align: center;
}
.payfast-txt {
    color: var(--text-color);
    font-family: Poppins;
    font-size: 64px;
    font-style: normal;
    font-weight: 500;
    line-height: 60px;
}
.payfast-txt span {
    color: var(--2, #7B51F1);
    font-weight: 700;
    line-height: 60px;
}
.payfast-title {
    color: var(--sub-text-color);
    text-align: center;
    font-family: Satoshi;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
}
/************************ 3.Onboarding CSS ***************************/
.custom-slider-btn {
    position: relative !important;
    z-index: 2;
    padding: 0;
    margin: 0 !important;
    list-style: none;
    height: fit-content;
    width: fit-content;
    margin-left: auto !important;
    margin-right: auto !important;
    margin-top: 40px !important;
}
.onboarding-slider .carousel-indicators [data-bs-target] {
    margin-right: 8px;
    margin-left: 0 !important;
}
.custom-slider-dots {
    width: 12px !important;
    height: 12px !important;
    border-radius: 8px !important;
    border: none !important;
    background: var(--sub-text-color) !important;
    margin-right: 8px;
    opacity: 0.24;
}
.Onboarding-Screen-1 {
    position: relative;
    margin-top: 50px;
}
.Onboarding-Screen-1-full {
    position: relative;
    height: 100vh;
}
.slider-sec-btn {
    position: fixed;
    width: 100%;
    left: 0;
    bottom: 0;
    background-color: var(--primary-color);
    z-index: 5;
    padding: 16px;
}
.onboarding-slider {
    padding-bottom: 100px;
}
.slider-sec-btn a {
    width: 100%;
    border-radius: 12px;
    background: var(--2, #7B51F1);
    padding: 12px 0;
    margin: auto;
    max-width: 600px;
    color: var(--1, #FFF);
    text-align: center;
    font-family: Poppins;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
}
.slider-txt h2 {
    color: var(--text-color);
    text-align: center;
    font-family: Poppins;
    font-size: 30px;
    font-style: normal;
    font-weight: 600;
    line-height: 40px;
}
.slider-txt p {
    color: var(--sub-text-color);
    text-align: center;
    font-family: Satoshi;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
}
.slider-img,
.verify-number-img,
.otp-resend {
    text-align: center;
}
.onboarding-slider .carousel-item {
    transition: none !important;
}
.slider-txt {
    margin-top: 70px;
}
.custom-slider-dots.active {
    opacity: 1;
    background: var(--text-color) !important;
    width: 40px !important;
}
.loader-mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: var(--primary-color);
    z-index: 99999;
}
/************************ 4.Let you screen CSS ***************************/
.let-you-page-main {
    height: 100vh;
    background: var(--sub-bg-color);
    position: relative;
    overflow: auto;
}
#let-you-main {
    padding-bottom: 100px;
    margin-bottom: 180px;
}
#sign-up-main {
    padding-bottom: 150px;
    margin-bottom: 250px;
}
.let-you-top {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    height: 375px;
    position: relative;
    width: 100%;
    max-width: 100%;
}
.payfast-img_main {
    border-radius: 24px;
    background: var(--1, #FFF);
    width: 120px;
    height: 120px;
    padding: 16px 20px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 20px;
    text-align: center;
}
.back-btn {
    border: 1px solid #ffffff;
    height: 36px;
    width: 36px;
    border-radius: 8px;
}
.let-you-top-wrap {
    padding-top: 30px;
}
.icons_main a {
    border: 2px solid var(--sub-bg-color);
    width: 48px;
    height: 48px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.apple {
    filter: var(--icon-filter);
}
.icons_main {
    display: flex;
    justify-content: center;
    column-gap: 24px;
}
.lets_you_in_box {
    border-radius: 24px;
    background: var(--primary-color);
    padding: 32px 16px;
    margin: 0 16px;
    position: absolute;
    width: calc(100% - 30px);
    left: 0;
    right: 0;
    top: -118px;
}
.lets_you_in_text {
    color: var(--text-color);
    text-align: center;
    font-family: Poppins;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: 36px;
}
.or-section p {
    color: var(--sub-text-color);
    text-align: center;
    font-family: Satoshi;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    overflow: hidden;
}
.or-section p:before {
    right: 8px;
    margin-left: -50%;
}
.or-section p:before,
.or-section p:after {
    background: var(--sub-bg-color);
    content: "";
    display: inline-block;
    height: 2px;
    position: relative;
    vertical-align: middle;
    width: 50%;
}
.or-section p:after {
    left: 8px;
    margin-right: -50%;
}
.form-sign-in-password-btn a {
    width: 100%;
    border-radius: 12px;
    background: var(--2, #7B51F1);
    padding: 12px 0;
    margin: auto;
    max-width: 600px;
    color: var(--1, #FFF);
    text-align: center;
    font-family: Poppins;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
}
.let-you-social-sec {
    position: relative;
    width: 100%;
}
#let-you-footer {
    position: fixed;
    width: 100%;
    left: 0;
    bottom: 0;
    padding: 16px;
    z-index: 99;
    max-width: 600px;
    margin: 0 auto;
    right: 0;
    background: var(--sub-bg-color);
}
.block-footer p {
    color: var(--sub-text-color);
    text-align: center;
    font-family: Satoshi;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
}
.block-footer a {
    color: var(--text-color);
    font-family: Satoshi;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
}
/************************ 5.Sign In screen CSS ***************************/
.iti__arrow:before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) !important;
    position: absolute;
    top: 0px;
}
#sign-in-main {
    padding-bottom: 120px;
    margin-bottom: 220px;
}
.iti__arrow {
    border: 0 !important;
    margin-left: 12px !important;
}
.iti__selected-dial-code {
    display: none;
}
.iti--separate-dial-code .iti__selected-flag {
    background-color: transparent !important;
    padding: 0 !important;
}
.mobile-form {
    border-radius: 8px;
    background: var(--input-bg);
    padding: 11px;
    display: flex;
    align-items: center;
}
.ReactFlagsSelect-module_selectBtn__19wW7 {
    width: 70px !important;
    padding: 0 !important;
    border: none !important;
    font-size: 20px !important;
    justify-content: center !important;
}
.ReactFlagsSelect-module_flagsSelect__2pfa2 {
    padding-bottom: 0 !important;
}
.ReactFlagsSelect-module_selectOptions__3LNBJ {
    width: 320px;
}
.ReactFlagsSelect-module_selectValue__152eS .ReactFlagsSelect-module_label__27pw9 {
    display: none;
}
.sign-in-custom-input {
    border: none;
    background: transparent;
    width: 100%;
    padding-left: 12px;
    color: var(--sub-text-color);
    font-family: Satoshi;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
}
.sign-in-custom-input::placeholder {
    color: var(--5, #5A5C5E);
    font-family: Satoshi;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
}
#mobile_code {
    padding-right: 0;
}
.iti {
    display: flex !important;
}
/************************ 6.Sign up screen CSS ***************************/
.form-details-sign-in {
    border-radius: 8px;
    background: var(--input-bg);
    padding: 11px;
    display: flex;
}
.form-details-sign-in span img {
    filter: var(--icon-filter);
}
/************************ 7.Verify phone number screen CSS ***************************/
.verify-number-bottom {
    border-radius: 24px 24px 0px 0px;
    background: var(--primary-color);
    margin-top: 20px;
    padding: 16px 16px 0px 16px;
    position: relative;
}
.verify-number-main {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-size: cover;
    background-repeat: no-repeat;
    position: relative;
    width: 100%;
    max-width: 100%;
}
div#upload-id-page {
    height: 100vh;
}
.verify-number-top-content {
    padding-top: 30px;
    display: flex;
    align-items: center;
    column-gap: 12px;
}
.header-title p {
    color: var(--1, #FFF);
    font-family: Poppins;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
}
.verify-txt p {
    color: var(--sub-text-color);
    text-align: center;
    font-family: Satoshi;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
}
.otp-section input {
    width: 60px;
    height: 60px;
    text-align: center;
    padding: 10px;
    color: var(--text-color);
    font-family: Satoshi;
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: 32px;
    border-radius: 30px;
    background: var(--sub-bg-color);
}
.otp-section {
    column-gap: 11px;
}
.otp-section input:focus {
    border-radius: 30px;
    border: 2px solid var(--2, #7B51F1);
    background: var(--1, #FFF);
    box-shadow: none !important;
}
.resend-txt1 {
    color: var(--sub-text-color);
    text-align: center;
    font-family: Satoshi;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
}
.resend-txt2 {
    font-family: Satoshi;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
    color: var(--text-color);
}
.verify-number-btn a {
    width: 100%;
    border-radius: 12px;
    background: var(--2, #7B51F1);
    padding: 12px 0;
    margin: auto;
    max-width: 600px;
    color: var(--1, #FFF);
    text-align: center;
    font-family: Poppins;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
}
.verify-number-btn {
    position: fixed;
    bottom: 0;
    width: 100%;
    left: 0;
    right: 0;
    padding: 0 16px;
    padding-bottom: 20px;
    background: var(--primary-color);
    z-index: 2;
}
.resend-txt2 a {
    color: var(--text-color);
}
.form-control:focus {
    background: var(--sub-bg-color);
    box-shadow: none;
}
/************************ 9.Send money to all screen CSS ***************************/
.search-text {
    background: transparent;
    color: white !important;
    font-family: Satoshi;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    border: 0 !important;
    padding: 0;
}
.star-favourite a {
    display: block;
}
.star-favourite span img,
.upIconsSat,
.star-favourite img {
    filter: var(--icon-filter);
}
.search-text::placeholder {
    color: rgb(255 255 255 / 64%) !important;
}
.search-icon {
    background: transparent;
    border: 0 !important;
    padding: 0;
}
.contact-searchbar {
    border: 1px solid #ffffff;
    position: relative;
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    width: 100%;
    padding: 15px !important;
    justify-content: space-between;
    border-radius: 16px;
    background: linear-gradient(92deg, rgba(255, 255, 255, 0.40) 0%, rgba(255, 255, 255, 0.24) 100%);
    backdrop-filter: blur(4px);
}
.seach-bar .form-control:focus {
    background: transparent;
}
.contact-search {
    margin-top: 20px;
}
.voice-icon {
    text-align: center;
}
.seach-bar {
    width: 80%;
}
.item-bookmark img {
    filter: var(--icon-filter);
}
.item-bookmark.active {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
.send-money-contact-tab {
    display: flex;
    align-items: center;
    column-gap: 16px;
    padding: 8px 0;
}
.contact-star,
#Qrcode-main .bank-active-sec {
    margin-left: auto;
}
.contact-profile img {
    border-radius: 50px;
}
.contact-details h3 {
    color: var(--text-color);
    font-family: Satoshi;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
}
.contact-details h4 {
    color: var(--sub-text-color);
    font-family: Satoshi;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px;
    margin-top: 4px;
}
.custom-tab-contact {
    width: 100%;
    width: calc(100% - 30px);
    border-radius: 8px;
    border: 2px solid var(--6, #FFAA01);
    background: var(--1, #FFF);
    position: absolute;
    left: 0;
    z-index: 99;
    margin-top: 25px !important;
    margin: 0 auto;
    right: 0;
}
.custom-tab-contact button {
    width: 50%;
    border: 0 !important;
    border-top-left-radius: 0 !important;
    border-top-right-radius: 0 !important;
    color: var(--6, #FFAA01);
    text-align: center;
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
    padding: 12px !important;
}
.custom-tab-contact .nav-link.active {
    background: var(--6, #FFAA01);
    margin-bottom: auto !important;
    color: var(--1, #FFF);
}
.custom-tab-contact button:hover {
    color: var(--6, #FFAA01);
}
#send-money-contact {
    margin-top: 40px !important;
    padding: 60px 16px 16px 16px !important;
}
#subscription-main .contact-searchbar {
    justify-content: normal;
    column-gap: 8px;
}
#subscription-main .seach-bar {
    width: 100%;
}
.purple-edit-icon {
    filter: brightness(0) saturate(100%) invert(29%) sepia(61%) saturate(1820%) hue-rotate(235deg) brightness(111%) contrast(91%);
}
/************************ 10.Pay Bill  CSS ***************************/
.pay-bill-img {
    width: 74px;
    height: 74px;
    border-radius: 37px;
}
.pay-bill-sec,
.about-us-icon-wrapper {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 24px;
}
.pay-bill-img.bg-1,
.pay-bill-img.bg-9 {
    background: rgb(255 170 1 / 12%);
}
.pay-bill-img.bg-2,
.pay-bill-img.bg-12,
.pay-bill-img.bg-15 {
    background: rgb(251 73 69 / 12%);
}
.pay-bill-img.bg-3 {
    background: rgb(34 211 238 / 12%);
}
.pay-bill-img.bg-4,
.pay-bill-img.bg-10 {
    background: rgb(0 162 102 / 12%);
}
.pay-bill-img.bg-5,
.pay-bill-img.bg-13 {
    background: rgb(123 81 241 / 12%);
}
.pay-bill-img.bg-6,
.pay-bill-img.bg-11 {
    background: rgb(249 115 22 / 12%);
}
.pay-bill-img.bg-7 {
    background: rgb(0 162 102 / 12%);
}
.pay-bill-img.bg-8 {
    background: rgb(132 204 22 / 12%);
}
.pay-bill-img.bg-14 {
    background: rgb(6 182 212 / 12%);
}
.pay-bill-img.bg-16 {
    background: rgb(18 18 18 / 12%);
    filter: var(--icon-filter);
}
.pay-bill-name {
    overflow: hidden;
    color: var(--text-color);
    text-align: center;
    text-overflow: ellipsis;
    font-family: Satoshi;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    margin-top: 8px;
}
.pay-bill-sec a {
    margin-right: auto;
    margin-left: auto;
}
/************************ 11.Send quick response2 CSS ***************************/
.allow-btn a {
    width: 100%;
    border-radius: 12px;
    background: var(--2, #7B51F1);
    padding: 15px 0;
    margin: auto;
    max-width: 600px;
    color: var(--1, #FFF);
    text-align: center;
    font-family: Poppins;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
}
.done-btn a {
    width: 100%;
    border-radius: 12px;
    background: var(--2, #F2EEFE);
    padding: 15px 0;
    margin: auto;
    max-width: 600px;
    color: var(--1, #7B51F1);
    text-align: center;
    font-family: Poppins;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
}
.bottom-btn {
    position: fixed;
    width: 100%;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 0 16px 16px 16px;
    background: white;
}
#send-response2 {
    padding-bottom: 160px;
}
/************************ 12.Language CSS ***************************/
.change-lan-sec {
    padding: 16px 0px !important;
}
#currency-page .form-check-input.custom-input:checked,
#language-screen .form-check-input.custom-input:checked,
#spilt8-main .form-check-input.custom-input:checked,
#reason-using-payfast-main .form-check-input.custom-input:checked {
    background: var(--primary-color);
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    background-size: cover;
    width: 20px;
    height: 20px;
    border: none;
}
.form-check-input {
    --bs-form-check-bg: transparent;
}
.form-check-label.custom-lable {
    display: flex;
    align-items: center;
    color: var(--sub-text-color);
    font-family: Satoshi;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
}
.custom-lable span {
    padding-right: 8px;
}
#currency-page .form-check-input.custom-input,
#language-screen .form-check-input.custom-input,
#spilt8-main .form-check-input.custom-input,
#reason-using-payfast-main .form-check-input.custom-input {
    width: 18px;
    height: 18px;
    border-radius: 4px;
    border: 2px solid #7B51F1;
    float: right !important;
}
.language-sel .curr-icon {
    filter: var(--icon-filter);
}
.change-lan-sec:last-child {
    border: navajowhite;
}
.form-check-input:focus {
    box-shadow: none !important;
}
.language-sel .form-check-label.custom-lable {
    color: var(--text-color);
}
.form-check-input:active {
    filter: none;
}
.first-pt-0 {
    padding-top: 0 !important;
}
/************************ 13.About us CSS ***************************/
.social-detail-about {
    margin-left: auto;
    margin-right: auto;
}
.shape {
    width: 74px;
    height: 74px;
    border-radius: 37px;
    cursor: pointer;
}
.facebook-bg {
    background: rgb(59 89 153 / 8%);
}
.instragram-bg {
    background: linear-gradient(225deg, rgb(110 62 255 / 7%) 0%, rgb(224 49 77 / 7%) 47.92%, rgb(254 215 84 / 7%) 100%);
}
.twitter-bg {
    background: rgb(29 161 242 / 7%);
}
.youtube-bg {
    background: rgb(255 0 0 / 7%);
}
.privacy-txt p {
    color: var(--sub-text-color);
    font-family: Satoshi;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
}
.pt-10 {
    padding-top: 10px;
}
p.about-social-txt {
    color: var(--sub-text-color);
    text-align: center;
    font-family: Satoshi;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 16px;
    padding-top: 12px;
}
.social-txt {
    color: var(--text-color);
    font-family: Poppins;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
}
/************************ 14.Personal info slider CSS ***************************/
.form-floating>.form-control:not(:placeholder-shown)~label::after {
    background: transparent !important;
}
#msform .progress {
    background: var(--sub-bg-color);
    width: 140px;
    height: 8px;
    margin-left: auto;
    margin-right: auto;
}
#msform .progress-bar {
    background: #7B51F1;
}
#msform {
    text-align: center;
    position: relative;
    margin-bottom: 0;
}
#msform fieldset:not(:first-of-type) {
    display: none;
}
#msform .action-button {
    width: 48px;
    height: 48px;
    background: var(--sub-bg-color);
    border: 0 none;
    border-radius: 12px;
    cursor: pointer;
    padding: 10px 5px;
    float: right;
    position: relative;
    margin-top: 24px;
}
.input-icon-next {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) !important;
    background-repeat: no-repeat !important;
    background-position: center !important;
}
.input-icon-previous {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) !important;
    background-repeat: no-repeat !important;
    background-position: center !important;
}
#msform .action-button-previous {
    width: 48px;
    height: 48px;
    background: var(--sub-bg-color);
    border: 0 none;
    border-radius: 8px;
    cursor: pointer;
    padding: 10px 5px;
    float: left;
    position: relative;
    margin-top: 24px;
}
.home-address-heading h2 {
    color: var(--text-color);
    text-align: center;
    font-family: Poppins;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: 36px;
}
.home-address-heading p {
    color: var(--sub-text-color);
    text-align: center;
    font-family: Satoshi;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    margin-top: 12px;
}
#personal-info-slider {
    padding: 16px !important;
}
#file-input {
    display: none;
}
#files {
    display: none;
}
.select-img {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    background: var(--2, #7B51F1);
}
.select-sec {
    column-gap: 12px;
    margin-top: 24px;
}
.select-img img,
.plus-id-btn img {
    filter: brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(7472%) hue-rotate(114deg) brightness(110%) contrast(98%);
}
.select-txt {
    color: var(--2, #7B51F1);
    font-family: Satoshi;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
}
.goverment-id-sec {
    border-radius: 12px;
    background: var(--sub-bg-color);
    padding: 24px 16px;
}
.goverment-id-sec h3 {
    color: var(--text-color);
    text-align: center;
    font-family: Satoshi;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
    margin-bottom: 8px;
}
.goverment-id-sec p {
    color: var(--sub-text-color);
    text-align: center;
    font-family: Satoshi;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
}
.plus-id-btn a {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    background: var(--2, #7B51F1);
    padding: 12px;
}
.plus-id-btn {
    column-gap: 12px;
}
.verify-id-btn a {
    width: 100%;
    border-radius: 12px;
    background: var(--sub-bg-color);
    padding: 15px 0;
    margin: auto;
    max-width: 600px;
    color: var(--2, #7B51F1);
    text-align: center;
    font-family: Poppins;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
}
.verify-id-btn {
    pointer-events: none;
    cursor: default;
    position: absolute;
    width: 100%;
    bottom: -100px;
    clear: both;
    padding-bottom: 16px;
}
.verify-my-btn {
    pointer-events: auto !important;
}
.finger-modal-content .modal-body {
    padding: 12px 16px;
    bottom: 0;
    background: var(--primary-color);
}
.photo-custom-modal .modal-dialog {
    position: fixed;
    top: auto;
    right: 0;
    left: 0;
    bottom: 0;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 0;
}
.photo-type p {
    color: var(--sub-text-color);
    text-align: center;
    font-family: Satoshi;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
}
.photo-content-details a div:nth-child(1) {
    color: var(--text-color);
    font-family: Satoshi;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
}
.photo-content-details a {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 0;
}
.photo-content-details img {
    filter: var(--icon-filter);
}
.card-btn {
    text-align: center;
}
.photo-content-details:last-child {
    border-bottom: none;
}
#photo-id-modal {
    background: linear-gradient(180deg, rgba(18, 18, 18, 0.56) 0%, rgba(18, 18, 18, 0.24) 100%);
    backdrop-filter: blur(2px);
}
.finger-modal-content {
    border: 0;
}
.photo-custom-modal .modal.fade .modal-dialog {
    transition: transform .3s ease-out;
    transform: translate(0, 0px);
    margin: auto;
}
.card-btn button {
    background: transparent;
    border: navajowhite;
    padding: 0;
}
.hidden-text-button {
    color: transparent;
    text-indent: -9999px;
    background: #f0f0f0;
    width: 100px;
    height: 50px;
    border-radius: 10px;
    border: none;
}
/************************ 15.Reason for using payfast CSS ***************************/
.we-txt {
    color: var(--sub-text-color);
    text-align: center;
    font-family: Satoshi;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
}
.border-top {
    border-top: 2px solid var(--sub-bg-color) !important;
}
#reason-using-payfast-main .custom-lable {
    color: var(--text-color);
}
#reason-using-payfast-main .change-lan-sec {
    padding: 12px 0 !important;
}
#upload-id-main {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    width: 100%;
    height: calc(100vh - 66px);
    position: relative;
    border-radius: 24px 24px 0px 0px;
    margin-top: 20px;
}
.frame {
    max-width: 768px;
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
    border-radius: 34px 34px 0px 0px;
}
.frame img {
    width: 100%;
    height: 100%;
}
#upload-id-page .verify-number-top {
    padding-bottom: 20px;
}
.overlay {
    position: absolute;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    width: 100%;
    top: 0;
    right: 0;
    height: 100%;
    border-radius: 24px 24px 0px 0px;
}
.overlay.selfie-overlay {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
}
.upload-top h1 {
    color: var(--1, #FFF);
    text-align: center;
    font-family: Satoshi;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
}
.upload-top p {
    color: var(--1, #FFF);
    text-align: center;
    font-family: Satoshi;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
}
.upload-id-content {
    position: absolute;
    height: 100%;
    width: 100%;
    padding: 16px 16px 0 16px;
    bottom: 0;
}
.flash-btn {
    width: 48px;
    height: 48px;
    border-radius: 24px;
    background: white;
}
.upload-id-button-content {
    column-gap: 30px;
}
.upload-id-bottom {
    position: relative;
    height: calc(100% - 86px);
}
.upload-id-button {
    position: fixed;
    width: 100%;
    bottom: 0;
    left: 0;
    right: 0;
    padding-bottom: 30px;
}
.scanner-border {
    margin-top: 64px;
    text-align: center;
}
.verify-txt {
    color: var(--1, #FFF);
    text-align: center;
    font-family: Satoshi;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
}
#loader {
    color: var(--6, #FFAA01);
    text-align: center;
    font-family: Poppins;
    font-size: 36px;
    font-style: normal;
    font-weight: 600;
    line-height: 36px;
}
.loader-content {
    position: fixed;
    width: 100%;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    padding-bottom: 30px;
    bottom: 0;
}
.finger-content-sec h2 {
    color: var(--text-color);
    text-align: center;
    font-family: Poppins;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: 36px;
}
.finger-content-sec p {
    color: var(--5, #5A5C5E);
    text-align: center;
    font-family: Satoshi;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
}
.face-main .offcanvas-body {
    overflow-y: hidden;
}
.loader,
.finger-img-sec {
    text-align: center;
}
.sk-fading-circle {
    width: 40px;
    height: 40px;
    position: relative;
    margin-left: auto;
    margin-right: auto;
}
.sk-fading-circle .sk-circle {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
}
.sk-fading-circle .sk-circle:before {
    content: '';
    display: block;
    margin: 0 auto;
    width: 15%;
    height: 15%;
    background-color: #7B51F1;
    border-radius: 100%;
    animation: sk-circleFadeDelay 1.2s infinite ease-in-out both;
}
.sk-fading-circle .sk-circle2 {
    transform: rotate(30deg);
}
.sk-fading-circle .sk-circle3 {
    transform: rotate(60deg);
}
.sk-fading-circle .sk-circle4 {
    transform: rotate(90deg);
}
.sk-fading-circle .sk-circle5 {
    transform: rotate(120deg);
}
.sk-fading-circle .sk-circle6 {
    transform: rotate(150deg);
}
.sk-fading-circle .sk-circle7 {
    transform: rotate(180deg);
}
.sk-fading-circle .sk-circle8 {
    transform: rotate(210deg);
}
.sk-fading-circle .sk-circle9 {
    transform: rotate(240deg);
}
.sk-fading-circle .sk-circle10 {
    transform: rotate(270deg);
}
.sk-fading-circle .sk-circle11 {
    transform: rotate(300deg);
}
.sk-fading-circle .sk-circle12 {
    transform: rotate(330deg);
}
.sk-fading-circle .sk-circle2:before {
    animation-delay: -1.1s;
}
.sk-fading-circle .sk-circle3:before {
    animation-delay: -1s;
}
.sk-fading-circle .sk-circle4:before {
    animation-delay: -0.9s;
}
.sk-fading-circle .sk-circle5:before {
    animation-delay: -0.8s;
}
.sk-fading-circle .sk-circle6:before {
    animation-delay: -0.7s;
}
.sk-fading-circle .sk-circle7:before {
    animation-delay: -0.6s;
}
.sk-fading-circle .sk-circle8:before {
    animation-delay: -0.5s;
}
.sk-fading-circle .sk-circle9:before {
    animation-delay: -0.4s;
}
.sk-fading-circle .sk-circle10:before {
    animation-delay: -0.3s;
}
.sk-fading-circle .sk-circle11:before {
    animation-delay: -0.2s;
}
.sk-fading-circle .sk-circle12:before {
    animation-delay: -0.1s;
}
@keyframes sk-circleFadeDelay {
    0%,
    39%,
    100% {
        opacity: 0;
    }
    40% {
        opacity: 1;
    }
}
/************************ 16.Finger Print CSS ***************************/
.scan {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
    width: 220px;
    height: 220px;
    background-size: 300px;
    background-repeat: no-repeat;
    background-size: cover;
    margin-left: auto;
    margin-right: auto;
}
.scan .fingerprint {
    position: relative;
    width: 220px;
    height: 220px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
    background-size: 300px;
    background-repeat: no-repeat;
    background-size: cover;
}
.dark .scan .fingerprint {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}
.scan .fingerprint::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
    background-size: 300px;
    background-repeat: no-repeat;
    background-size: cover;
    animation: animate 4s ease-in-out infinite;
    filter: brightness(0) saturate(100%) invert(30%) sepia(94%) saturate(1008%) hue-rotate(229deg) brightness(109%) contrast(91%);
}
.finger-print-main .modal-dialog {
    margin: inherit !important;
    margin-right: auto !important;
    margin-left: auto !important;
}
.scan .fingerprint::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 4px;
    border-radius: 8px;
    animation: animate_line 4s ease-in-out infinite;
}
.sub-text {
    color: var(--sub-text-color);
    text-align: center;
    font-family: Satoshi;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
}
.verify-number-btn.fingerprint-btn {
    position: relative;
    padding: 0;
}
.add-fingerprint p {
    color: var(--sub-text-color);
    text-align: center;
    font-family: Satoshi;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
}
.scanner_main {
    padding-top: 120px;
    padding-bottom: 135px;
}
.circles,
#homepage .home-activity {
    padding-bottom: 135px;
}
.skip-txt a {
    color: var(--text-color);
    font-family: Satoshi;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
}
.skip-txt {
    text-align: center;
}
.finger-print-bottom {
    position: fixed;
    width: 100%;
    bottom: 0;
    left: 0;
    padding: 16px 16px;
    background: var(--primary-color);
}
/************************ 17.Forget password CSS ***************************/
.form-item {
    position: relative;
    margin-bottom: 15px;
}
.form-item input {
    display: block;
    width: 100%;
    height: 64px;
    background: transparent;
    border: solid 2px black;
    transition: all .3s ease;
    padding-left: 80px;
    border-radius: 30px;
    outline: none;
    padding-top: 5px;
    color: grey;
    font-family: Satoshi;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
}
.form-item label {
    position: absolute;
    cursor: text;
    z-index: 2;
    top: 33%;
    left: 70px;
    padding: 0 10px;
    color: green;
    transition: all .3s ease;
    font-family: Satoshi;
    font-weight: 500;
    line-height: 20px;
    font-size: 16px;
}
.form-item input:focus {
    border: 2px solid #00D061;
}
.mobile-message-main {
    position: absolute;
    top: 8px;
    left: 8px;
    width: 48px;
    height: 48px;
    background-color: var(--sub-bg-color);
    border-radius: 50%;
}
.form-item input:focus+label,
.form-item input:valid+label {
    font-size: 14px;
    top: 3px;
    color: #00D061 !important;
}
.forget-password-form .form-floating>label {
    left: 70px;
}
.forget-password-form input {
    padding-left: 80px !important;
    background: transparent !important;
    border-radius: 12px;
    border: 2px solid var(--14, #F2EEFE);
    background: var(--1, #FFF);
    height: 64px !important;
}
.forget-password-form .form-control:focus {
    box-shadow: none !important;
    background: transparent !important;
    border: 2px solid var(--14, #F2EEFE);
}
.forget-password-form .form-floating input:focus {
    border: 2px solid var(--2, #7B51F1);
}
/************************ 18.Notification screen CSS ***************************/
.notification-icon-img {
    width: 64px;
    height: 64px;
    border-radius: 32px;
}
.icon1 {
    background: #F2EEFE;
}
.icon2 {
    background: rgb(255 170 1 / 12%);
}
.icon3 {
    background: rgb(251 73 69 / 12%);
}
.icon4 {
    background: rgb(0 162 102 / 12%);
}
.nofication-content {
    display: flex;
    column-gap: 16px;
    align-items: center;
}
.notification-new {
    margin-left: auto;
}
.new {
    padding: 8px 12px;
    border-radius: 4px;
    background: var(--7, #00A266);
}
.new a {
    color: var(--1, #FFF);
    text-align: center;
    font-family: Satoshi;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    display: block;
}
.notification-content h3 {
    color: var(--text-color);
    font-family: Satoshi;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
}
.notification-content p {
    color: var(--sub-text-color);
    font-family: Satoshi;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px;
    padding-top: 4px;
}
.now-txt {
    color: var(--sub-text-color);
    font-family: Satoshi;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px;
}
.notification-details {
    border-bottom: 2px solid var(--sub-bg-color);
    padding-bottom: 12px;
}
.notification-details:last-child {
    border-bottom: none;
}
#notification-main {
    padding: 16px !important;
}
/************************ 19.Deactive account CSS ***************************/
.deactive-account-sec h1 {
    color: var(--text-color);
    font-family: Poppins;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
}
.deactivate-step p,
.deactivate-step-list li {
    color: var(--sub-text-color);
    font-family: Satoshi;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
}
.deactivate-step-list li {
    padding-top: 8px;
}
.deactivate-step-list {
    padding-left: 25px;
}
/************************ 20.Electricity bill 1 Screen ***************************/
.electricity1-top {
    border-bottom: 2px solid var(--sub-bg-color);
}
.pay-txt {
    color: var(--text-color);
    text-align: center;
    font-family: Poppins;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: 36px;
}
#electricity1 .pay-bill-img {
    margin-right: auto;
    margin-left: auto;
}
#electricity1 .pay-bill-name {
    padding-bottom: 24px;
}
.custom-input-id {
    border: none;
    background: aqua;
    width: 100%;
    color: var(--sub-text-color);
    font-family: Satoshi;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    border-radius: 12px;
    background: var(--primary-color);
    padding: 16px;
    border: 2px solid var(--sub-bg-color);
}
.custom-lbl-electricity {
    color: var(--text-color);
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
}
.bill-amount-content span:first-child {
    color: var(--sub-text-color);
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
}
.bill-amount-content span:last-child {
    color: var(--text-color);
    text-align: right;
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
}
.bill-amount-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.electricity1-bottom.mt-24 {
    border-radius: 12px;
    border: 2px solid var(--2, #7B51F1);
    background: var(--primary-color);
    padding: 16px;
}
.custom-select-internet select {
    width: 100%;
    color: var(--sub-text-color);
    font-family: Satoshi;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    padding: 16px;
    border-radius: 12px;
    background-color: var(--sub-bg-color);
    border: 0;
}
.arrow-icon {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat;
    background-position: 96% center;
    font-size: 18px;
    appearance: none;
}
select:focus-visible {
    outline: 0;
}
/************************ 21.Paid screen css ***************************/
.paid-button1 a {
    width: 100%;
    border-radius: 12px;
    background: var(--2, #7B51F1);
    padding: 12px 0;
    margin: auto;
    max-width: 600px;
    color: var(--1, #FFF);
    text-align: center;
    font-family: Poppins;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
}
.paid-button2 a {
    width: 100%;
    border-radius: 12px;
    background: var(--sub-bg-color);
    padding: 12px 0;
    margin: auto;
    max-width: 600px;
    color: var(--2, #7B51F1);
    text-align: center;
    font-family: Poppins;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
}
.bill-paid-btn {
    position: fixed;
    width: 100%;
    bottom: 0;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    background: var(--primary-color);
    padding: 16px;
    padding-bottom: 16px;
    box-shadow: 0px -4px 4px 0px rgba(18, 18, 18, 0.04);
}
#bill-paid {
    padding-bottom: 170px !important;
}
/************************ 22.Faq css ***************************/
.nested-accordion {
    cursor: pointer;
    position: relative;
}
.review-time p {
    color: var(--3, #666);
    font-family: Lato;
    font-size: 10px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
}
.nested-accordion h3 {
    color: var(--4, #121212);
    font-family: Satoshi;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
}
.nested-accordion .comment {
    color: var(--5, #5A5C5E);
    font-family: Satoshi;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
}
.nested-accordion h3:before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
    position: absolute;
    right: 0;
    color: #FF4C3B;
    font-family: Space Grotesk;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
}
.nested-accordion h3.selected {
    color: var(--2, #7B51F1);
    font-family: Satoshi;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
}
/* .faq-txt1:before {
    content: url(../svg/up-arrow.svg) !important;
} */
.nested-accordion h3.selected:before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
}
.faq-txt1.selected:before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_15___}) !important;
}
.faq-txt1:before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) !important;
}
/************************ 23.Feedback css ***************************/
label {
    display: block;
}
.custom-textarea {
    width: 100%;
    padding: 16px;
    color: var(--5, #5A5C5E);
    font-family: Satoshi;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    border-radius: 12px;
    background: var(--9, #F5F5F5);
    border: 0;
}
textarea {
    resize: none;
}
/************************ 24.Contact us css ***************************/
.contact-us-mobile-btn a {
    border-radius: 8px;
    background: rgb(123 81 241 / 8%);
    padding: 12px;
    width: 100%;
    display: block;
    color: var(--text-color);
    font-family: Satoshi;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
}
.contact-us-no {
    padding-left: 12px;
}
/************************ 25.Notifiaction setting css ***************************/
.notification-option-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 0;
}
.notification-option-name p {
    color: var(--text-color);
    font-family: Satoshi;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
}
.notification-option-switch .switch {
    position: relative;
    display: inline-block;
    width: 40px;
    height: 20px;
}
.notification-option-switch .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 4px;
    right: 0;
    bottom: 0;
    border: 1px solid rgb(102 102 102 / 20%);
    border-radius: 40px;
    transition: 0.4s;
}
.notification-option-switch .slider:before {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    background: #fff;
    border-radius: 22px;
    left: 0px;
    bottom: 0px;
    transition: 0.4s;
    border-radius: 22px;
    border: 0.5px solid #F0F0F0;
    box-shadow: 0px 3px 1px 0px rgba(0, 0, 0, 0.05), 0px 1px 1px 0px rgba(0, 0, 0, 0.08), 0px 3px 8px 0px rgba(0, 0, 0, 0.08);
}
.notification-option-switch input:checked+.slider {
    background: #7B51F1;
    border: 1px solid transparent;
}
.notification-option-switch input:checked+.slider:before {
    transform: translateX(16px);
}
.switch input {
    opacity: 0;
    width: 0;
    height: 0;
}
p.notify-txt {
    color: var(--text-color);
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
}
/************************ 26.Setting screen css ***************************/
.setting-header {
    display: flex;
    justify-content: space-between;
    width: 100%;
}
.setting-left {
    width: 50%;
    display: flex;
    align-items: center;
    column-gap: 12px;
}
.setting-right {
    width: 50%;
    justify-content: end;
    display: flex;
    align-items: center;
    column-gap: 12px;
}
.setting-right span a {
    display: flex;
}
.dots-icon {
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    border: 2px solid white;
    border-radius: 8px;
}
.setting-txt {
    color: var(--1, #FFF);
    font-family: Poppins;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
}
.setting-top {
    border-bottom: 2px solid var(--sub-bg-color);
    padding-bottom: 16px;
}
.setting-title h3 {
    color: var(--text-color);
    font-family: Satoshi;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
}
.setting-icon {
    width: 48px;
    height: 48px;
    background: var(--sub-bg-color);
    border-radius: 8px;
}
.setting-center-border {
    height: 2px;
    background: var(--sub-bg-color);
    margin: 24px 0;
}
.border-none {
    border-bottom: none !important;
    padding-bottom: 0 !important;
}
.setting-lanuage {
    color: var(--sub-text-color);
    text-align: right;
    font-family: Satoshi;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    display: inline-flex;
    margin-right: 16px;
}
.send-money-contact-tab {
    cursor: pointer;
}
.diffrent-chat-dropdown {
    padding: 0;
    margin: 0;
    list-style-type: circle;
    margin-left: 50px;
    margin-right: 30px;
}
.diffrent-chat-dropdown li {
    border-bottom: 2px solid var(--sub-bg-color);
    padding: 8px;
}
.diffrent-chat-dropdown li a {
    color: var(--text-color);
    font-family: Satoshi;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
}
/************************ 27.Send money1 css ***************************/
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
    appearance: none;
    margin: 0;
}
.enter-amount label,
.total-txt {
    color: var(--sub-text-color);
    text-align: center;
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
}
.available-txt {
    color: var(--sub-text-color);
    text-align: center;
    font-family: Satoshi;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
}
.enter-amount input {
    width: 100%;
    padding: 22px 12px;
    text-align: center;
    color: var(--text-color);
    text-align: center;
    font-family: Poppins;
    font-size: 36px;
    font-style: normal;
    font-weight: 500;
    line-height: 36px;
    border-radius: 12px;
    border: 2px solid var(--8, #FB4945);
    background: var(--primary-color);
    border-style: solid;
}
.enter-amount input:focus,
.enter-amount input.active {
    border: 2px solid #00A266;
}
.fee-txt {
    color: var(--sub-text-color);
    text-align: center;
    font-family: Satoshi;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
}
/************************ 28.Send money4 css ***************************/
.send-money4-top h1 {
    color: var(--4, #121212);
    text-align: center;
    font-family: Poppins;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 30px;
}
.send-money4-top p {
    color: var(--5, #5A5C5E);
    text-align: center;
    font-family: Satoshi;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
}
.custom-radio {
    position: relative;
    margin-bottom: 0;
    border-radius: 12px;
    border: 2px solid var(--sub-bg-color);
    background: var(--primary-color);
    padding: 16px !important;
}
#data-privacy .form-check-input:checked[type=radio],
#delete-deactivate-main .form-check-input:checked[type=radio],
#delete-account .form-check-input:checked[type=radio],
#transfer-to-bank-main .form-check-input:checked[type=radio] {
    outline: 2px solid #FB4945;
    outline-offset: 4px;
    background: #FB4945;
    border: 0;
    width: 11px;
    height: 11px;
    margin-right: 5px;
}
.custom-radio input {
    right: 0;
}
.checkout-modal-lbl {
    display: inline-grid !important;
    padding: 16px 0;
    color: var(--text-color);
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
}
.checkout-modal-lbl span {
    color: var(--sub-text-color);
    font-family: Satoshi;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    padding-right: 50px;
}
.custom-radio input {
    position: absolute;
    right: 25px;
    top: 0;
    bottom: 0;
    margin: auto;
    width: 24px;
    height: 24px;
    border: 2px solid var(--text-color);
}
.custom-radio.active {
    border: 2px solid var(--8, #FB4945) !important;
}
/************************ 29.Send money css ***************************/
.sendmoney-top h1 {
    color: var(--text-color);
    text-align: center;
    font-family: Poppins;
    font-size: 36px;
    font-style: normal;
    font-weight: 600;
    line-height: 36px;
}
.sendmoney-top p {
    color: var(--sub-text-color);
    text-align: center;
    font-family: Satoshi;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
}
.sendmoney-top.send-money4-top {
    padding-bottom: 16px;
}
.contact-icon {
    background: var(--sub-bg-color);
    padding: 13px;
    width: 74px;
    height: 74px;
    border-radius: 37px;
    margin-left: auto;
    margin-right: auto;
}
.send-money p {
    color: var(--text-color);
    text-align: center;
    text-overflow: ellipsis;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
}
.sendmoney-bottom-wrap {
    display: flex;
    justify-content: space-around;
    width: 100%;
}
.send-money {
    width: 33.33%;
}
.sendmomey-details {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 2px solid var(--sub-bg-color);
    padding-bottom: 12px;
}
.sendmomey-details span:first-child {
    color: var(--sub-text-color);
    font-family: Poppins;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
}
.sendmomey-details span:last-child {
    color: var(--text-color);
    text-align: right;
    font-family: Poppins;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
}
img.copied-icon {
    margin-left: 8px;
}
.sendmoney-content {
    border-radius: 12px;
    border: 2px solid var(--2, #7B51F1);
    background: var(--primary-color);
    padding: 16px;
}
.sendmomey-details:last-child {
    padding-bottom: 0;
    border-bottom: 0;
}
/************************ 30.Taxes css ***************************/
.tax-plus-btn {
    width: 56px;
    height: 56px;
    background: var(--2, #7B51F1);
    border-radius: 26px;
    position: absolute;
    bottom: 0;
    right: 0;
    margin-bottom: 50px;
    margin-right: 16px;
}
#taxes-main .tax-plus-btn {
    margin-bottom: 30px;
}
.tax-plus-btn img {
    filter: brightness(0) saturate(100%) invert(100%) sepia(100%) saturate(0%) hue-rotate(299deg) brightness(106%) contrast(101%);
}
#taxes-main .sendmomey-details {
    padding: 16px 0 !important;
}
#taxes-main .sendmomey-details:first-child {
    padding-top: 0 !important;
}
#taxes-main .sendmomey-details span:first-child,
#taxes-main .sendmomey-details span:last-child {
    color: var(--text-color);
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
}
/************************ 31.Marketing css ***************************/
.marketing-content p {
    color: var(--sub-text-color);
    font-family: Satoshi;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
}
.marketing-content h2 {
    color: var(--text-color);
    font-family: Poppins;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
}
.marketing-content .notification-option-wrapper {
    padding: 0;
}
.marketing-content .notification-option-name p {
    color: var(--text-color);
    font-family: Satoshi;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
}
/************************ 32.Data privacy css ***************************/
.data-privacy-content h1 {
    color: var(--text-color);
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
}
.privacy-content h2 {
    color: var(--text-color);
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
}
.privacy-content p {
    color: var(--sub-text-color);
    font-family: Satoshi;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
}
.privacy-content {
    border-radius: 12px;
    border: 2px solid var(--sub-bg-color);
    background: var(--primary-color);
    padding: 16px;
}
.manage-txt {
    color: var(--text-color);
    font-family: Poppins;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
}
.manage-data-sec {
    border-radius: 12px;
    border: 2px solid var(--sub-bg-color);
    background: var(--primary-color);
    padding: 16px;
}
.manage-data-title h3 {
    color: var(--text-color);
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
}
.manage-data-title p {
    color: var(--sub-text-color);
    font-family: Satoshi;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
}
/************************ 33.Delete deactivate css ***************************/
.delete-content p {
    color: var(--sub-text-color);
    text-align: center;
    font-family: Satoshi;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
}
/************************ 34.Send money review css ***************************/
.purple-border {
    border-bottom: 2px solid #7B51F1;
}
.review-note h2 {
    color: var(--text-color);
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
}
.review-note p {
    color: var(--sub-text-color);
    font-family: Satoshi;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
}
#send-money-review .sendmomey-details {
    padding-bottom: 16px;
}
.money-review-txt {
    color: var(--text-color);
    font-family: Satoshi;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
}
form {
    margin-block-end: 0px;
}
/************************ 35.Transfer to bank css ***************************/
.transfer-first {
    display: flex;
    align-items: center;
    column-gap: 16px;
    border-bottom: 2px solid var(--sub-bg-color);
    padding-bottom: 24px;
    padding-top: 24px;
}
.bank-img {
    border: 1px solid var(--sub-bg-color);
    width: 74px;
    height: 48px;
    border-radius: 8px;
}
.bank-details h2 {
    color: var(--text-color);
    font-family: Satoshi;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
}
.bank-card span:first-child {
    color: var(--7, #00A266);
    font-family: Satoshi;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
}
.bank-card span:last-child {
    color: var(--sub-text-color);
    font-family: Satoshi;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
}
#bank-and-card-main .bank-active-sec,
#payment-main .bank-active-sec,
#transfer-to-bank-main .bank-active-sec {
    margin-left: auto;
}
.bank-active-sec img {
    filter: var(--icon-filter);
}
.bank-card {
    margin-top: 4px;
}
.paid-button2 span img {
    filter: brightness(0) saturate(100%) invert(35%) sepia(96%) saturate(2682%) hue-rotate(239deg) brightness(95%) contrast(100%);
    margin-right: 8px;
}
#bank-and-card-main .verify-number-btn span img {
    filter: brightness(0) saturate(100%) invert(100%) sepia(13%) saturate(0%) hue-rotate(79deg) brightness(101%) contrast(101%);
    margin-right: 8px;
}
.pay-txt1 {
    color: var(--7, #00A266);
    text-align: right;
    font-family: Satoshi;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
}
#payment-main .transfer-first {
    padding-bottom: 16px;
    padding-top: 16px;
}
.transfer-first:first-child {
    padding-top: 0 !important;
}
#payment-main .bank-active-sec img {
    filter: brightness(0) saturate(100%) invert(34%) sepia(31%) saturate(6894%) hue-rotate(144deg) brightness(102%) contrast(101%);
}
#payment-main .bank-details p {
    color: var(--sub-text-color);
    font-family: Satoshi;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    margin-top: 4px;
}
.ApplyPay {
    filter: var(--icon-filter);
}
/************************ 36.Invite friend css ***************************/
.invite-friend-wrapper {
    display: flex;
    align-items: center;
    column-gap: 16px;
}
.friend-invite {
    margin-left: auto;
}
.friend-select input {
    display: none;
}
.custom-radio-sel-friend {
    width: 61px;
    height: 34px;
    border-radius: 4px;
    border: 2px solid #7B51F1;
    cursor: pointer;
    color: var(--2, #7B51F1);
    text-align: center;
    font-family: Satoshi;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 16px;
}
.friend-select input[type="checkbox"]:checked+label {
    border-radius: 4px;
    border: 2px solid var(--2, #7B51F1);
    background: var(--2, #7B51F1);
    color: white;
}
.friend-name {
    color: var(--text-color);
    font-family: Satoshi;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
}
.friend-no a {
    color: var(--sub-text-color);
    font-family: Satoshi;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px;
    margin-top: 4px;
}
.invite-img img {
    border-radius: 50px;
}
.friend-no {
    margin-top: 4px;
}
/************************ 37.Logout popup css ***************************/
.offcanvas.offcanvas-bottom {
    border-radius: 24px 24px 0 0;
    padding: 12px 16px 30px 16px;
    height: auto;
}
.offcanvas.offcanvas-bottom .offcanvas-header {
    padding: 0;
    cursor: pointer;
}
.offcanvas {
    background: var(--primary-color);
}
.logout-main .offcanvas-body {
    padding: 0 !important;
}
.logout-text-pop {
    color: var(--text-color);
    text-align: center;
    font-family: Poppins;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 30px;
}
.sm-txt {
    color: var(--5, #5A5C5E);
    text-align: center;
    font-family: Satoshi;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
}
.logout-button-main {
    gap: 16px;
}
.logout-cancel {
    color: var(--2, #7B51F1);
    text-align: center;
    font-family: Poppins;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    width: 164px;
    height: 48px;
    border-radius: 12px;
    background: var(--14, #F2EEFE);
    border: none !important;
}
.yes-logot {
    border-radius: 12px;
    background: var(--2, #7B51F1);
    color: var(--1, #FFF);
    text-align: center;
    font-family: Poppins;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
}
.offcanvas-backdrop.show {
    opacity: 1 !important;
}
.offcanvas-backdrop {
    background: linear-gradient(180deg, rgba(33, 43, 70, 0.56) 0%, rgba(33, 43, 70, 0.24) 100%) !important;
    backdrop-filter: blur(2px) !important;
}
.not-connect {
    color: var(--4, #FF484D);
}
button.text-reset {
    background: transparent;
    color: var(--text-color) !important;
    padding: 0;
    border: 0;
}
/************************ 38.Personal info css ***************************/
.profile-edit-img {
    text-align: center;
    position: relative;
    width: 120px;
    height: 120px;
    margin: auto;
}
.profile-edit-img img {
    border-radius: 60px;
    max-width: 200px;
    max-height: 200px;
    width: 100%;
    height: auto;
}
.image-input {
    position: absolute;
    bottom: 6px;
    right: 0px;
}
.image-input input {
    display: none;
}
.image-button {
    background: black;
    padding: 8px;
    border-radius: 20px;
    cursor: pointer;
}
.custom-icon-edit {
    position: absolute;
    right: 16px;
    top: 35%;
    cursor: pointer;
    filter: var(--icon-filter);
}
.personal-name {
    border-radius: 12px;
    background: var(--sub-bg-color);
    padding: 8px 16px;
    position: relative;
}
.personal-name label {
    color: var(--2, #7B51F1);
    font-family: Satoshi;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
}
.personal-name input {
    color: var(--text-color);
    font-family: Satoshi;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    border: 0;
    width: 100%;
    background: transparent;
    padding-right: 35px;
}
/************************ 39.Activity css ***************************/
.custom-tab-activity {
    width: 100%;
    width: calc(100% - 30px);
    border-radius: 8px;
    border: 2px solid var(--6, #FFAA01);
    background: var(--1, #FFF);
    position: absolute;
    left: 0;
    z-index: 99;
    margin-top: 25px !important;
    margin: 0 auto;
    right: 0;
}
.custom-tab-activity button {
    width: 33.33%;
    border: 0 !important;
    border-top-left-radius: 0 !important;
    border-top-right-radius: 0 !important;
    color: var(--6, #FFAA01);
    text-align: center;
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
    padding: 12px !important;
    border-right: 1px solid #ffaa01 !important;
}
.custom-tab-activity .nav-link.active {
    background: var(--6, #FFAA01);
    margin-bottom: auto !important;
    color: var(--1, #FFF);
}
.custom-tab-activity button:hover {
    color: var(--6, #FFAA01);
}
.custom-tab-activity button:last-child {
    border-right: 0 !important;
}
.activity-date {
    color: var(--text-color);
    font-family: Poppins;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
}
.all-details-name h3 {
    color: var(--text-color);
    font-family: Satoshi;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
}
.all-details-name p {
    color: var(--sub-text-color);
    font-family: Satoshi;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    margin-top: 4px;
}
.all-content-price p {
    color: var(--7, #00A266);
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
}
.all-details-wrap {
    display: flex;
    justify-content: space-between;
}
/************************ 40.Delete account css ***************************/
.delete-account-top h1 {
    color: var(--text-color);
    font-family: Poppins;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
}
.delete-account-top p {
    color: var(--sub-text-color);
    font-family: Satoshi;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
}
.delete-account-bottom {
    display: flex;
    justify-content: space-between;
    padding: 16px 0;
}
.delete-account-bottom input,
.bank-active-sec input {
    width: 20px;
    height: 20px;
    border: 2px solid var(--text-color);
    outline: 0;
    margin: 0;
}
.delete-select {
    display: flex;
    align-items: center;
}
.delete-account-trapping p {
    color: var(--sub-text-color);
    font-family: Satoshi;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
}
.delete-account-trapping span {
    color: var(--text-color);
}
.delete-account-trapping {
    margin-top: 40px;
}
.delete-txt {
    color: var(--text-color);
    font-family: Satoshi;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
}
/************************ 41.Add new card css ***************************/
.demo-visa {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
    background-position: center;
    background-repeat: no-repeat;
    max-height: 200px;
    height: 100%;
    max-width: 343px;
    width: 100%;
    margin: 0 auto;
    border-radius: 24px;
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 40px;
}
.card-hidden-number {
    color: var(--1, #FFF);
    font-family: Satoshi;
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: 36px;
    letter-spacing: 1.2px;
}
.card-name-jessica {
    color: var(--1, #FFF);
    font-family: Satoshi;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
    letter-spacing: 0.8px;
    text-transform: uppercase;
    width: 100%;
    max-width: 170px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.card-date-cvv {
    color: var(--1, #FFF);
    text-align: right;
    font-family: Satoshi;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
    letter-spacing: 0.8px;
    text-transform: uppercase;
}
.new_password_input .form-item input {
    border-radius: 8px;
    background: #F0F0F0;
    border: navajowhite;
    padding: 12px 16px;
    width: 100%;
    color: #212B46;
    font-family: "Space Grotesk", sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    margin-top: 8px;
}
.info-person {
    color: var(--3, #67696B);
    font-family: "League Spartan", sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    text-transform: uppercase;
}
.new_password_input .form-item input::placeholder {
    color: #212B46;
}
.card-name-jessica-main {
    display: flex;
    justify-content: space-around;
    column-gap: 25px;
}
.ui-datepicker-header a.ui-datepicker-next {
    right: 0;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
    background-repeat: no-repeat;
    background-size: 16px;
    background-position: 50%;
}
.ui-datepicker-header a.ui-datepicker-prev {
    left: 0;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
    background-repeat: no-repeat;
    background-size: 16px;
    background-position: 50%;
    transform: rotate(180deg);
}
.ui-datepicker-header a>span {
    display: none;
}
.card-name-jessica-main-sub {
    display: flex;
    justify-content: space-around;
    column-gap: 25px;
}
#ui-datepicker-div {
    display: none;
    background-color: #fff;
    box-shadow: 0 0.125rem 0.5rem rgba(0, 0, 0, 0.1);
    margin-top: 0.25rem;
    border-radius: 0.5rem;
    padding: 0.5rem;
}
table {
    border-collapse: collapse;
    border-spacing: 0;
}
.ui-datepicker-calendar thead th {
    padding: 0.25rem 0;
    text-align: center;
    font-size: 0.75rem;
    font-weight: 400;
    color: #78909C;
}
.ui-datepicker-calendar tbody td {
    width: 2.5rem;
    text-align: center;
    padding: 0;
}
div#ui-datepicker-div {
    z-index: 500 !important;
}
.ui-datepicker-calendar tbody td a {
    display: block;
    border-radius: 0.25rem;
    line-height: 2rem;
    transition: 0.3s all;
    color: #546E7A;
    font-size: 0.875rem;
    text-decoration: none;
}
.ui-datepicker-calendar tbody td a:hover {
    background: rgb(159 130 240 / 20%);
}
.ui-datepicker-calendar tbody td a.ui-state-active {
    background-color: #7B51F1;
    color: white;
}
.ui-datepicker-header a.ui-corner-all {
    cursor: pointer;
    position: absolute;
    top: 0;
    width: 2rem;
    height: 2rem;
    margin: 0.5rem;
    border-radius: 0.25rem;
    transition: 0.3s all;
}
.ui-datepicker-title {
    text-align: center;
    line-height: 32px;
    margin-bottom: 10px;
    font-size: 16px;
    font-weight: 500;
}
.expiry-date.mt-16 {
    display: flex;
    column-gap: 16px;
}
/************************ 42.Old invoice css ***************************/
.old-invoice-edit {
    margin-left: auto;
}
.old-invoice-edit img {
    filter: brightness(0) saturate(100%) invert(100%) sepia(100%) saturate(0%) hue-rotate(201deg) brightness(105%) contrast(105%);
}
.old-invoice-icon {
    margin-left: 8px;
    width: 20px;
    height: 20px;
}
#old-invoice .verify-number-btn {
    background: var(--primary-color);
    box-shadow: 0px -4px 4px 0px rgba(18, 18, 18, 0.04);
    padding: 16px;
}
.old-invoice-add-content {
    display: flex;
    justify-content: space-between;
}
.old-invoice-add-content span {
    color: var(--text-color);
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
}
.add-item-btn a {
    width: 100%;
    border-radius: 12px;
    border: 2px solid #7B51F1;
    padding: 10px 0;
    margin: auto;
    max-width: 600px;
    color: var(--2, #7B51F1);
    text-align: center;
    font-family: Poppins;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
}
.add-item-btn img {
    padding-right: 8px;
}
.txt2 {
    color: var(--sub-text-color);
    font-family: Poppins;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    margin-top: 8px;
}
.continue-txt {
    color: var(--sub-text-color);
    text-align: center;
    font-family: Satoshi;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
}
.new-invoice-modal-content {
    display: flex;
    column-gap: 12px;
}
.new-invoice-modal-content {
    display: flex;
    column-gap: 12px;
    border-bottom: 2px solid var(--sub-bg-color);
    padding: 16px 0;
}
.new-invoive-pre-bnt {
    margin-left: auto;
}
.new-invoive-pre-bnt img {
    filter: var(--icon-filter);
}
.new-invoice-title p {
    color: var(--text-color);
    font-family: Satoshi;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
}
.new-invoice-modal {
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    max-width: 600px;
}
/************************ 43.Invoice css ***************************/
.custom-tab-invoice button {
    width: 25%;
}
.text-reset-share{
text-align: center;
}
.share-btn {
    filter: var(--icon-filter) !important;
    background: #000;
}
.all-details-name-invoice,
.all-content-price-invoice {
    display: flex;
    justify-content: space-between;
}
.all-details-name-invoice span {
    color: var(--text-color);
    font-family: Satoshi;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
}
.all-content-price-invoice span {
    color: var(--sub-text-color);
    font-family: Satoshi;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    margin-top: 4px;
}
/************************ 44.Tracking css ***************************/
.order-status-sec {
    display: flex;
    align-items: center;
}
.order-status-sec img {
    filter: var(--icon-filter);
}
.order1 {
    position: relative;
}
.order1::before {
    content: "";
    position: absolute;
    width: 100%;
    top: 50%;
    left: 50%;
    border-left: 2px dashed var(--text-color);
    height: 40px;
    margin-top: 14px;
}
.order2 {
    margin-left: 12px;
}
.order-txt1 {
    color: var(--text-color);
    font-family: Satoshi;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px;
}
.order-txt2 {
    color: var(--sub-text-color);
    font-family: Satoshi;
    font-size: 10px;
    font-style: normal;
    font-weight: 700;
    line-height: 14px;
    margin-top: 4px;
}
.track-order-third-sec-full h3 {
    color: var(--text-color);
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
    padding-bottom: 18px;
}
/************************ 45.Preapproved-payment1 css ***************************/
#preapproved-payment1 .send-money {
    width: 25%;
}
#preapproved-payment1 .send-money:last-child p {
    text-overflow: ellipsis;
    overflow: hidden;
    width: 74px;
    white-space: nowrap;
    margin-left: auto;
    margin-right: auto;
}
#preapproved-payment1 .sendmoney-bottom-wrap {
    display: flex;
    justify-content: space-between;
    width: 100%;
    column-gap: 16px;
}
.refund-txt {
    color: var(--text-color);
    text-align: center;
    font-family: Poppins;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 30px;
}
/************************ 46.Spilt css ***************************/
.spilt8-img {
    margin-top: 20px;
}
.spilt3-editIcon {
    filter: var(--icon-filter);
}
.split7-screen-content-top,
.spilt8-img {
    text-align: center;
}
.spilt8-img p {
    color: var(--1, #FFF);
    text-align: center;
    font-family: Satoshi;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px;
}
.spilt8-btn {
    gap: 16px;
    position: fixed;
    width: 100%;
    bottom: 0;
    left: 0;
    right: 0;
}
.split3-btn {
    background: var(--primary-color);
    box-shadow: 0px -4px 4px 0px rgba(18, 18, 18, 0.04);
    padding: 16px;
}
.social-media-content {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 16px;
    max-width: 600px;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
}
.social-media-img {
    text-align: center;
}
.social-media-img p {
    color: var(--text-color);
    text-align: center;
    font-family: Satoshi;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    margin-top: 8px;
}
.split7-screen-content-top h1 {
    color: var(--text-color);
    text-align: center;
    font-family: Poppins;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: 36px;
}
.split7-screen-content-top p {
    color: var(--sub-text-color);
    text-align: center;
    font-family: Satoshi;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
}
#spilt7-main .sendmomey-details,
#spilt6-main .sendmomey-details {
    padding: 12px 0;
}
.split6-screen-content-top h1 {
    color: var(--text-color);
    text-align: center;
    font-family: Poppins;
    font-size: 36px;
    font-style: normal;
    font-weight: 600;
    line-height: 36px;
}
.split6-screen-content-top p {
    color: var(--sub-text-color);
    text-align: center;
    font-family: Satoshi;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    margin-top: 12px;
}
.split3-screen-content {
    display: flex;
    align-items: center;
    column-gap: 16px;
}
.split3-edit {
    margin-left: auto;
    display: flex;
}
.split3-edit span:first-child {
    margin-right: 15px;
}
.split-bill2-top {
    display: flex;
    column-gap: 12px;
    justify-content: space-between;
    overflow-x: scroll;
    margin-left: 16px;
}
.split-bill2-top-wrap {
    position: relative;
}
.spilt-cancel-icon {
    position: absolute;
    right: 0;
    bottom: 0;
}
.spilt-img img {
    border-radius: 50px;
}
::-webkit-scrollbar {
    display: none;
}
.split2-main .split-bill2-content .send-money-contact-tab {
    padding: 0 !important;
}
.doneIocn {
    filter: none;
}
/************************ 47.Transfer-to-bank-success css ***************************/
.transfer-txt h1 {
    color: var(--text-color);
    text-align: center;
    font-family: Poppins;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: 36px;
}
.transfer-txt p {
    color: var(--sub-text-color);
    text-align: center;
    font-family: Satoshi;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
}
.transfer-logo {
    width: 74px;
    height: 48px;
    border: 1px solid #F2EEFE;
    border-radius: 4px;
}
.first-content h2 {
    color: var(--text-color);
    font-family: Satoshi;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
}
.first-content p {
    color: var(--sub-text-color);
    font-family: Satoshi !important;
    font-size: 14px;
    font-style: normal;
    font-weight: 500 !important;
    line-height: 20px;
    margin-top: 4px;
}
.content-details {
    display: flex;
    column-gap: 16px;
    border-bottom: 2px solid var(--sub-bg-color);
    padding-bottom: 16px;
}
.transfer-content-details p {
    color: var(--sub-text-color);
    font-family: Poppins;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
}
#transfer-to-bank-review .sendmomey-details {
    padding-top: 16px !important;
    border-bottom: 2px solid #7B51F1;
}
#transfer-to-bank-review .sendmomey-details:last-child {
    border-bottom: 0;
}
#transfer-to-bank-review .sendmomey-details:first-child {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
}
.estimated-time h2 {
    color: var(--text-color);
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
}
.estimated-time p {
    color: var(--sub-text-color);
    font-family: Satoshi;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
}
.send-money4 h1 {
    color: var(--text-color);
    text-align: center;
    font-family: Poppins;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 30px;
}
/************************ 48.Line chart css ***************************/
.chat-income-sec {
    display: flex;
    column-gap: 16px;
    width: 100%;
}
.chat-income,
.chat-expense {
    width: 50%;
    display: flex;
    padding: 7px 8px;
    height: 56px;
    align-items: center;
    column-gap: 9px;
    border: 2px solid var(--6, #FFAA01);
    border-radius: 8px;
    background: white;
}
.chat-content {
    width: calc(100% - 30px);
    position: absolute;
    left: 0;
    z-index: 99;
    margin-top: 16px !important;
    max-width: 100%;
    margin: 0 auto;
    right: 0;
}
.chat-txt1 {
    color: var(--7, #00A266);
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
}
.chat-txt2 {
    color: var(--sub-text-color);
    font-family: Satoshi;
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: 18px;
}
.week-txt {
    color: var(--sub-text-color);
    font-family: Satoshi;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px
}
.price-txt {
    color: var(--text-color);
    font-family: Satoshi;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
    margin-top: 4px;
}
.date-txt {
    color: var(--sub-text-color);
    font-family: Satoshi;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px;
    margin-top: 4px;
}
.line-chart-data {
    display: flex;
}
.data-details {
    width: 50%;
}
.statistic-first h2 {
    color: var(--text-color);
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
}
.statistic-first p {
    color: var(--sub-text-color);
    font-family: Satoshi;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    margin-top: 4px;
}
.statistic-overview-content {
    display: flex;
    column-gap: 16px;
}
.chat-bottom-space {
    padding-bottom: 110px;
}
.statistic-first {
    width: 60%;
}
.statistic-second {
    width: 40%;
}
.area-chat .custom-select-internet select {
    border-radius: 4px;
    background-color: var(--2, #7B51F1);
    color: var(--1, #FFF);
    font-family: Satoshi;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 16px;
    padding: 12px;
}
.area-chat .arrow-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___}) !important;
}
/************************ 49.Homescreen css ***************************/
p.name {
    color: var(--1, #FFF);
    font-family: Poppins;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 30px;
}
p.balance {
    color: var(--1, #FFF);
    font-family: Satoshi;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
}
.balance-data h1 {
    color: var(--1, #FFF);
    font-family: Poppins;
    font-size: 36px;
    font-style: normal;
    font-weight: 700;
    line-height: 36px;
}
.home-top-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 36px;
}
.homepage-first {
    display: flex;
    justify-content: space-around;
    border-radius: 24px;
    background: var(--6, #FFAA01);
    padding: 16px 0;
}
.first-details p {
    color: var(--1, #FFF);
    text-align: center;
    font-family: Satoshi;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    margin-top: 8px;
}
#homepage .send-money:last-child p,
#homepage .send-money:first-child p {
    text-overflow: ellipsis;
    overflow: hidden;
    width: 74px;
    white-space: nowrap;
    margin-left: auto;
    margin-right: auto;
}
.home-activity-top span:first-child {
    color: var(--text-color);
    font-family: Poppins;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 30px;
}
.home-activity-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.home-activity-bottom-wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.home-first h3 {
    color: var(--text-color);
    font-family: Satoshi;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
}
.home-first p {
    color: var(--sub-text-color);
    font-family: Satoshi;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    margin-top: 4px;
}
.home-second h4 {
    color: var(--7, #00A266);
    text-align: right;
    font-family: Satoshi;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
}
/************************ 50.Bottom tabbar css ***************************/
.bottom-menu-svg-main {
    position: relative;
}
.bottom-menu-svg {
    position: fixed;
    bottom: -40px;
}
.gol3 {
    position: absolute;
    left: 50%;
    top: -10%;
    transform: translateX(-50%);
    width: 80px;
    height: 80px;
    background-color: #000000;
    border-radius: 50%;
    z-index: 99;
}
.add-to-cart-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    align-items: center;
}
.home-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
.bottom-menu-svg-design {
    max-width: 600px;
    height: 160px;
    width: 100%;
    backdrop-filter: blur(12px);
    background: var(--primary-color);
}
.navigation {
    position: fixed;
    bottom: 25px;
    width: 100%;
    padding: 0 32px;
    max-width: 600px;
}
.navigation .listWrap {
    list-style: none;
    display: flex;
    justify-content: space-between;
    width: 100%;
}
.navigation .listWrap li a {
    position: relative;
    display: flex;
    justify-content: center;
}
.navigation .listWrap li:active a .icon,
.navigation .listWrap li.active a .icon {
    filter: brightness(0) saturate(100%) invert(35%) sepia(56%) saturate(1672%) hue-rotate(232deg) brightness(95%) contrast(100%);
    transform: translateY(-10px);
}
.navigation .listWrap li a .icon {
    position: relative;
    display: block;
    text-align: center;
    transition: 0.5s;
    color: #FFF;
}
.icon img {
    filter: var(--icon-filter);
}
#paint0_linear_1_13394 {
    stop-color: #121212;
}
.navigation .listWrap li:active a .text,
.navigation .listWrap li.active a .text {
    opacity: 1;
}
.navigation .listWrap li a .text {
    position: absolute;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #7B51F1;
    transition: 0.5s;
    transform: translateY(20px);
    opacity: 0;
    z-index: 1;
}
/************************ 51.Face recognition css ***************************/
.concentric-circles {
    position: relative;
    width: 300px;
    height: 300px;
    margin-top: 70px;
    margin-left: auto;
    margin-right: auto
}
.circle {
    position: absolute;
    border-radius: 50%;
    animation: pulse 2s infinite;
}
.outer {
    width: 100%;
    height: 100%;
    background-color: rgba(136, 84, 255, 0.1);
    animation-delay: 0s;
}
.middle {
    width: 220px;
    height: 220px;
    background-color: rgba(136, 84, 255, 0.2);
    animation-delay: 0.5s;
}
.inner {
    width: 120px;
    height: 120px;
    background-color: #8854FF;
    animation-delay: 1s;
}
.inner img {
    width: 50%;
    height: 50%;
}
.chart-container {
    width: 100%;
    background: #FFF;
    padding: 10px;
}
.bar-chart-container {
    height: 300px;
    margin: auto;
}
.request-content span:first-child {
    color: var(--sub-text-color);
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
}
.request-content span:last-child {
    color: var(--text-color);
    text-align: right;
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
}
.request-txt {
    color: var(--sub-text-color);
    text-align: center;
    font-family: Satoshi;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    border-bottom: 2px solid var(--sub-bg-color);
    padding-bottom: 16px;
}
.request-btn {
    position: relative;
    padding: 0;
}
.request-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.request-money-modal {
    max-width: 600px;
    margin: auto;
}
/************************ 52.QR code payment css ***************************/
.name-txt {
    color: var(--text-color);
    text-align: center;
    font-family: Poppins;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 30px;
}
.email-txt {
    color: var(--sub-text-color);
    text-align: center;
    font-family: Satoshi;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
}
.qr-price {
    color: var(--text-color);
    text-align: center;
    font-family: Poppins;
    font-size: 36px;
    font-style: normal;
    font-weight: 500;
    line-height: 36px;
}
.qr-code-name input {
    border-radius: 12px;
    background: var(--sub-bg-color);
    color: var(--sub-text-color);
    text-align: center;
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    padding: 12px 24px;
    border: 0;
    width: 230px;
    margin: auto;
    display: flex;
}
.payment-method p {
    color: var(--sub-text-color);
    font-family: Satoshi;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
}
.payment-method {
    padding-top: 50px;
}
.payment-method P {
    color: var(--sub-text-color);
    font-family: Satoshi;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
}
.profile-img-content img {
    border-radius: 80px;
}
.line-scale>div {
    background-color: #7B51F1;
    width: 4px;
    height: 35px;
    border-radius: 2px;
    margin: 2px;
    animation-fill-mode: both;
    display: inline-block;
}
.line-scale>div:nth-child(1) {
    animation: line-scale 1s -0.4s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);
}
.line-scale>div:nth-child(2) {
    animation: line-scale 1s -0.3s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);
}
.line-scale>div:nth-child(3) {
    animation: line-scale 1s -0.2s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);
}
.line-scale>div:nth-child(4) {
    animation: line-scale 1s -0.1s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);
}
.line-scale>div:nth-child(5) {
    animation: line-scale 1s 0s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);
}
.loader {
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}
.overlay1 {
    position: absolute;
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    width: 100%;
    top: 0;
    right: 0;
    height: 100%;
    border-radius: 24px 24px 0px 0px;
    background: rgb(18 18 18 / 80%);
}
.scan1 .fingerprint1 {
    position: relative;
    width: 300px;
    height: 300px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
    background-size: 300px;
    background-repeat: no-repeat;
    background-size: cover;
    background-color: white;
}
.scan1 {
    position: relative;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
    width: 339px;
    height: 339px;
    background-size: 300px;
    background-repeat: no-repeat;
    background-size: cover;
    background-color: white;
    margin-left: auto;
    margin-right: auto;
    margin-top: 70px;
    border-radius: 25px;
}
.scan1 .fingerprint1::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
    background-size: 300px;
    background-repeat: no-repeat;
    background-size: cover;
    animation: animate 4s ease-in-out infinite;
    background: linear-gradient(180deg, rgba(251, 73, 69, 0.00) 0%, rgba(251, 73, 69, 0.60) 100%);
}
.scan1 .fingerprint1::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 4px;
    background: #FB4945;
    border-radius: 8px;
    filter: drop-shadow(0 0 20px #00D061) drop-shadow(0 0 60px #00D061);
    animation: animate_line 4s ease-in-out infinite;
}
/************************ 53.Create new password CSS ***************************/
#create-new-password-main .password-form input {
    padding-right: 50px !important;
}
.password-form .form-floating>.form-control:focus~label {
    color: var(--2, #7B51F1);
    font-family: Satoshi;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
}
.password-form input {
    color: var(--text-color) !important;
    font-family: Satoshi;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    border-radius: 12px;
    background: var(--sub-bg-color);
    border: 2px solid var(--sub-bg-color);
    padding-right: 16px !important;
}
i#eye,
i#eye1 {
    font-size: 20px;
    color: #5A5C5E;
    position: absolute;
    right: 16px;
    top: 35%;
    cursor: pointer;
}
.form-floating>.form-control:not(:placeholder-shown)~label {
    color: #8854FF;
}
.password-form .form-floating>label {
    color: var(--sub-text-color);
    font-family: Satoshi;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
}
.password-form .form-floating>.form-control:focus~label::after {
    background: transparent;
}
.footer-checkbox-input+.footer-chec-txt:before {
    content: "";
    margin-right: 12px;
    display: inline-block;
    vertical-align: text-top;
    width: 22px;
    height: 22px;
    border: 2px solid var(--text-color);
    border-radius: 8px;
}
.footer-checkbox-input {
    position: absolute;
    opacity: 0;
    width: fit-content;
}
.footer-checkbox-input:checked+.footer-chec-txt:after {
    content: "";
    position: absolute;
    left: 6px;
    top: 12px;
    background: white;
    width: 2px;
    height: 2px;
    box-shadow: 2px 0 0 white, 4px 0 0 white, 4px -2px 0 white, 4px -4px 0 white, 4px -6px 0 white, 4px -8px 0 white;
    transform: rotate(45deg);
}
.footer-checkbox-input:checked+.footer-chec-txt:before {
    background: black;
    border: none;
}
.footer-checkbox-input+.footer-chec-txt {
    position: relative;
    cursor: pointer;
    padding: 0;
    color: var(--sub-text-color);
    font-family: Satoshi;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
}
.verify-txt h1 {
    color: var(--text-color);
    text-align: center;
    font-family: Poppins;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: 36px;
}
#empty-notification-main .verify-number-bottom {
    padding-bottom: 30px;
}
/************************ 54.Keyframe Animation ***************************/
@keyframes line-scale {
    0% {
        transform: scaley(1);
    }
    50% {
        transform: scaley(0.4);
    }
    100% {
        transform: scaley(1);
    }
}
@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
@keyframes animate {
    0%,
    100% {
        height: 0%;
    }
    50% {
        height: 100%;
    }
}
@keyframes animate_line {
    0%,
    100% {
        top: 0%;
    }
    50% {
        top: 100%;
    }
}
@keyframes pulse {
    0%,
    100% {
        transform: scale(1);
    }
    50% {
        transform: scale(1.1);
    }
}
.offcanvas-title {
    color: var(--text-color);
}
.btn-close {
    filter: var(--icon-filter);
}
.diffrent-chat-dropdown {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.4s ease, opacity 0.4s ease;
    opacity: 0;
}
.diffrent-chat-dropdown.open {
    max-height: 500px;
    opacity: 1;
}
.pay-bill-img {
    background: #00D061;
}
.upIconsSat {
    transition: transform 0.3s ease;
}
.rotated {
    transform: rotate(180deg);
}
.menu-canvas {
    background: var(--primary-color);
}
/* Idetify Bottom Modal  */
.modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: flex-end;
    z-index: 1000;
}
.photo-modal {
    background: #fff;
    border-radius: 16px 16px 0 0;
    width: 100%;
    max-width: 500px;
    padding: 20px;
    box-shadow: 0 -4px 10px rgba(0, 0, 0, 0.2);
    animation: slideUp 0.3s ease;
}
@keyframes slideUp {
    from {
        transform: translateY(100%);
    }
    to {
        transform: translateY(0);
    }
}`, "",{"version":3,"sources":["webpack://./src/assets/css/style.css"],"names":[],"mappings":"AAAA;;;;;oEAKoE;AACpE;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;kEAsDkE;AAClE;;;oEAGoE;AACpE,mEAAmE;AACnE;IACI,uBAAuB;IACvB,8BAA8B;IAC9B,WAAW;IACX,YAAY;AAChB;AACA;;;IAII,sBAAsB;AAC1B;AACA;;IAEI,aAAa;IACb,qBAAqB;IACrB,eAAe;AACnB;AACA;;;;;;;IAOI,SAAS;IACT,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,cAAc;IACd,YAAY;IACZ,sCAAsC;AAC1C;AACA;IACI,UAAU;IACV,SAAS;AACb;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,UAAU;AACd;AACA;IACI,wBAAwB;IACxB,2BAA2B;AAC/B;AACA;IACI,2BAA2B;IAC3B,6BAA6B;IAC7B,YAAY;AAChB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,mCAAmC;AACvC;AACA;;IAEI,mCAAmC;AACvC;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;IA+BI,gCAAgC;AACpC;AACA;;;;;IAKI,oBAAoB;AACxB;AACA;;;;;;;;;;;;;;;;;;IAkBI,oBAAoB;AACxB;AACA;IACI,sBAAsB;IACtB,4CAAuC;IACvC,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;AACA;;;;;;IAMI,4CAA4C;IAC5C,oBAAoB;AACxB;AACA;;;;IAII,4CAA4C;IAC5C,oBAAoB;AACxB;AACA;;;;;;;;IAQI,4CAA4C;AAChD;AACA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,sCAAsC;IACtC,cAAc;AAClB;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;IAqCI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,8BAA8B;AAClC;AACA,kEAAkE;AAClE;IACI,aAAa;IACb,WAAW;AACf;AACA;;IAEI,kBAAkB;AACtB;AACA;IACI,wBAAwB;IACxB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,wBAAwB;IACxB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA,sEAAsE;AACtE;IACI,6BAA6B;IAC7B,UAAU;IACV,UAAU;IACV,oBAAoB;IACpB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,4BAA4B;IAC5B,6BAA6B;IAC7B,2BAA2B;AAC/B;AACA;IACI,iBAAiB;IACjB,yBAAyB;AAC7B;AACA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,6BAA6B;IAC7B,uBAAuB;IACvB,4CAA4C;IAC5C,iBAAiB;IACjB,aAAa;AACjB;AACA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,aAAa;AACjB;AACA;IACI,eAAe;IACf,WAAW;IACX,OAAO;IACP,SAAS;IACT,sCAAsC;IACtC,UAAU;IACV,aAAa;AACjB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,mBAAmB;IACnB,6BAA6B;IAC7B,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;;;IAGI,kBAAkB;AACtB;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,gBAAgB;AACpB;AACA;IACI,UAAU;IACV,wCAAwC;IACxC,sBAAsB;AAC1B;AACA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,sCAAsC;IACtC,cAAc;AAClB;AACA,0EAA0E;AAC1E;IACI,aAAa;IACb,+BAA+B;IAC/B,kBAAkB;IAClB,cAAc;AAClB;AACA;IACI,qBAAqB;IACrB,oBAAoB;AACxB;AACA;IACI,qBAAqB;IACrB,oBAAoB;AACxB;AACA;IACI,yDAA0D;IAC1D,2BAA2B;IAC3B,sBAAsB;IACtB,4BAA4B;IAC5B,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,eAAe;AACnB;AACA;IACI,mBAAmB;IACnB,0BAA0B;IAC1B,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,qCAAqC;IACrC,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,gCAAgC;IAChC,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,wBAAwB;IACxB,OAAO;IACP,QAAQ;IACR,WAAW;AACf;AACA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,UAAU;IACV,iBAAiB;AACrB;AACA;;IAEI,+BAA+B;IAC/B,WAAW;IACX,qBAAqB;IACrB,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB,UAAU;AACd;AACA;IACI,SAAS;IACT,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,mBAAmB;IACnB,6BAA6B;IAC7B,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,WAAW;AACf;AACA;IACI,eAAe;IACf,WAAW;IACX,OAAO;IACP,SAAS;IACT,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,QAAQ;IACR,+BAA+B;AACnC;AACA;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,wBAAwB;IACxB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA,0EAA0E;AAC1E;IACI,2DAA2C;IAC3C,kBAAkB;IAClB,QAAQ;AACZ;AACA;IACI,qBAAqB;IACrB,oBAAoB;AACxB;AACA;IACI,oBAAoB;IACpB,4BAA4B;AAChC;AACA;IACI,aAAa;AACjB;AACA;IACI,wCAAwC;IACxC,qBAAqB;AACzB;AACA;IACI,kBAAkB;IAClB,2BAA2B;IAC3B,aAAa;IACb,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,sBAAsB;IACtB,qBAAqB;IACrB,uBAAuB;IACvB,0BAA0B;IAC1B,kCAAkC;AACtC;AACA;IACI,4BAA4B;AAChC;AACA;IACI,YAAY;AAChB;AACA;IACI,aAAa;AACjB;AACA;IACI,YAAY;IACZ,uBAAuB;IACvB,WAAW;IACX,kBAAkB;IAClB,4BAA4B;IAC5B,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,wBAAwB;IACxB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,wBAAwB;AAC5B;AACA,0EAA0E;AAC1E;IACI,kBAAkB;IAClB,2BAA2B;IAC3B,aAAa;IACb,aAAa;AACjB;AACA;IACI,0BAA0B;AAC9B;AACA,sFAAsF;AACtF;IACI,gCAAgC;IAChC,gCAAgC;IAChC,gBAAgB;IAChB,2BAA2B;IAC3B,kBAAkB;AACtB;AACA;IACI,yDAA0D;IAC1D,sBAAsB;IACtB,4BAA4B;IAC5B,kBAAkB;IAClB,WAAW;IACX,eAAe;AACnB;AACA;IACI,aAAa;AACjB;AACA;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,qBAAqB;IACrB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,wBAAwB;IACxB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,+BAA+B;AACnC;AACA;IACI,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,mCAAmC;IACnC,0BAA0B;IAC1B,2BAA2B;AAC/B;AACA;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,wBAAwB;AAC5B;AACA;IACI,WAAW;IACX,mBAAmB;IACnB,6BAA6B;IAC7B,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,SAAS;IACT,WAAW;IACX,OAAO;IACP,QAAQ;IACR,eAAe;IACf,oBAAoB;IACpB,gCAAgC;IAChC,UAAU;AACd;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,+BAA+B;IAC/B,gBAAgB;AACpB;AACA,oFAAoF;AACpF;IACI,uBAAuB;IACvB,uBAAuB;IACvB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,UAAU;AACd;AACA;IACI,cAAc;AAClB;AACA;;;IAGI,0BAA0B;AAC9B;AACA;IACI,wCAAwC;AAC5C;AACA;IACI,uBAAuB;IACvB,oBAAoB;IACpB,UAAU;AACd;AACA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;IACX,wBAAwB;IACxB,8BAA8B;IAC9B,mBAAmB;IACnB,gGAAgG;IAChG,0BAA0B;AAC9B;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,gBAAgB;AACpB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,UAAU;AACd;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,gDAAkC;AACtC;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;AAClB;AACA;;IAEI,iBAAiB;AACrB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,wBAAwB;IACxB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,4BAA4B;IAC5B,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,WAAW;IACX,wBAAwB;IACxB,kBAAkB;IAClB,mCAAmC;IACnC,0BAA0B;IAC1B,kBAAkB;IAClB,OAAO;IACP,WAAW;IACX,2BAA2B;IAC3B,cAAc;IACd,QAAQ;AACZ;AACA;IACI,UAAU;IACV,oBAAoB;IACpB,oCAAoC;IACpC,qCAAqC;IACrC,wBAAwB;IACxB,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,wBAAwB;AAC5B;AACA;IACI,6BAA6B;IAC7B,8BAA8B;IAC9B,qBAAqB;AACzB;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,2BAA2B;IAC3B,uCAAuC;AAC3C;AACA;IACI,uBAAuB;IACvB,eAAe;AACnB;AACA;IACI,WAAW;AACf;AACA;IACI,6HAA6H;AACjI;AACA,sEAAsE;AACtE;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;AACA;;IAEI,aAAa;IACb,qCAAqC;IACrC,SAAS;AACb;AACA;;IAEI,gCAAgC;AACpC;AACA;;;IAGI,gCAAgC;AACpC;AACA;IACI,iCAAiC;AACrC;AACA;;IAEI,gCAAgC;AACpC;AACA;;IAEI,iCAAiC;AACrC;AACA;;IAEI,iCAAiC;AACrC;AACA;IACI,gCAAgC;AACpC;AACA;IACI,iCAAiC;AACrC;AACA;IACI,gCAAgC;AACpC;AACA;IACI,+BAA+B;IAC/B,0BAA0B;AAC9B;AACA;IACI,gBAAgB;IAChB,wBAAwB;IACxB,kBAAkB;IAClB,uBAAuB;IACvB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;AACA,iFAAiF;AACjF;IACI,WAAW;IACX,mBAAmB;IACnB,6BAA6B;IAC7B,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,mBAAmB;IACnB,6BAA6B;IAC7B,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,wBAAwB;IACxB,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,WAAW;IACX,OAAO;IACP,QAAQ;IACR,SAAS;IACT,yBAAyB;IACzB,iBAAiB;AACrB;AACA;IACI,qBAAqB;AACzB;AACA,qEAAqE;AACrE;IACI,4BAA4B;AAChC;AACA;;;;IAII,gCAAgC;IAChC,yDAA6C;IAC7C,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,YAAY;AAChB;AACA;IACI,+BAA+B;AACnC;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,4BAA4B;IAC5B,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,kBAAkB;AACtB;AACA;;;;IAII,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,uBAAuB;AAC3B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,mBAAmB;AACvB;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,YAAY;AAChB;AACA;IACI,yBAAyB;AAC7B;AACA,qEAAqE;AACrE;IACI,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,+BAA+B;AACnC;AACA;IACI,mHAAmH;AACvH;AACA;IACI,gCAAgC;AACpC;AACA;IACI,6BAA6B;AACjC;AACA;IACI,4BAA4B;IAC5B,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;AACrB;AACA;IACI,wBAAwB;IACxB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA,iFAAiF;AACjF;IACI,kCAAkC;AACtC;AACA;IACI,+BAA+B;IAC/B,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,aAAa;AACjB;AACA;IACI,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B,cAAc;IACd,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,oEAAsD;IACtD,uCAAuC;IACvC,sCAAsC;AAC1C;AACA;IACI,oEAA0D;IAC1D,uCAAuC;IACvC,sCAAsC;AAC1C;AACA;IACI,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,6BAA6B;AACjC;AACA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;AACA;;IAEI,6HAA6H;AACjI;AACA;IACI,wBAAwB;IACxB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,mBAAmB;IACnB,+BAA+B;IAC/B,kBAAkB;AACtB;AACA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,6BAA6B;IAC7B,aAAa;AACjB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,mBAAmB;IACnB,+BAA+B;IAC/B,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,wBAAwB;IACxB,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,cAAc;IACd,WAAW;IACX,oBAAoB;AACxB;AACA;IACI,+BAA+B;AACnC;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,gCAAgC;AACpC;AACA;IACI,eAAe;IACf,SAAS;IACT,QAAQ;IACR,OAAO;IACP,SAAS;IACT,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,wBAAwB;IACxB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;AACnB;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,kBAAkB;AACtB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,2FAA2F;IAC3F,0BAA0B;AAC9B;AACA;IACI,SAAS;AACb;AACA;IACI,kCAAkC;IAClC,4BAA4B;IAC5B,YAAY;AAChB;AACA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,YAAY;AAChB;AACA,qFAAqF;AACrF;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,oDAAoD;AACxD;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,yDAAqD;IACrD,sBAAsB;IACtB,4BAA4B;IAC5B,2BAA2B;IAC3B,WAAW;IACX,0BAA0B;IAC1B,kBAAkB;IAClB,gCAAgC;IAChC,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;AACpC;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,kBAAkB;IAClB,yDAAsD;IACtD,2BAA2B;IAC3B,4BAA4B;IAC5B,0BAA0B;IAC1B,WAAW;IACX,MAAM;IACN,QAAQ;IACR,YAAY;IACZ,gCAAgC;AACpC;AACA;IACI,yDAA6D;AACjE;AACA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,SAAS;AACb;AACA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;AACrB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,yBAAyB;AAC7B;AACA;IACI,eAAe;IACf,WAAW;IACX,SAAS;IACT,OAAO;IACP,QAAQ;IACR,oBAAoB;AACxB;AACA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,WAAW;IACX,OAAO;IACP,QAAQ;IACR,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;IACpB,SAAS;AACb;AACA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,kBAAkB;AACtB;AACA;;IAEI,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,MAAM;AACV;AACA;IACI,WAAW;IACX,cAAc;IACd,cAAc;IACd,UAAU;IACV,WAAW;IACX,yBAAyB;IACzB,mBAAmB;IAEnB,4DAA4D;AAChE;AACA;IAGI,wBAAwB;AAC5B;AACA;IAGI,wBAAwB;AAC5B;AACA;IAGI,wBAAwB;AAC5B;AACA;IAGI,yBAAyB;AAC7B;AACA;IAGI,yBAAyB;AAC7B;AACA;IAGI,yBAAyB;AAC7B;AACA;IAGI,yBAAyB;AAC7B;AACA;IAGI,yBAAyB;AAC7B;AACA;IAGI,yBAAyB;AAC7B;AACA;IAGI,yBAAyB;AAC7B;AACA;IAGI,yBAAyB;AAC7B;AACA;IAEI,sBAAsB;AAC1B;AACA;IAEI,oBAAoB;AACxB;AACA;IAEI,sBAAsB;AAC1B;AACA;IAEI,sBAAsB;AAC1B;AACA;IAEI,sBAAsB;AAC1B;AACA;IAEI,sBAAsB;AAC1B;AACA;IAEI,sBAAsB;AAC1B;AACA;IAEI,sBAAsB;AAC1B;AACA;IAEI,sBAAsB;AAC1B;AACA;IAEI,sBAAsB;AAC1B;AACA;IAEI,sBAAsB;AAC1B;AACA;IACI;;;QAGI,UAAU;IACd;IACA;QACI,UAAU;IACd;AACJ;AACA,yEAAyE;AACzE;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,oDAAwD;IACxD,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,4BAA4B;IAC5B,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,oDAA4D;IAC5D,sBAAsB;IACtB,4BAA4B;IAC5B,sBAAsB;AAC1B;AACA;IACI,oDAAkE;AACtE;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oDAA4D;IAC5D,sBAAsB;IACtB,4BAA4B;IAC5B,sBAAsB;IACtB,0CAA0C;IAC1C,6HAA6H;AACjI;AACA;IACI,0BAA0B;IAC1B,6BAA6B;IAC7B,4BAA4B;AAChC;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,+CAA+C;AACnD;AACA;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,UAAU;AACd;AACA;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;AACA;;IAEI,qBAAqB;AACzB;AACA;IACI,wBAAwB;IACxB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,WAAW;IACX,SAAS;IACT,OAAO;IACP,kBAAkB;IAClB,gCAAgC;AACpC;AACA,4EAA4E;AAC5E;IACI,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,uBAAuB;IACvB,wBAAwB;IACxB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,WAAW;IACX,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,QAAQ;IACR,UAAU;IACV,eAAe;IACf,YAAY;IACZ,wBAAwB;IACxB,oBAAoB;IACpB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,qCAAqC;IACrC,kBAAkB;AACtB;AACA;;IAEI,eAAe;IACf,QAAQ;IACR,yBAAyB;AAC7B;AACA;IACI,UAAU;AACd;AACA;IACI,6BAA6B;IAC7B,kCAAkC;IAClC,mBAAmB;IACnB,oCAAoC;IACpC,0BAA0B;IAC1B,uBAAuB;AAC3B;AACA;IACI,2BAA2B;IAC3B,kCAAkC;IAClC,oCAAoC;AACxC;AACA;IACI,mCAAmC;AACvC;AACA,gFAAgF;AAChF;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,gCAAgC;AACpC;AACA;IACI,gCAAgC;AACpC;AACA;IACI,gCAAgC;AACpC;AACA;IACI,aAAa;IACb,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,6BAA6B;AACjC;AACA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,wBAAwB;IACxB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,4BAA4B;IAC5B,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,4BAA4B;IAC5B,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,4CAA4C;IAC5C,oBAAoB;AACxB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,wBAAwB;AAC5B;AACA,6EAA6E;AAC7E;IACI,wBAAwB;IACxB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;;IAEI,4BAA4B;IAC5B,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,kBAAkB;AACtB;AACA,kFAAkF;AAClF;IACI,4CAA4C;AAChD;AACA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,4BAA4B;IAC5B,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gCAAgC;IAChC,aAAa;IACb,qCAAqC;AACzC;AACA;IACI,wBAAwB;IACxB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,4BAA4B;IAC5B,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,wBAAwB;IACxB,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;AACA;IACI,mBAAmB;IACnB,mCAAmC;IACnC,gCAAgC;IAChC,aAAa;AACjB;AACA;IACI,WAAW;IACX,4BAA4B;IAC5B,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,qCAAqC;IACrC,SAAS;AACb;AACA;IACI,6DAA6C;IAC7C,+BAA+B;IAC/B,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,UAAU;AACd;AACA,wEAAwE;AACxE;IACI,WAAW;IACX,mBAAmB;IACnB,6BAA6B;IAC7B,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,mBAAmB;IACnB,+BAA+B;IAC/B,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,wBAAwB;IACxB,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,WAAW;IACX,SAAS;IACT,OAAO;IACP,QAAQ;IACR,iBAAiB;IACjB,kBAAkB;IAClB,gCAAgC;IAChC,aAAa;IACb,oBAAoB;IACpB,mDAAmD;AACvD;AACA;IACI,gCAAgC;AACpC;AACA,gEAAgE;AAChE;IACI,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,wBAAwB;IACxB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,wBAAwB;IACxB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,iDAAiC;IACjC,kBAAkB;IAClB,QAAQ;IACR,cAAc;IACd,0BAA0B;IAC1B,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,wBAAwB;IACxB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;;GAEG;AACH;IACI,iDAAkC;AACtC;AACA;IACI,4DAA4C;AAChD;AACA;IACI,2DAA2C;AAC/C;AACA,qEAAqE;AACrE;IACI,cAAc;AAClB;AACA;IACI,WAAW;IACX,aAAa;IACb,wBAAwB;IACxB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,6BAA6B;IAC7B,SAAS;AACb;AACA;IACI,YAAY;AAChB;AACA,uEAAuE;AACvE;IACI,kBAAkB;IAClB,gCAAgC;IAChC,aAAa;IACb,WAAW;IACX,cAAc;IACd,wBAAwB;IACxB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,kBAAkB;AACtB;AACA,iFAAiF;AACjF;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;AACnB;AACA;IACI,wBAAwB;IACxB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,MAAM;IACN,SAAS;IACT,QAAQ;IACR,SAAS;IACT,wCAAwC;IACxC,mBAAmB;IAEnB,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,SAAS;IACT,WAAW;IAEX,gBAAgB;IAChB,mBAAmB;IACnB,2BAA2B;IAC3B,yHAAyH;AAC7H;AACA;IACI,mBAAmB;IACnB,6BAA6B;AACjC;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,UAAU;IACV,QAAQ;IACR,SAAS;AACb;AACA;IACI,wBAAwB;IACxB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA,2EAA2E;AAC3E;IACI,aAAa;IACb,8BAA8B;IAC9B,WAAW;AACf;AACA;IACI,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,UAAU;IACV,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,aAAa;AACjB;AACA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,uBAAuB;IACvB,kBAAkB;AACtB;AACA;IACI,qBAAqB;IACrB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,4CAA4C;IAC5C,oBAAoB;AACxB;AACA;IACI,wBAAwB;IACxB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,+BAA+B;IAC/B,cAAc;AAClB;AACA;IACI,8BAA8B;IAC9B,4BAA4B;AAChC;AACA;IACI,4BAA4B;IAC5B,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;AACtB;AACA;IACI,eAAe;AACnB;AACA;IACI,UAAU;IACV,SAAS;IACT,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,4CAA4C;IAC5C,YAAY;AAChB;AACA;IACI,wBAAwB;IACxB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA,wEAAwE;AACxE;;IAII,gBAAgB;IAChB,SAAS;AACb;AACA;;IAEI,4BAA4B;IAC5B,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,wBAAwB;IACxB,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,mCAAmC;IACnC,gCAAgC;IAChC,mBAAmB;AACvB;AACA;;IAEI,yBAAyB;AAC7B;AACA;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA,wEAAwE;AACxE;IACI,wBAAwB;IACxB,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,qCAAqC;IACrC,gCAAgC;IAChC,wBAAwB;AAC5B;AACA;;;;IAII,0BAA0B;IAC1B,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,QAAQ;AACZ;AACA;IACI,+BAA+B;IAC/B,eAAe;IACf,wBAAwB;IACxB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,4BAA4B;IAC5B,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,MAAM;IACN,SAAS;IACT,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,mCAAmC;AACvC;AACA;IACI,8CAA8C;AAClD;AACA,uEAAuE;AACvE;IACI,wBAAwB;IACxB,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,+BAA+B;IAC/B,aAAa;IACb,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,6BAA6B;IAC7B,WAAW;AACf;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,4CAA4C;IAC5C,oBAAoB;AACxB;AACA;IACI,4BAA4B;IAC5B,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,wBAAwB;IACxB,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,mCAAmC;IACnC,gCAAgC;IAChC,aAAa;AACjB;AACA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;AACA,kEAAkE;AAClE;IACI,WAAW;IACX,YAAY;IACZ,6BAA6B;IAC7B,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,6HAA6H;AACjI;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,yBAAyB;AAC7B;AACA;;IAEI,wBAAwB;IACxB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA,sEAAsE;AACtE;IACI,4BAA4B;IAC5B,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,wBAAwB;IACxB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,UAAU;AACd;AACA;IACI,wBAAwB;IACxB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA,yEAAyE;AACzE;IACI,wBAAwB;IACxB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,wBAAwB;IACxB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,4BAA4B;IAC5B,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,mBAAmB;IACnB,qCAAqC;IACrC,gCAAgC;IAChC,aAAa;AACjB;AACA;IACI,wBAAwB;IACxB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,mBAAmB;IACnB,qCAAqC;IACrC,gCAAgC;IAChC,aAAa;AACjB;AACA;IACI,wBAAwB;IACxB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,4BAA4B;IAC5B,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA,8EAA8E;AAC9E;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA,8EAA8E;AAC9E;IACI,gCAAgC;AACpC;AACA;IACI,wBAAwB;IACxB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,4BAA4B;IAC5B,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,wBAAwB;IACxB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,qBAAqB;AACzB;AACA,6EAA6E;AAC7E;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,4CAA4C;IAC5C,oBAAoB;IACpB,iBAAiB;AACrB;AACA;IACI,qCAAqC;IACrC,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,wBAAwB;IACxB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,wBAAwB;IACxB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,4BAA4B;IAC5B,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;;;IAGI,iBAAiB;AACrB;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,eAAe;AACnB;AACA;IACI,6HAA6H;IAC7H,iBAAiB;AACrB;AACA;IACI,2HAA2H;IAC3H,iBAAiB;AACrB;AACA;IACI,wBAAwB;IACxB,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,oBAAoB;IACpB,iBAAiB;AACrB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,8HAA8H;AAClI;AACA;IACI,4BAA4B;IAC5B,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,0BAA0B;AAC9B;AACA,0EAA0E;AAC1E;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,aAAa;AACjB;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,wBAAwB;IACxB,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,mCAAmC;IACnC,6BAA6B;IAC7B,YAAY;AAChB;AACA;IACI,wBAAwB;IACxB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,4BAA4B;IAC5B,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,eAAe;AACnB;AACA,yEAAyE;AACzE;IACI,4BAA4B;IAC5B,4BAA4B;IAC5B,YAAY;AAChB;AACA;IACI,UAAU;IACV,eAAe;AACnB;AACA;IACI,gCAAgC;AACpC;AACA;IACI,qBAAqB;AACzB;AACA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,SAAS;AACb;AACA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,8BAA8B;IAC9B,uBAAuB;AAC3B;AACA;IACI,mBAAmB;IACnB,6BAA6B;IAC7B,qBAAqB;IACrB,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,sGAAsG;IACtG,qCAAqC;AACzC;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,uBAAuB;IACvB,mCAAmC;IACnC,UAAU;IACV,SAAS;AACb;AACA,0EAA0E;AAC1E;IACI,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,YAAY;AAChB;AACA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;IACX,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;AACd;AACA;IACI,aAAa;AACjB;AACA;IACI,iBAAiB;IACjB,YAAY;IACZ,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,eAAe;IACf,0BAA0B;AAC9B;AACA;IACI,mBAAmB;IACnB,+BAA+B;IAC/B,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,wBAAwB;IACxB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,wBAAwB;IACxB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,SAAS;IACT,WAAW;IACX,uBAAuB;IACvB,mBAAmB;AACvB;AACA,qEAAqE;AACrE;IACI,WAAW;IACX,wBAAwB;IACxB,kBAAkB;IAClB,mCAAmC;IACnC,0BAA0B;IAC1B,kBAAkB;IAClB,OAAO;IACP,WAAW;IACX,2BAA2B;IAC3B,cAAc;IACd,QAAQ;AACZ;AACA;IACI,aAAa;IACb,oBAAoB;IACpB,oCAAoC;IACpC,qCAAqC;IACrC,wBAAwB;IACxB,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,wBAAwB;IACxB,0CAA0C;AAC9C;AACA;IACI,6BAA6B;IAC7B,8BAA8B;IAC9B,qBAAqB;AACzB;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,wBAAwB;IACxB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,wBAAwB;IACxB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,4BAA4B;IAC5B,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,wBAAwB;IACxB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,8BAA8B;AAClC;AACA,2EAA2E;AAC3E;IACI,wBAAwB;IACxB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,4BAA4B;IAC5B,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,eAAe;AACnB;AACA;;IAEI,WAAW;IACX,YAAY;IACZ,mCAAmC;IACnC,UAAU;IACV,SAAS;AACb;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,4BAA4B;IAC5B,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,gBAAgB;AACpB;AACA;IACI,wBAAwB;IACxB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA,yEAAyE;AACzE;IACI,0DAAsD;IACtD,2BAA2B;IAC3B,4BAA4B;IAC5B,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,cAAc;IACd,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;AACA;IACI,qBAAqB;IACrB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;AACzB;AACA;IACI,qBAAqB;IACrB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,yBAAyB;IACzB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,yBAAyB;AAC7B;AACA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,cAAc;IACd,wCAAwC;IACxC,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,wBAAwB;IACxB,yCAAyC;IACzC,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;AAC7B;AACA;IACI,cAAc;AAClB;AACA;IACI,aAAa;IACb,6BAA6B;IAC7B,gBAAgB;AACpB;AACA;IACI,QAAQ;IACR,oDAAgD;IAChD,4BAA4B;IAC5B,qBAAqB;IACrB,wBAAwB;AAC5B;AACA;IACI,OAAO;IACP,oDAAgD;IAChD,4BAA4B;IAC5B,qBAAqB;IACrB,wBAAwB;IACxB,yBAAyB;AAC7B;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;IACb,6BAA6B;IAC7B,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,gDAAgD;IAChD,mBAAmB;IACnB,qBAAqB;IACrB,eAAe;AACnB;AACA;IACI,yBAAyB;IACzB,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,aAAa;IACb,kBAAkB;IAClB,UAAU;AACd;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,cAAc;IACd,sBAAsB;IACtB,iBAAiB;IACjB,oBAAoB;IACpB,cAAc;IACd,mBAAmB;IACnB,qBAAqB;AACzB;AACA;IACI,kCAAkC;AACtC;AACA;IACI,yBAAyB;IACzB,YAAY;AAChB;AACA;IACI,eAAe;IACf,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,YAAY;IACZ,cAAc;IACd,sBAAsB;IACtB,oBAAoB;AACxB;AACA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,gBAAgB;AACpB;AACA,wEAAwE;AACxE;IACI,iBAAiB;AACrB;AACA;IACI,6HAA6H;AACjI;AACA;IACI,gBAAgB;IAChB,WAAW;IACX,YAAY;AAChB;AACA;IACI,gCAAgC;IAChC,mDAAmD;IACnD,aAAa;AACjB;AACA;IACI,aAAa;IACb,8BAA8B;AAClC;AACA;IACI,wBAAwB;IACxB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,wBAAwB;IACxB,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,4BAA4B;IAC5B,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,gBAAgB;IAChB,4CAA4C;IAC5C,eAAe;AACnB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,wBAAwB;IACxB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB;AACA,oEAAoE;AACpE;IACI,UAAU;AACd;AACA;AACA,kBAAkB;AAClB;AACA;IACI,qCAAqC;IACrC,gBAAgB;AACpB;AACA;;IAEI,aAAa;IACb,8BAA8B;AAClC;AACA;IACI,wBAAwB;IACxB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,4BAA4B;IAC5B,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;AACnB;AACA,qEAAqE;AACrE;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,SAAS;IACT,yCAAyC;IACzC,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,wBAAwB;IACxB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,4BAA4B;IAC5B,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,wBAAwB;IACxB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;AACxB;AACA,iFAAiF;AACjF;IACI,UAAU;AACd;AACA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA,kEAAkE;AAClE;IACI,gBAAgB;AACpB;AACA;IACI,0BAA0B;AAC9B;AACA;;IAEI,kBAAkB;AACtB;AACA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,SAAS;IACT,eAAe;IACf,WAAW;IACX,SAAS;IACT,OAAO;IACP,QAAQ;AACZ;AACA;IACI,gCAAgC;IAChC,mDAAmD;IACnD,aAAa;AACjB;AACA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;;IAEI,eAAe;AACnB;AACA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,iBAAiB;IACjB,aAAa;AACjB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,gBAAgB;IAChB,8BAA8B;IAC9B,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;AACb;AACA;IACI,mBAAmB;AACvB;AACA;IACI,aAAa;AACjB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,YAAY;AAChB;AACA,qFAAqF;AACrF;IACI,wBAAwB;IACxB,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;AACtB;AACA;IACI,wBAAwB;IACxB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,4BAA4B;IAC5B,+BAA+B;IAC/B,eAAe;IACf,kBAAkB;IAClB,2BAA2B;IAC3B,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,aAAa;IACb,gBAAgB;IAChB,4CAA4C;IAC5C,oBAAoB;AACxB;AACA;IACI,4BAA4B;IAC5B,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,4BAA4B;IAC5B,gCAAgC;AACpC;AACA;IACI,gBAAgB;AACpB;AACA;IACI,yBAAyB;IACzB,4BAA4B;AAChC;AACA;IACI,wBAAwB;IACxB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,4BAA4B;IAC5B,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA,uEAAuE;AACvE;IACI,aAAa;IACb,gBAAgB;IAChB,WAAW;AACf;AACA;;IAEI,UAAU;IACV,aAAa;IACb,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,mCAAmC;IACnC,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,OAAO;IACP,WAAW;IACX,2BAA2B;IAC3B,eAAe;IACf,cAAc;IACd,QAAQ;AACZ;AACA;IACI,wBAAwB;IACxB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,4BAA4B;IAC5B,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,4BAA4B;IAC5B,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;AACA;IACI,wBAAwB;IACxB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,4BAA4B;IAC5B,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,aAAa;AACjB;AACA;IACI,UAAU;AACd;AACA;IACI,wBAAwB;IACxB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,4BAA4B;IAC5B,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,aAAa;IACb,gBAAgB;AACpB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,mCAAmC;IACnC,qBAAqB;IACrB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;AACjB;AACA;IACI,qEAA0D;AAC9D;AACA,uEAAuE;AACvE;IACI,qBAAqB;IACrB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,qBAAqB;IACrB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,qBAAqB;IACrB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,6BAA6B;IAC7B,eAAe;AACnB;AACA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;AACnB;AACA;;IAEI,uBAAuB;IACvB,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,wBAAwB;IACxB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;AACA;IACI,wBAAwB;IACxB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,4BAA4B;IAC5B,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,wBAAwB;IACxB,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA,0EAA0E;AAC1E;IACI,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,aAAa;AACjB;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;AACpC;AACA;IACI,gBAAgB;IAChB,aAAa;IACb,WAAW;IACX,2BAA2B;IAC3B,gCAAgC;AACpC;AACA;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,aAAa;IACb,8BAA8B;IAC9B,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;AAC3B;AACA;;IAEI,6HAA6H;IAC7H,4BAA4B;AAChC;AACA;IACI,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,mBAAmB;AACvB;AACA;;IAEI,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,2BAA2B;IAC3B,UAAU;IACV,UAAU;AACd;AACA,6EAA6E;AAC7E;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,4BAA4B;AAChC;AACA;IACI,WAAW;IACX,YAAY;IACZ,yCAAyC;IACzC,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,aAAa;IACb,yCAAyC;IACzC,qBAAqB;AACzB;AACA;IACI,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,mBAAmB;AACvB;AACA;IACI,UAAU;IACV,WAAW;AACf;AACA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;AACjB;AACA;IACI,aAAa;IACb,YAAY;AAChB;AACA;IACI,4BAA4B;IAC5B,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,wBAAwB;IACxB,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,4CAA4C;IAC5C,oBAAoB;AACxB;AACA;IACI,kBAAkB;IAClB,UAAU;AACd;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;AACA;IACI,gBAAgB;IAChB,YAAY;AAChB;AACA,4EAA4E;AAC5E;IACI,wBAAwB;IACxB,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,mBAAmB;IACnB,+BAA+B;IAC/B,4BAA4B;IAC5B,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,YAAY;IACZ,aAAa;AACjB;AACA;IACI,4BAA4B;IAC5B,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,4BAA4B;IAC5B,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,yBAAyB;IACzB,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,WAAW;IAEX,yBAAyB;IACzB,qBAAqB;AACzB;AACA;IAEI,2EAA2E;AAC/E;AACA;IAEI,2EAA2E;AAC/E;AACA;IAEI,2EAA2E;AAC/E;AACA;IAEI,2EAA2E;AAC/E;AACA;IAEI,wEAAwE;AAC5E;AACA;IACI,eAAe;IACf,SAAS;IACT,QAAQ;IACR,gCAAgC;AACpC;AACA;IACI,kBAAkB;IAClB,2BAA2B;IAC3B,4BAA4B;IAC5B,0BAA0B;IAC1B,WAAW;IACX,MAAM;IACN,QAAQ;IACR,YAAY;IACZ,gCAAgC;IAChC,+BAA+B;AACnC;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,oDAAsD;IACtD,sBAAsB;IACtB,4BAA4B;IAC5B,sBAAsB;IACtB,uBAAuB;AAC3B;AACA;IACI,kBAAkB;IAClB,0DAA+D;IAC/D,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,4BAA4B;IAC5B,sBAAsB;IACtB,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oDAAsD;IACtD,sBAAsB;IACtB,4BAA4B;IAC5B,sBAAsB;IACtB,0CAA0C;IAC1C,6FAA6F;AACjG;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,mEAAmE;IACnE,+CAA+C;AACnD;AACA,gFAAgF;AAChF;IACI,8BAA8B;AAClC;AACA;IACI,wBAAwB;IACxB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,mCAAmC;IACnC,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,+BAA+B;IAC/B,qCAAqC;IACrC,8BAA8B;AAClC;AACA;;IAEI,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,eAAe;AACnB;AACA;IACI,cAAc;AAClB;AACA;IACI,4BAA4B;IAC5B,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,qBAAqB;IACrB,wBAAwB;IACxB,WAAW;IACX,YAAY;IACZ,mCAAmC;IACnC,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,iBAAiB;IACjB,UAAU;IACV,WAAW;IACX,gHAAgH;IAChH,wBAAwB;AAC5B;AACA;IACI,iBAAiB;IACjB,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,UAAU;IACV,4BAA4B;IAC5B,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,oBAAoB;AACxB;AACA,2EAA2E;AAC3E;IACI;QAEI,oBAAoB;IACxB;IACA;QAEI,sBAAsB;IAC1B;IACA;QAEI,oBAAoB;IACxB;AACJ;AACA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ;AACA;IACI;;QAEI,UAAU;IACd;IACA;QACI,YAAY;IAChB;AACJ;AACA;IACI;;QAEI,OAAO;IACX;IACA;QACI,SAAS;IACb;AACJ;AACA;IACI;;QAEI,mBAAmB;IACvB;IACA;QACI,qBAAqB;IACzB;AACJ;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,aAAa;IACb,gBAAgB;IAChB,mDAAmD;IACnD,UAAU;AACd;AACA;IACI,iBAAiB;IACjB,UAAU;AACd;AACA;IACI,mBAAmB;AACvB;AACA;IACI,+BAA+B;AACnC;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,gCAAgC;AACpC;AACA,0BAA0B;AAC1B;IACI,eAAe;IACf,QAAQ;IACR,8BAA8B;IAC9B,aAAa;IACb,uBAAuB;IACvB,qBAAqB;IACrB,aAAa;AACjB;AACA;IACI,gBAAgB;IAChB,4BAA4B;IAC5B,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,0CAA0C;IAC1C,4BAA4B;AAChC;AACA;IACI;QACI,2BAA2B;IAC/B;IACA;QACI,wBAAwB;IAC5B;AACJ","sourcesContent":["/*------------------------------------------------------------------\nProject: PayFast E-Wallet\nAuthor: The_Krishna     \nLast change: 03/06/2024\nPrimary use:  Online Payment App\n-------------------------------------------------------------------*/\n/*----------------Table of contents Start---------------------------\n1.Default CSS\n2.Splash screen CSS\n3.Onboarding screen CSS\n4.Let you screen CSS\n5.Sign In screen CSS\n6.Sign up screen CSS\n7.Verify phone number screen CSS\n8.Confirm otp CSS\n9.Send money to all screen CSS\n10.Pay Bill  CSS \n11.Send quick response2 CSS\n12.Language CSS\n13.About us CSS\n14.Personal info slider CSS\n15.Reason for using payfast CSS\n16.Finger Print CSS\n17.Forget password CSS\n18.Notification screen CSS\n19.Deactive account CSS\n20.Electricity bill 1 Screen\n21.Paid screen Screen\n22.Faq css\n23.Feedback section css\n24.Contact us css\n25.Notifiaction setting css\n26.Setting screen css\n27.Send money1 css\n28.Send money4 css\n29.Send money css\n30.Taxes css\n31.Marketing css\n32.Data privacy css\n33.Delete deactivate css\n35.Transfer to bank css\n36.Invite friend css\n37.Logout popup css\n38.Personal info css\n39.Activity css\n40.Delete account css\n41.Add new card css\n42.Old invoice css\n43.Invoice css\n44.Tracking css\n45.Preapproved-payment1 css\n46.Spilt css\n47.Transfer-to-bank-success css\n48.Line chart css\n49.Homescreen css\n50.Bottom tabbar css\n51.Face recognition css\n52.QR code payment css\n53.Create new password CSS\n54.Keyframe Animation\n---------Table of contents End-----------------------------------*/\n/*------------------------ [Color codes] ------------------------                  \nBackground:#ffffff,#7B51F1,#F5F5F5   \nContent:#5A5C5E,#121212      \n-------------------------------------------------------------------*/\n/************************ 1.Default CSS ***************************/\nhtml {\n    scroll-behavior: smooth;\n    -webkit-text-size-adjust: 100%;\n    width: 100%;\n    height: 100%;\n}\n*,\n::after,\n::before {\n    -webkit-box-sizing: border-box;\n    box-sizing: border-box;\n}\na:focus,\na {\n    outline: none;\n    text-decoration: none;\n    cursor: pointer;\n}\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np {\n    margin: 0;\n    padding: 0;\n}\nbody {\n    max-width: 600px;\n    margin: 0 auto;\n    height: 100%;\n    background-color: var(--primary-color);\n}\nul {\n    padding: 0;\n    margin: 0;\n}\n.container {\n    padding: 0 16px !important;\n}\nsvg {\n    vertical-align: middle;\n}\ninput {\n    outline-width: 0;\n    outline-offset: 0;\n    outline: 0;\n}\ntextarea {\n    outline-width: 0;\n    outline-offset: 0;\n    outline: 0;\n}\n.nav-link:focus-visible {\n    outline: none !important;\n    box-shadow: none !important;\n}\n.form-control:focus {\n    box-shadow: none !important;\n    background: var(--9, #F5F5F5);\n    border: none;\n}\n.site-content {\n    width: 100%;\n    height: 100%;\n}\n.mt-16 {\n    margin-top: 16px !important;\n}\n.mt-32 {\n    margin-top: 32px !important;\n}\n.mt-24 {\n    margin-top: 24px !important;\n}\n.mt-12 {\n    margin-top: 12px !important;\n}\n.mt-8 {\n    margin-top: 8px !important;\n}\n.color-purple {\n    color: #7B51F1 !important;\n}\n.color-green {\n    color: #00A266 !important;\n}\n.color-black {\n    color: var(--text-color) !important;\n}\n.color-red,\n.red-color {\n    color: var(--8, #FB4945) !important;\n}\n#verify-no-main,\n#notification-allow-main,\n#reason-using-payfast-main,\n#create-new-pin-main,\n#forget-password-main,\n#confirm-otp-main,\n#create-new-password-main,\n#send-money1,\n#delete-deactivate-main,\n#feedback-main,\n#personal-info,\n#add-new-card,\n#bank-and-card-main,\n#old-invoice,\n#add-new-item,\n#tracking-main,\n#preapproved-refund,\n#spilt8-main,\n#spilt7-main,\n#spilt6-main,\n#spilt5-main,\n#spilt4-main,\n#spilt3-main,\n#electricity1,\n#internet1,\n#transfer-to-bank-success,\n#transfer-to-bank-review,\n#send-money-successfull,\n#send-money-review,\n#Qrcode-main,\n#transfer-to-bank-main {\n    padding-bottom: 100px !important;\n}\n#deactive-main,\n#payment-main,\n#add-tax-main,\n#delete-account,\n#activity-main .favourite-list {\n    padding-bottom: 80px;\n}\n#invite-friend-main,\n#contact-us-main,\n#about-us,\n#data-privacy,\n#faq-main,\n#notification-setting,\n#language-screen,\n#currency-page,\n#security-main,\n#automatic-payment,\n#customer-main,\n#setting-main,\n#taxes-main,\n#request-payment,\n#send-money-main,\n#preapproved-payment1,\n.split2-main,\n#pay-bill {\n    padding-bottom: 20px;\n}\n@font-face {\n    font-family: \"Satoshi\";\n    src: url('../fonts/Satoshi-Medium.ttf');\n    font-weight: 500;\n    font-display: swap;\n    font-style: normal;\n}\n.split6-screen-content-top,\n#old-invoice .feedback-form,\n.send-money4-top,\n.boder-bottom-activity,\n.chart-border,\n.border-main {\n    border-bottom: 2px solid var(--sub-bg-color);\n    padding-bottom: 24px;\n}\n.delete-content,\n.marketing-content,\n.about-us-screen-full,\n.boder-top {\n    border-bottom: 1px solid var(--sub-bg-color);\n    padding-bottom: 24px;\n}\n.change-lan-sec,\n.delete-account-bottom,\n.setting-center-border,\n.send-money-contact-tab.setting-border,\n.notification-option-wrap,\n#reason-using-payfast-main .change-lan-sec:last-child,\n.photo-content-details a,\n.Char-content {\n    border-bottom: 1px solid var(--sub-bg-color);\n}\n.loader-mask-splash {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: var(--primary-color);\n    z-index: 99999;\n}\n.flash-btn,\n.upload-id-button-content,\n#loader,\n.mobile-message-main,\n.notification-icon-img,\n.paid-button1 a,\n.paid-button2 a,\n.contact-us-mobile-btn,\n.notification-option-switch,\n.setting-icon,\n.contact-icon,\n.tax-plus-btn,\n.bank-img,\n.custom-radio-sel-friend,\n.logout-button-main,\n.add-item-btn a,\n.spilt8-btn,\n.transfer-logo,\n.pie-chart .chart-container,\n.concentric-circles,\n.circle,\n.scan1,\n#splash-screen-page,\n.slider-sec-btn a,\n.back-btn,\n.form-sign-in-password-btn a,\n.otp-section,\n.verify-number-btn a,\n.pay-bill-img,\n.allow-btn a,\n.done-btn a,\n.shape,\n.select-img,\n.select-sec,\n.plus-id-btn a,\n.plus-id-btn,\n.verify-id-btn a {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.bg-green {\n    background: #00A266 !important;\n}\n/************************ 2.Splash CSS ***************************/\n#splash-screen-page {\n    height: 100vh;\n    width: 100%;\n}\n.splash-screen-content,\n.profile-img-content {\n    text-align: center;\n}\n.payfast-txt {\n    color: var(--text-color);\n    font-family: Poppins;\n    font-size: 64px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 60px;\n}\n.payfast-txt span {\n    color: var(--2, #7B51F1);\n    font-weight: 700;\n    line-height: 60px;\n}\n.payfast-title {\n    color: var(--sub-text-color);\n    text-align: center;\n    font-family: Satoshi;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n}\n/************************ 3.Onboarding CSS ***************************/\n.custom-slider-btn {\n    position: relative !important;\n    z-index: 2;\n    padding: 0;\n    margin: 0 !important;\n    list-style: none;\n    height: fit-content;\n    width: fit-content;\n    margin-left: auto !important;\n    margin-right: auto !important;\n    margin-top: 40px !important;\n}\n.onboarding-slider .carousel-indicators [data-bs-target] {\n    margin-right: 8px;\n    margin-left: 0 !important;\n}\n.custom-slider-dots {\n    width: 12px !important;\n    height: 12px !important;\n    border-radius: 8px !important;\n    border: none !important;\n    background: var(--sub-text-color) !important;\n    margin-right: 8px;\n    opacity: 0.24;\n}\n.Onboarding-Screen-1 {\n    position: relative;\n    margin-top: 50px;\n}\n.Onboarding-Screen-1-full {\n    position: relative;\n    height: 100vh;\n}\n.slider-sec-btn {\n    position: fixed;\n    width: 100%;\n    left: 0;\n    bottom: 0;\n    background-color: var(--primary-color);\n    z-index: 5;\n    padding: 16px;\n}\n.onboarding-slider {\n    padding-bottom: 100px;\n}\n.slider-sec-btn a {\n    width: 100%;\n    border-radius: 12px;\n    background: var(--2, #7B51F1);\n    padding: 12px 0;\n    margin: auto;\n    max-width: 600px;\n    color: var(--1, #FFF);\n    text-align: center;\n    font-family: Poppins;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n}\n.slider-txt h2 {\n    color: var(--text-color);\n    text-align: center;\n    font-family: Poppins;\n    font-size: 30px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 40px;\n}\n.slider-txt p {\n    color: var(--sub-text-color);\n    text-align: center;\n    font-family: Satoshi;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n}\n.slider-img,\n.verify-number-img,\n.otp-resend {\n    text-align: center;\n}\n.onboarding-slider .carousel-item {\n    transition: none !important;\n}\n.slider-txt {\n    margin-top: 70px;\n}\n.custom-slider-dots.active {\n    opacity: 1;\n    background: var(--text-color) !important;\n    width: 40px !important;\n}\n.loader-mask {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: var(--primary-color);\n    z-index: 99999;\n}\n/************************ 4.Let you screen CSS ***************************/\n.let-you-page-main {\n    height: 100vh;\n    background: var(--sub-bg-color);\n    position: relative;\n    overflow: auto;\n}\n#let-you-main {\n    padding-bottom: 100px;\n    margin-bottom: 180px;\n}\n#sign-up-main {\n    padding-bottom: 150px;\n    margin-bottom: 250px;\n}\n.let-you-top {\n    background-image: url(../images/let-you-screen/bg-img.png);\n    background-position: center;\n    background-size: cover;\n    background-repeat: no-repeat;\n    height: 375px;\n    position: relative;\n    width: 100%;\n    max-width: 100%;\n}\n.payfast-img_main {\n    border-radius: 24px;\n    background: var(--1, #FFF);\n    width: 120px;\n    height: 120px;\n    padding: 16px 20px;\n    margin-left: auto;\n    margin-right: auto;\n    margin-top: 20px;\n    text-align: center;\n}\n.back-btn {\n    border: 1px solid #ffffff;\n    height: 36px;\n    width: 36px;\n    border-radius: 8px;\n}\n.let-you-top-wrap {\n    padding-top: 30px;\n}\n.icons_main a {\n    border: 2px solid var(--sub-bg-color);\n    width: 48px;\n    height: 48px;\n    border-radius: 8px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.apple {\n    filter: var(--icon-filter);\n}\n.icons_main {\n    display: flex;\n    justify-content: center;\n    column-gap: 24px;\n}\n.lets_you_in_box {\n    border-radius: 24px;\n    background: var(--primary-color);\n    padding: 32px 16px;\n    margin: 0 16px;\n    position: absolute;\n    width: calc(100% - 30px);\n    left: 0;\n    right: 0;\n    top: -118px;\n}\n.lets_you_in_text {\n    color: var(--text-color);\n    text-align: center;\n    font-family: Poppins;\n    font-size: 24px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 36px;\n}\n.or-section p {\n    color: var(--sub-text-color);\n    text-align: center;\n    font-family: Satoshi;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n    overflow: hidden;\n}\n.or-section p:before {\n    right: 8px;\n    margin-left: -50%;\n}\n.or-section p:before,\n.or-section p:after {\n    background: var(--sub-bg-color);\n    content: \"\";\n    display: inline-block;\n    height: 2px;\n    position: relative;\n    vertical-align: middle;\n    width: 50%;\n}\n.or-section p:after {\n    left: 8px;\n    margin-right: -50%;\n}\n.form-sign-in-password-btn a {\n    width: 100%;\n    border-radius: 12px;\n    background: var(--2, #7B51F1);\n    padding: 12px 0;\n    margin: auto;\n    max-width: 600px;\n    color: var(--1, #FFF);\n    text-align: center;\n    font-family: Poppins;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n}\n.let-you-social-sec {\n    position: relative;\n    width: 100%;\n}\n#let-you-footer {\n    position: fixed;\n    width: 100%;\n    left: 0;\n    bottom: 0;\n    padding: 16px;\n    z-index: 99;\n    max-width: 600px;\n    margin: 0 auto;\n    right: 0;\n    background: var(--sub-bg-color);\n}\n.block-footer p {\n    color: var(--sub-text-color);\n    text-align: center;\n    font-family: Satoshi;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n}\n.block-footer a {\n    color: var(--text-color);\n    font-family: Satoshi;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 24px;\n}\n/************************ 5.Sign In screen CSS ***************************/\n.iti__arrow:before {\n    content: url(../svg/up-icon.svg) !important;\n    position: absolute;\n    top: 0px;\n}\n#sign-in-main {\n    padding-bottom: 120px;\n    margin-bottom: 220px;\n}\n.iti__arrow {\n    border: 0 !important;\n    margin-left: 12px !important;\n}\n.iti__selected-dial-code {\n    display: none;\n}\n.iti--separate-dial-code .iti__selected-flag {\n    background-color: transparent !important;\n    padding: 0 !important;\n}\n.mobile-form {\n    border-radius: 8px;\n    background: var(--input-bg);\n    padding: 11px;\n    display: flex;\n    align-items: center;\n}\n.ReactFlagsSelect-module_selectBtn__19wW7 {\n    width: 70px !important;\n    padding: 0 !important;\n    border: none !important;\n    font-size: 20px !important;\n    justify-content: center !important;\n}\n.ReactFlagsSelect-module_flagsSelect__2pfa2 {\n    padding-bottom: 0 !important;\n}\n.ReactFlagsSelect-module_selectOptions__3LNBJ {\n    width: 320px;\n}\n.ReactFlagsSelect-module_selectValue__152eS .ReactFlagsSelect-module_label__27pw9 {\n    display: none;\n}\n.sign-in-custom-input {\n    border: none;\n    background: transparent;\n    width: 100%;\n    padding-left: 12px;\n    color: var(--sub-text-color);\n    font-family: Satoshi;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n}\n.sign-in-custom-input::placeholder {\n    color: var(--5, #5A5C5E);\n    font-family: Satoshi;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n}\n#mobile_code {\n    padding-right: 0;\n}\n.iti {\n    display: flex !important;\n}\n/************************ 6.Sign up screen CSS ***************************/\n.form-details-sign-in {\n    border-radius: 8px;\n    background: var(--input-bg);\n    padding: 11px;\n    display: flex;\n}\n.form-details-sign-in span img {\n    filter: var(--icon-filter);\n}\n/************************ 7.Verify phone number screen CSS ***************************/\n.verify-number-bottom {\n    border-radius: 24px 24px 0px 0px;\n    background: var(--primary-color);\n    margin-top: 20px;\n    padding: 16px 16px 0px 16px;\n    position: relative;\n}\n.verify-number-main {\n    background-image: url(../images/let-you-screen/bg-img.png);\n    background-size: cover;\n    background-repeat: no-repeat;\n    position: relative;\n    width: 100%;\n    max-width: 100%;\n}\ndiv#upload-id-page {\n    height: 100vh;\n}\n.verify-number-top-content {\n    padding-top: 30px;\n    display: flex;\n    align-items: center;\n    column-gap: 12px;\n}\n.header-title p {\n    color: var(--1, #FFF);\n    font-family: Poppins;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n}\n.verify-txt p {\n    color: var(--sub-text-color);\n    text-align: center;\n    font-family: Satoshi;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n}\n.otp-section input {\n    width: 60px;\n    height: 60px;\n    text-align: center;\n    padding: 10px;\n    color: var(--text-color);\n    font-family: Satoshi;\n    font-size: 24px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 32px;\n    border-radius: 30px;\n    background: var(--sub-bg-color);\n}\n.otp-section {\n    column-gap: 11px;\n}\n.otp-section input:focus {\n    border-radius: 30px;\n    border: 2px solid var(--2, #7B51F1);\n    background: var(--1, #FFF);\n    box-shadow: none !important;\n}\n.resend-txt1 {\n    color: var(--sub-text-color);\n    text-align: center;\n    font-family: Satoshi;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n}\n.resend-txt2 {\n    font-family: Satoshi;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 24px;\n    color: var(--text-color);\n}\n.verify-number-btn a {\n    width: 100%;\n    border-radius: 12px;\n    background: var(--2, #7B51F1);\n    padding: 12px 0;\n    margin: auto;\n    max-width: 600px;\n    color: var(--1, #FFF);\n    text-align: center;\n    font-family: Poppins;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n}\n.verify-number-btn {\n    position: fixed;\n    bottom: 0;\n    width: 100%;\n    left: 0;\n    right: 0;\n    padding: 0 16px;\n    padding-bottom: 20px;\n    background: var(--primary-color);\n    z-index: 2;\n}\n.resend-txt2 a {\n    color: var(--text-color);\n}\n.form-control:focus {\n    background: var(--sub-bg-color);\n    box-shadow: none;\n}\n/************************ 9.Send money to all screen CSS ***************************/\n.search-text {\n    background: transparent;\n    color: white !important;\n    font-family: Satoshi;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n    border: 0 !important;\n    padding: 0;\n}\n.star-favourite a {\n    display: block;\n}\n.star-favourite span img,\n.upIconsSat,\n.star-favourite img {\n    filter: var(--icon-filter);\n}\n.search-text::placeholder {\n    color: rgb(255 255 255 / 64%) !important;\n}\n.search-icon {\n    background: transparent;\n    border: 0 !important;\n    padding: 0;\n}\n.contact-searchbar {\n    border: 1px solid #ffffff;\n    position: relative;\n    display: flex;\n    align-items: center;\n    flex-wrap: nowrap;\n    width: 100%;\n    padding: 15px !important;\n    justify-content: space-between;\n    border-radius: 16px;\n    background: linear-gradient(92deg, rgba(255, 255, 255, 0.40) 0%, rgba(255, 255, 255, 0.24) 100%);\n    backdrop-filter: blur(4px);\n}\n.seach-bar .form-control:focus {\n    background: transparent;\n}\n.contact-search {\n    margin-top: 20px;\n}\n.voice-icon {\n    text-align: center;\n}\n.seach-bar {\n    width: 80%;\n}\n.item-bookmark img {\n    filter: var(--icon-filter);\n}\n.item-bookmark.active {\n    content: url(../svg/fill-star.svg);\n}\n.send-money-contact-tab {\n    display: flex;\n    align-items: center;\n    column-gap: 16px;\n    padding: 8px 0;\n}\n.contact-star,\n#Qrcode-main .bank-active-sec {\n    margin-left: auto;\n}\n.contact-profile img {\n    border-radius: 50px;\n}\n.contact-details h3 {\n    color: var(--text-color);\n    font-family: Satoshi;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 24px;\n}\n.contact-details h4 {\n    color: var(--sub-text-color);\n    font-family: Satoshi;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 18px;\n    margin-top: 4px;\n}\n.custom-tab-contact {\n    width: 100%;\n    width: calc(100% - 30px);\n    border-radius: 8px;\n    border: 2px solid var(--6, #FFAA01);\n    background: var(--1, #FFF);\n    position: absolute;\n    left: 0;\n    z-index: 99;\n    margin-top: 25px !important;\n    margin: 0 auto;\n    right: 0;\n}\n.custom-tab-contact button {\n    width: 50%;\n    border: 0 !important;\n    border-top-left-radius: 0 !important;\n    border-top-right-radius: 0 !important;\n    color: var(--6, #FFAA01);\n    text-align: center;\n    font-family: Poppins;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 24px;\n    padding: 12px !important;\n}\n.custom-tab-contact .nav-link.active {\n    background: var(--6, #FFAA01);\n    margin-bottom: auto !important;\n    color: var(--1, #FFF);\n}\n.custom-tab-contact button:hover {\n    color: var(--6, #FFAA01);\n}\n#send-money-contact {\n    margin-top: 40px !important;\n    padding: 60px 16px 16px 16px !important;\n}\n#subscription-main .contact-searchbar {\n    justify-content: normal;\n    column-gap: 8px;\n}\n#subscription-main .seach-bar {\n    width: 100%;\n}\n.purple-edit-icon {\n    filter: brightness(0) saturate(100%) invert(29%) sepia(61%) saturate(1820%) hue-rotate(235deg) brightness(111%) contrast(91%);\n}\n/************************ 10.Pay Bill  CSS ***************************/\n.pay-bill-img {\n    width: 74px;\n    height: 74px;\n    border-radius: 37px;\n}\n.pay-bill-sec,\n.about-us-icon-wrapper {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 24px;\n}\n.pay-bill-img.bg-1,\n.pay-bill-img.bg-9 {\n    background: rgb(255 170 1 / 12%);\n}\n.pay-bill-img.bg-2,\n.pay-bill-img.bg-12,\n.pay-bill-img.bg-15 {\n    background: rgb(251 73 69 / 12%);\n}\n.pay-bill-img.bg-3 {\n    background: rgb(34 211 238 / 12%);\n}\n.pay-bill-img.bg-4,\n.pay-bill-img.bg-10 {\n    background: rgb(0 162 102 / 12%);\n}\n.pay-bill-img.bg-5,\n.pay-bill-img.bg-13 {\n    background: rgb(123 81 241 / 12%);\n}\n.pay-bill-img.bg-6,\n.pay-bill-img.bg-11 {\n    background: rgb(249 115 22 / 12%);\n}\n.pay-bill-img.bg-7 {\n    background: rgb(0 162 102 / 12%);\n}\n.pay-bill-img.bg-8 {\n    background: rgb(132 204 22 / 12%);\n}\n.pay-bill-img.bg-14 {\n    background: rgb(6 182 212 / 12%);\n}\n.pay-bill-img.bg-16 {\n    background: rgb(18 18 18 / 12%);\n    filter: var(--icon-filter);\n}\n.pay-bill-name {\n    overflow: hidden;\n    color: var(--text-color);\n    text-align: center;\n    text-overflow: ellipsis;\n    font-family: Satoshi;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 20px;\n    margin-top: 8px;\n}\n.pay-bill-sec a {\n    margin-right: auto;\n    margin-left: auto;\n}\n/************************ 11.Send quick response2 CSS ***************************/\n.allow-btn a {\n    width: 100%;\n    border-radius: 12px;\n    background: var(--2, #7B51F1);\n    padding: 15px 0;\n    margin: auto;\n    max-width: 600px;\n    color: var(--1, #FFF);\n    text-align: center;\n    font-family: Poppins;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n}\n.done-btn a {\n    width: 100%;\n    border-radius: 12px;\n    background: var(--2, #F2EEFE);\n    padding: 15px 0;\n    margin: auto;\n    max-width: 600px;\n    color: var(--1, #7B51F1);\n    text-align: center;\n    font-family: Poppins;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n}\n.bottom-btn {\n    position: fixed;\n    width: 100%;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    padding: 0 16px 16px 16px;\n    background: white;\n}\n#send-response2 {\n    padding-bottom: 160px;\n}\n/************************ 12.Language CSS ***************************/\n.change-lan-sec {\n    padding: 16px 0px !important;\n}\n#currency-page .form-check-input.custom-input:checked,\n#language-screen .form-check-input.custom-input:checked,\n#spilt8-main .form-check-input.custom-input:checked,\n#reason-using-payfast-main .form-check-input.custom-input:checked {\n    background: var(--primary-color);\n    background-image: url(../svg/purple-tick.svg);\n    background-size: cover;\n    width: 20px;\n    height: 20px;\n    border: none;\n}\n.form-check-input {\n    --bs-form-check-bg: transparent;\n}\n.form-check-label.custom-lable {\n    display: flex;\n    align-items: center;\n    color: var(--sub-text-color);\n    font-family: Satoshi;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n}\n.custom-lable span {\n    padding-right: 8px;\n}\n#currency-page .form-check-input.custom-input,\n#language-screen .form-check-input.custom-input,\n#spilt8-main .form-check-input.custom-input,\n#reason-using-payfast-main .form-check-input.custom-input {\n    width: 18px;\n    height: 18px;\n    border-radius: 4px;\n    border: 2px solid #7B51F1;\n    float: right !important;\n}\n.language-sel .curr-icon {\n    filter: var(--icon-filter);\n}\n.change-lan-sec:last-child {\n    border: navajowhite;\n}\n.form-check-input:focus {\n    box-shadow: none !important;\n}\n.language-sel .form-check-label.custom-lable {\n    color: var(--text-color);\n}\n.form-check-input:active {\n    filter: none;\n}\n.first-pt-0 {\n    padding-top: 0 !important;\n}\n/************************ 13.About us CSS ***************************/\n.social-detail-about {\n    margin-left: auto;\n    margin-right: auto;\n}\n.shape {\n    width: 74px;\n    height: 74px;\n    border-radius: 37px;\n    cursor: pointer;\n}\n.facebook-bg {\n    background: rgb(59 89 153 / 8%);\n}\n.instragram-bg {\n    background: linear-gradient(225deg, rgb(110 62 255 / 7%) 0%, rgb(224 49 77 / 7%) 47.92%, rgb(254 215 84 / 7%) 100%);\n}\n.twitter-bg {\n    background: rgb(29 161 242 / 7%);\n}\n.youtube-bg {\n    background: rgb(255 0 0 / 7%);\n}\n.privacy-txt p {\n    color: var(--sub-text-color);\n    font-family: Satoshi;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n}\n.pt-10 {\n    padding-top: 10px;\n}\np.about-social-txt {\n    color: var(--sub-text-color);\n    text-align: center;\n    font-family: Satoshi;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 16px;\n    padding-top: 12px;\n}\n.social-txt {\n    color: var(--text-color);\n    font-family: Poppins;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 24px;\n}\n/************************ 14.Personal info slider CSS ***************************/\n.form-floating>.form-control:not(:placeholder-shown)~label::after {\n    background: transparent !important;\n}\n#msform .progress {\n    background: var(--sub-bg-color);\n    width: 140px;\n    height: 8px;\n    margin-left: auto;\n    margin-right: auto;\n}\n#msform .progress-bar {\n    background: #7B51F1;\n}\n#msform {\n    text-align: center;\n    position: relative;\n    margin-bottom: 0;\n}\n#msform fieldset:not(:first-of-type) {\n    display: none;\n}\n#msform .action-button {\n    width: 48px;\n    height: 48px;\n    background: var(--sub-bg-color);\n    border: 0 none;\n    border-radius: 12px;\n    cursor: pointer;\n    padding: 10px 5px;\n    float: right;\n    position: relative;\n    margin-top: 24px;\n}\n.input-icon-next {\n    background-image: url(../svg/next-icon.svg) !important;\n    background-repeat: no-repeat !important;\n    background-position: center !important;\n}\n.input-icon-previous {\n    background-image: url(../svg/previous-icon.svg) !important;\n    background-repeat: no-repeat !important;\n    background-position: center !important;\n}\n#msform .action-button-previous {\n    width: 48px;\n    height: 48px;\n    background: var(--sub-bg-color);\n    border: 0 none;\n    border-radius: 8px;\n    cursor: pointer;\n    padding: 10px 5px;\n    float: left;\n    position: relative;\n    margin-top: 24px;\n}\n.home-address-heading h2 {\n    color: var(--text-color);\n    text-align: center;\n    font-family: Poppins;\n    font-size: 24px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 36px;\n}\n.home-address-heading p {\n    color: var(--sub-text-color);\n    text-align: center;\n    font-family: Satoshi;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n    margin-top: 12px;\n}\n#personal-info-slider {\n    padding: 16px !important;\n}\n#file-input {\n    display: none;\n}\n#files {\n    display: none;\n}\n.select-img {\n    width: 48px;\n    height: 48px;\n    border-radius: 12px;\n    background: var(--2, #7B51F1);\n}\n.select-sec {\n    column-gap: 12px;\n    margin-top: 24px;\n}\n.select-img img,\n.plus-id-btn img {\n    filter: brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(7472%) hue-rotate(114deg) brightness(110%) contrast(98%);\n}\n.select-txt {\n    color: var(--2, #7B51F1);\n    font-family: Satoshi;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n}\n.goverment-id-sec {\n    border-radius: 12px;\n    background: var(--sub-bg-color);\n    padding: 24px 16px;\n}\n.goverment-id-sec h3 {\n    color: var(--text-color);\n    text-align: center;\n    font-family: Satoshi;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 24px;\n    margin-bottom: 8px;\n}\n.goverment-id-sec p {\n    color: var(--sub-text-color);\n    text-align: center;\n    font-family: Satoshi;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 20px;\n}\n.plus-id-btn a {\n    width: 48px;\n    height: 48px;\n    border-radius: 12px;\n    background: var(--2, #7B51F1);\n    padding: 12px;\n}\n.plus-id-btn {\n    column-gap: 12px;\n}\n.verify-id-btn a {\n    width: 100%;\n    border-radius: 12px;\n    background: var(--sub-bg-color);\n    padding: 15px 0;\n    margin: auto;\n    max-width: 600px;\n    color: var(--2, #7B51F1);\n    text-align: center;\n    font-family: Poppins;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n}\n.verify-id-btn {\n    pointer-events: none;\n    cursor: default;\n    position: absolute;\n    width: 100%;\n    bottom: -100px;\n    clear: both;\n    padding-bottom: 16px;\n}\n.verify-my-btn {\n    pointer-events: auto !important;\n}\n.finger-modal-content .modal-body {\n    padding: 12px 16px;\n    bottom: 0;\n    background: var(--primary-color);\n}\n.photo-custom-modal .modal-dialog {\n    position: fixed;\n    top: auto;\n    right: 0;\n    left: 0;\n    bottom: 0;\n    width: 100%;\n    margin-left: auto;\n    margin-right: auto;\n    margin-bottom: 0;\n}\n.photo-type p {\n    color: var(--sub-text-color);\n    text-align: center;\n    font-family: Satoshi;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 20px;\n}\n.photo-content-details a div:nth-child(1) {\n    color: var(--text-color);\n    font-family: Satoshi;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n}\n.photo-content-details a {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 16px 0;\n}\n.photo-content-details img {\n    filter: var(--icon-filter);\n}\n.card-btn {\n    text-align: center;\n}\n.photo-content-details:last-child {\n    border-bottom: none;\n}\n#photo-id-modal {\n    background: linear-gradient(180deg, rgba(18, 18, 18, 0.56) 0%, rgba(18, 18, 18, 0.24) 100%);\n    backdrop-filter: blur(2px);\n}\n.finger-modal-content {\n    border: 0;\n}\n.photo-custom-modal .modal.fade .modal-dialog {\n    transition: transform .3s ease-out;\n    transform: translate(0, 0px);\n    margin: auto;\n}\n.card-btn button {\n    background: transparent;\n    border: navajowhite;\n    padding: 0;\n}\n.hidden-text-button {\n    color: transparent;\n    text-indent: -9999px;\n    background: #f0f0f0;\n    width: 100px;\n    height: 50px;\n    border-radius: 10px;\n    border: none;\n}\n/************************ 15.Reason for using payfast CSS ***************************/\n.we-txt {\n    color: var(--sub-text-color);\n    text-align: center;\n    font-family: Satoshi;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n}\n.border-top {\n    border-top: 2px solid var(--sub-bg-color) !important;\n}\n#reason-using-payfast-main .custom-lable {\n    color: var(--text-color);\n}\n#reason-using-payfast-main .change-lan-sec {\n    padding: 12px 0 !important;\n}\n#upload-id-main {\n    background-image: url(../images/upload-id/bg-img.png);\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n    width: 100%;\n    height: calc(100vh - 66px);\n    position: relative;\n    border-radius: 24px 24px 0px 0px;\n    margin-top: 20px;\n}\n.frame {\n    max-width: 768px;\n    width: 100%;\n    height: 100%;\n    position: relative;\n    overflow: hidden;\n    border-radius: 34px 34px 0px 0px;\n}\n.frame img {\n    width: 100%;\n    height: 100%;\n}\n#upload-id-page .verify-number-top {\n    padding-bottom: 20px;\n}\n.overlay {\n    position: absolute;\n    background-image: url(../images/upload-id/overlay.png);\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: 100% 100%;\n    width: 100%;\n    top: 0;\n    right: 0;\n    height: 100%;\n    border-radius: 24px 24px 0px 0px;\n}\n.overlay.selfie-overlay {\n    background-image: url(../images/upload-id/selfie-overlay.png);\n}\n.upload-top h1 {\n    color: var(--1, #FFF);\n    text-align: center;\n    font-family: Satoshi;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 24px;\n}\n.upload-top p {\n    color: var(--1, #FFF);\n    text-align: center;\n    font-family: Satoshi;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 20px;\n}\n.upload-id-content {\n    position: absolute;\n    height: 100%;\n    width: 100%;\n    padding: 16px 16px 0 16px;\n    bottom: 0;\n}\n.flash-btn {\n    width: 48px;\n    height: 48px;\n    border-radius: 24px;\n    background: white;\n}\n.upload-id-button-content {\n    column-gap: 30px;\n}\n.upload-id-bottom {\n    position: relative;\n    height: calc(100% - 86px);\n}\n.upload-id-button {\n    position: fixed;\n    width: 100%;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    padding-bottom: 30px;\n}\n.scanner-border {\n    margin-top: 64px;\n    text-align: center;\n}\n.verify-txt {\n    color: var(--1, #FFF);\n    text-align: center;\n    font-family: Satoshi;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n}\n#loader {\n    color: var(--6, #FFAA01);\n    text-align: center;\n    font-family: Poppins;\n    font-size: 36px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 36px;\n}\n.loader-content {\n    position: fixed;\n    width: 100%;\n    left: 0;\n    right: 0;\n    margin-left: auto;\n    margin-right: auto;\n    padding-bottom: 30px;\n    bottom: 0;\n}\n.finger-content-sec h2 {\n    color: var(--text-color);\n    text-align: center;\n    font-family: Poppins;\n    font-size: 24px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 36px;\n}\n.finger-content-sec p {\n    color: var(--5, #5A5C5E);\n    text-align: center;\n    font-family: Satoshi;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 20px;\n}\n.face-main .offcanvas-body {\n    overflow-y: hidden;\n}\n.loader,\n.finger-img-sec {\n    text-align: center;\n}\n.sk-fading-circle {\n    width: 40px;\n    height: 40px;\n    position: relative;\n    margin-left: auto;\n    margin-right: auto;\n}\n.sk-fading-circle .sk-circle {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    left: 0;\n    top: 0;\n}\n.sk-fading-circle .sk-circle:before {\n    content: '';\n    display: block;\n    margin: 0 auto;\n    width: 15%;\n    height: 15%;\n    background-color: #7B51F1;\n    border-radius: 100%;\n    -webkit-animation: sk-circleFadeDelay 1.2s infinite ease-in-out both;\n    animation: sk-circleFadeDelay 1.2s infinite ease-in-out both;\n}\n.sk-fading-circle .sk-circle2 {\n    -webkit-transform: rotate(30deg);\n    -ms-transform: rotate(30deg);\n    transform: rotate(30deg);\n}\n.sk-fading-circle .sk-circle3 {\n    -webkit-transform: rotate(60deg);\n    -ms-transform: rotate(60deg);\n    transform: rotate(60deg);\n}\n.sk-fading-circle .sk-circle4 {\n    -webkit-transform: rotate(90deg);\n    -ms-transform: rotate(90deg);\n    transform: rotate(90deg);\n}\n.sk-fading-circle .sk-circle5 {\n    -webkit-transform: rotate(120deg);\n    -ms-transform: rotate(120deg);\n    transform: rotate(120deg);\n}\n.sk-fading-circle .sk-circle6 {\n    -webkit-transform: rotate(150deg);\n    -ms-transform: rotate(150deg);\n    transform: rotate(150deg);\n}\n.sk-fading-circle .sk-circle7 {\n    -webkit-transform: rotate(180deg);\n    -ms-transform: rotate(180deg);\n    transform: rotate(180deg);\n}\n.sk-fading-circle .sk-circle8 {\n    -webkit-transform: rotate(210deg);\n    -ms-transform: rotate(210deg);\n    transform: rotate(210deg);\n}\n.sk-fading-circle .sk-circle9 {\n    -webkit-transform: rotate(240deg);\n    -ms-transform: rotate(240deg);\n    transform: rotate(240deg);\n}\n.sk-fading-circle .sk-circle10 {\n    -webkit-transform: rotate(270deg);\n    -ms-transform: rotate(270deg);\n    transform: rotate(270deg);\n}\n.sk-fading-circle .sk-circle11 {\n    -webkit-transform: rotate(300deg);\n    -ms-transform: rotate(300deg);\n    transform: rotate(300deg);\n}\n.sk-fading-circle .sk-circle12 {\n    -webkit-transform: rotate(330deg);\n    -ms-transform: rotate(330deg);\n    transform: rotate(330deg);\n}\n.sk-fading-circle .sk-circle2:before {\n    -webkit-animation-delay: -1.1s;\n    animation-delay: -1.1s;\n}\n.sk-fading-circle .sk-circle3:before {\n    -webkit-animation-delay: -1s;\n    animation-delay: -1s;\n}\n.sk-fading-circle .sk-circle4:before {\n    -webkit-animation-delay: -0.9s;\n    animation-delay: -0.9s;\n}\n.sk-fading-circle .sk-circle5:before {\n    -webkit-animation-delay: -0.8s;\n    animation-delay: -0.8s;\n}\n.sk-fading-circle .sk-circle6:before {\n    -webkit-animation-delay: -0.7s;\n    animation-delay: -0.7s;\n}\n.sk-fading-circle .sk-circle7:before {\n    -webkit-animation-delay: -0.6s;\n    animation-delay: -0.6s;\n}\n.sk-fading-circle .sk-circle8:before {\n    -webkit-animation-delay: -0.5s;\n    animation-delay: -0.5s;\n}\n.sk-fading-circle .sk-circle9:before {\n    -webkit-animation-delay: -0.4s;\n    animation-delay: -0.4s;\n}\n.sk-fading-circle .sk-circle10:before {\n    -webkit-animation-delay: -0.3s;\n    animation-delay: -0.3s;\n}\n.sk-fading-circle .sk-circle11:before {\n    -webkit-animation-delay: -0.2s;\n    animation-delay: -0.2s;\n}\n.sk-fading-circle .sk-circle12:before {\n    -webkit-animation-delay: -0.1s;\n    animation-delay: -0.1s;\n}\n@keyframes sk-circleFadeDelay {\n    0%,\n    39%,\n    100% {\n        opacity: 0;\n    }\n    40% {\n        opacity: 1;\n    }\n}\n/************************ 16.Finger Print CSS ***************************/\n.scan {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    background: url(../images/finger-print/print-border.png);\n    width: 220px;\n    height: 220px;\n    background-size: 300px;\n    background-repeat: no-repeat;\n    background-size: cover;\n    margin-left: auto;\n    margin-right: auto;\n}\n.scan .fingerprint {\n    position: relative;\n    width: 220px;\n    height: 220px;\n    background: url(../images/finger-print/finger-print-img.png);\n    background-size: 300px;\n    background-repeat: no-repeat;\n    background-size: cover;\n}\n.dark .scan .fingerprint {\n    background: url(../images/finger-print/finger-print-img-white.png);\n}\n.scan .fingerprint::before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: url(../images/finger-print/finger-print-img.png);\n    background-size: 300px;\n    background-repeat: no-repeat;\n    background-size: cover;\n    animation: animate 4s ease-in-out infinite;\n    filter: brightness(0) saturate(100%) invert(30%) sepia(94%) saturate(1008%) hue-rotate(229deg) brightness(109%) contrast(91%);\n}\n.finger-print-main .modal-dialog {\n    margin: inherit !important;\n    margin-right: auto !important;\n    margin-left: auto !important;\n}\n.scan .fingerprint::after {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 4px;\n    border-radius: 8px;\n    animation: animate_line 4s ease-in-out infinite;\n}\n.sub-text {\n    color: var(--sub-text-color);\n    text-align: center;\n    font-family: Satoshi;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n}\n.verify-number-btn.fingerprint-btn {\n    position: relative;\n    padding: 0;\n}\n.add-fingerprint p {\n    color: var(--sub-text-color);\n    text-align: center;\n    font-family: Satoshi;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n}\n.scanner_main {\n    padding-top: 120px;\n    padding-bottom: 135px;\n}\n.circles,\n#homepage .home-activity {\n    padding-bottom: 135px;\n}\n.skip-txt a {\n    color: var(--text-color);\n    font-family: Satoshi;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n}\n.skip-txt {\n    text-align: center;\n}\n.finger-print-bottom {\n    position: fixed;\n    width: 100%;\n    bottom: 0;\n    left: 0;\n    padding: 16px 16px;\n    background: var(--primary-color);\n}\n/************************ 17.Forget password CSS ***************************/\n.form-item {\n    position: relative;\n    margin-bottom: 15px;\n}\n.form-item input {\n    display: block;\n    width: 100%;\n    height: 64px;\n    background: transparent;\n    border: solid 2px black;\n    transition: all .3s ease;\n    padding-left: 80px;\n    border-radius: 30px;\n    outline: none;\n    padding-top: 5px;\n    color: grey;\n    font-family: Satoshi;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n}\n.form-item label {\n    position: absolute;\n    cursor: text;\n    z-index: 2;\n    top: 33%;\n    left: 70px;\n    padding: 0 10px;\n    color: green;\n    transition: all .3s ease;\n    font-family: Satoshi;\n    font-weight: 500;\n    line-height: 20px;\n    font-size: 16px;\n}\n.form-item input:focus {\n    border: 2px solid #00D061;\n}\n.mobile-message-main {\n    position: absolute;\n    top: 8px;\n    left: 8px;\n    width: 48px;\n    height: 48px;\n    background-color: var(--sub-bg-color);\n    border-radius: 50%;\n}\n.form-item input:focus+label,\n.form-item input:valid+label {\n    font-size: 14px;\n    top: 3px;\n    color: #00D061 !important;\n}\n.forget-password-form .form-floating>label {\n    left: 70px;\n}\n.forget-password-form input {\n    padding-left: 80px !important;\n    background: transparent !important;\n    border-radius: 12px;\n    border: 2px solid var(--14, #F2EEFE);\n    background: var(--1, #FFF);\n    height: 64px !important;\n}\n.forget-password-form .form-control:focus {\n    box-shadow: none !important;\n    background: transparent !important;\n    border: 2px solid var(--14, #F2EEFE);\n}\n.forget-password-form .form-floating input:focus {\n    border: 2px solid var(--2, #7B51F1);\n}\n/************************ 18.Notification screen CSS ***************************/\n.notification-icon-img {\n    width: 64px;\n    height: 64px;\n    border-radius: 32px;\n}\n.icon1 {\n    background: #F2EEFE;\n}\n.icon2 {\n    background: rgb(255 170 1 / 12%);\n}\n.icon3 {\n    background: rgb(251 73 69 / 12%);\n}\n.icon4 {\n    background: rgb(0 162 102 / 12%);\n}\n.nofication-content {\n    display: flex;\n    column-gap: 16px;\n    align-items: center;\n}\n.notification-new {\n    margin-left: auto;\n}\n.new {\n    padding: 8px 12px;\n    border-radius: 4px;\n    background: var(--7, #00A266);\n}\n.new a {\n    color: var(--1, #FFF);\n    text-align: center;\n    font-family: Satoshi;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n    display: block;\n}\n.notification-content h3 {\n    color: var(--text-color);\n    font-family: Satoshi;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 24px;\n}\n.notification-content p {\n    color: var(--sub-text-color);\n    font-family: Satoshi;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 18px;\n    padding-top: 4px;\n}\n.now-txt {\n    color: var(--sub-text-color);\n    font-family: Satoshi;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 18px;\n}\n.notification-details {\n    border-bottom: 2px solid var(--sub-bg-color);\n    padding-bottom: 12px;\n}\n.notification-details:last-child {\n    border-bottom: none;\n}\n#notification-main {\n    padding: 16px !important;\n}\n/************************ 19.Deactive account CSS ***************************/\n.deactive-account-sec h1 {\n    color: var(--text-color);\n    font-family: Poppins;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 24px;\n}\n.deactivate-step p,\n.deactivate-step-list li {\n    color: var(--sub-text-color);\n    font-family: Satoshi;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 20px;\n}\n.deactivate-step-list li {\n    padding-top: 8px;\n}\n.deactivate-step-list {\n    padding-left: 25px;\n}\n/************************ 20.Electricity bill 1 Screen ***************************/\n.electricity1-top {\n    border-bottom: 2px solid var(--sub-bg-color);\n}\n.pay-txt {\n    color: var(--text-color);\n    text-align: center;\n    font-family: Poppins;\n    font-size: 24px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 36px;\n}\n#electricity1 .pay-bill-img {\n    margin-right: auto;\n    margin-left: auto;\n}\n#electricity1 .pay-bill-name {\n    padding-bottom: 24px;\n}\n.custom-input-id {\n    border: none;\n    background: aqua;\n    width: 100%;\n    color: var(--sub-text-color);\n    font-family: Satoshi;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n    border-radius: 12px;\n    background: var(--primary-color);\n    padding: 16px;\n    border: 2px solid var(--sub-bg-color);\n}\n.custom-lbl-electricity {\n    color: var(--text-color);\n    font-family: Poppins;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 24px;\n}\n.bill-amount-content span:first-child {\n    color: var(--sub-text-color);\n    font-family: Poppins;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n}\n.bill-amount-content span:last-child {\n    color: var(--text-color);\n    text-align: right;\n    font-family: Poppins;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n}\n.bill-amount-content {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n.electricity1-bottom.mt-24 {\n    border-radius: 12px;\n    border: 2px solid var(--2, #7B51F1);\n    background: var(--primary-color);\n    padding: 16px;\n}\n.custom-select-internet select {\n    width: 100%;\n    color: var(--sub-text-color);\n    font-family: Satoshi;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n    padding: 16px;\n    border-radius: 12px;\n    background-color: var(--sub-bg-color);\n    border: 0;\n}\n.arrow-icon {\n    background: url(../svg/up-icon.svg) no-repeat;\n    background-position: 96% center;\n    font-size: 18px;\n    appearance: none;\n}\nselect:focus-visible {\n    outline: 0;\n}\n/************************ 21.Paid screen css ***************************/\n.paid-button1 a {\n    width: 100%;\n    border-radius: 12px;\n    background: var(--2, #7B51F1);\n    padding: 12px 0;\n    margin: auto;\n    max-width: 600px;\n    color: var(--1, #FFF);\n    text-align: center;\n    font-family: Poppins;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n}\n.paid-button2 a {\n    width: 100%;\n    border-radius: 12px;\n    background: var(--sub-bg-color);\n    padding: 12px 0;\n    margin: auto;\n    max-width: 600px;\n    color: var(--2, #7B51F1);\n    text-align: center;\n    font-family: Poppins;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n}\n.bill-paid-btn {\n    position: fixed;\n    width: 100%;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    margin-left: auto;\n    margin-right: auto;\n    background: var(--primary-color);\n    padding: 16px;\n    padding-bottom: 16px;\n    box-shadow: 0px -4px 4px 0px rgba(18, 18, 18, 0.04);\n}\n#bill-paid {\n    padding-bottom: 170px !important;\n}\n/************************ 22.Faq css ***************************/\n.nested-accordion {\n    cursor: pointer;\n    position: relative;\n}\n.review-time p {\n    color: var(--3, #666);\n    font-family: Lato;\n    font-size: 10px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n}\n.nested-accordion h3 {\n    color: var(--4, #121212);\n    font-family: Satoshi;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 20px;\n}\n.nested-accordion .comment {\n    color: var(--5, #5A5C5E);\n    font-family: Satoshi;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 20px;\n}\n.nested-accordion h3:before {\n    content: url(../svg/faq-plus.svg);\n    position: absolute;\n    right: 0;\n    color: #FF4C3B;\n    font-family: Space Grotesk;\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 20px;\n}\n.nested-accordion h3.selected {\n    color: var(--2, #7B51F1);\n    font-family: Satoshi;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 20px;\n}\n/* .faq-txt1:before {\n    content: url(../svg/up-arrow.svg) !important;\n} */\n.nested-accordion h3.selected:before {\n    content: url(../svg/faq-minus.svg);\n}\n.faq-txt1.selected:before {\n    content: url(../svg/faq-down.svg) !important;\n}\n.faq-txt1:before {\n    content: url(../svg/up-icon.svg) !important;\n}\n/************************ 23.Feedback css ***************************/\nlabel {\n    display: block;\n}\n.custom-textarea {\n    width: 100%;\n    padding: 16px;\n    color: var(--5, #5A5C5E);\n    font-family: Satoshi;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n    border-radius: 12px;\n    background: var(--9, #F5F5F5);\n    border: 0;\n}\ntextarea {\n    resize: none;\n}\n/************************ 24.Contact us css ***************************/\n.contact-us-mobile-btn a {\n    border-radius: 8px;\n    background: rgb(123 81 241 / 8%);\n    padding: 12px;\n    width: 100%;\n    display: block;\n    color: var(--text-color);\n    font-family: Satoshi;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n}\n.contact-us-no {\n    padding-left: 12px;\n}\n/************************ 25.Notifiaction setting css ***************************/\n.notification-option-wrapper {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 16px 0;\n}\n.notification-option-name p {\n    color: var(--text-color);\n    font-family: Satoshi;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n}\n.notification-option-switch .switch {\n    position: relative;\n    display: inline-block;\n    width: 40px;\n    height: 20px;\n}\n.notification-option-switch .slider {\n    position: absolute;\n    cursor: pointer;\n    top: 0;\n    left: 4px;\n    right: 0;\n    bottom: 0;\n    border: 1px solid rgb(102 102 102 / 20%);\n    border-radius: 40px;\n    -webkit-transition: 0.4s;\n    transition: 0.4s;\n}\n.notification-option-switch .slider:before {\n    position: absolute;\n    content: \"\";\n    height: 18px;\n    width: 18px;\n    background: #fff;\n    border-radius: 22px;\n    left: 0px;\n    bottom: 0px;\n    -webkit-transition: 0.4s;\n    transition: 0.4s;\n    border-radius: 22px;\n    border: 0.5px solid #F0F0F0;\n    box-shadow: 0px 3px 1px 0px rgba(0, 0, 0, 0.05), 0px 1px 1px 0px rgba(0, 0, 0, 0.08), 0px 3px 8px 0px rgba(0, 0, 0, 0.08);\n}\n.notification-option-switch input:checked+.slider {\n    background: #7B51F1;\n    border: 1px solid transparent;\n}\n.notification-option-switch input:checked+.slider:before {\n    transform: translateX(16px);\n}\n.switch input {\n    opacity: 0;\n    width: 0;\n    height: 0;\n}\np.notify-txt {\n    color: var(--text-color);\n    font-family: Poppins;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 24px;\n}\n/************************ 26.Setting screen css ***************************/\n.setting-header {\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n}\n.setting-left {\n    width: 50%;\n    display: flex;\n    align-items: center;\n    column-gap: 12px;\n}\n.setting-right {\n    width: 50%;\n    justify-content: end;\n    display: flex;\n    align-items: center;\n    column-gap: 12px;\n}\n.setting-right span a {\n    display: flex;\n}\n.dots-icon {\n    width: 36px;\n    height: 36px;\n    display: flex;\n    align-items: center;\n    justify-content: space-around;\n    border: 2px solid white;\n    border-radius: 8px;\n}\n.setting-txt {\n    color: var(--1, #FFF);\n    font-family: Poppins;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n}\n.setting-top {\n    border-bottom: 2px solid var(--sub-bg-color);\n    padding-bottom: 16px;\n}\n.setting-title h3 {\n    color: var(--text-color);\n    font-family: Satoshi;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 20px;\n}\n.setting-icon {\n    width: 48px;\n    height: 48px;\n    background: var(--sub-bg-color);\n    border-radius: 8px;\n}\n.setting-center-border {\n    height: 2px;\n    background: var(--sub-bg-color);\n    margin: 24px 0;\n}\n.border-none {\n    border-bottom: none !important;\n    padding-bottom: 0 !important;\n}\n.setting-lanuage {\n    color: var(--sub-text-color);\n    text-align: right;\n    font-family: Satoshi;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 20px;\n    display: inline-flex;\n    margin-right: 16px;\n}\n.send-money-contact-tab {\n    cursor: pointer;\n}\n.diffrent-chat-dropdown {\n    padding: 0;\n    margin: 0;\n    list-style-type: circle;\n    margin-left: 50px;\n    margin-right: 30px;\n}\n.diffrent-chat-dropdown li {\n    border-bottom: 2px solid var(--sub-bg-color);\n    padding: 8px;\n}\n.diffrent-chat-dropdown li a {\n    color: var(--text-color);\n    font-family: Satoshi;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 20px;\n}\n/************************ 27.Send money1 css ***************************/\ninput[type=number]::-webkit-inner-spin-button,\ninput[type=number]::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    margin: 0;\n}\n.enter-amount label,\n.total-txt {\n    color: var(--sub-text-color);\n    text-align: center;\n    font-family: Poppins;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n}\n.available-txt {\n    color: var(--sub-text-color);\n    text-align: center;\n    font-family: Satoshi;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n}\n.enter-amount input {\n    width: 100%;\n    padding: 22px 12px;\n    text-align: center;\n    color: var(--text-color);\n    text-align: center;\n    font-family: Poppins;\n    font-size: 36px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 36px;\n    border-radius: 12px;\n    border: 2px solid var(--8, #FB4945);\n    background: var(--primary-color);\n    border-style: solid;\n}\n.enter-amount input:focus,\n.enter-amount input.active {\n    border: 2px solid #00A266;\n}\n.fee-txt {\n    color: var(--sub-text-color);\n    text-align: center;\n    font-family: Satoshi;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 20px;\n}\n/************************ 28.Send money4 css ***************************/\n.send-money4-top h1 {\n    color: var(--4, #121212);\n    text-align: center;\n    font-family: Poppins;\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 30px;\n}\n.send-money4-top p {\n    color: var(--5, #5A5C5E);\n    text-align: center;\n    font-family: Satoshi;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 20px;\n}\n.custom-radio {\n    position: relative;\n    margin-bottom: 0;\n    border-radius: 12px;\n    border: 2px solid var(--sub-bg-color);\n    background: var(--primary-color);\n    padding: 16px !important;\n}\n#data-privacy .form-check-input:checked[type=radio],\n#delete-deactivate-main .form-check-input:checked[type=radio],\n#delete-account .form-check-input:checked[type=radio],\n#transfer-to-bank-main .form-check-input:checked[type=radio] {\n    outline: 2px solid #FB4945;\n    outline-offset: 4px;\n    background: #FB4945;\n    border: 0;\n    width: 11px;\n    height: 11px;\n    margin-right: 5px;\n}\n.custom-radio input {\n    right: 0;\n}\n.checkout-modal-lbl {\n    display: inline-grid !important;\n    padding: 16px 0;\n    color: var(--text-color);\n    font-family: Poppins;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 24px;\n}\n.checkout-modal-lbl span {\n    color: var(--sub-text-color);\n    font-family: Satoshi;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 20px;\n    padding-right: 50px;\n}\n.custom-radio input {\n    position: absolute;\n    right: 25px;\n    top: 0;\n    bottom: 0;\n    margin: auto;\n    width: 24px;\n    height: 24px;\n    border: 2px solid var(--text-color);\n}\n.custom-radio.active {\n    border: 2px solid var(--8, #FB4945) !important;\n}\n/************************ 29.Send money css ***************************/\n.sendmoney-top h1 {\n    color: var(--text-color);\n    text-align: center;\n    font-family: Poppins;\n    font-size: 36px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 36px;\n}\n.sendmoney-top p {\n    color: var(--sub-text-color);\n    text-align: center;\n    font-family: Satoshi;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 20px;\n}\n.sendmoney-top.send-money4-top {\n    padding-bottom: 16px;\n}\n.contact-icon {\n    background: var(--sub-bg-color);\n    padding: 13px;\n    width: 74px;\n    height: 74px;\n    border-radius: 37px;\n    margin-left: auto;\n    margin-right: auto;\n}\n.send-money p {\n    color: var(--text-color);\n    text-align: center;\n    text-overflow: ellipsis;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 20px;\n}\n.sendmoney-bottom-wrap {\n    display: flex;\n    justify-content: space-around;\n    width: 100%;\n}\n.send-money {\n    width: 33.33%;\n}\n.sendmomey-details {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    border-bottom: 2px solid var(--sub-bg-color);\n    padding-bottom: 12px;\n}\n.sendmomey-details span:first-child {\n    color: var(--sub-text-color);\n    font-family: Poppins;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 20px;\n}\n.sendmomey-details span:last-child {\n    color: var(--text-color);\n    text-align: right;\n    font-family: Poppins;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 20px;\n}\nimg.copied-icon {\n    margin-left: 8px;\n}\n.sendmoney-content {\n    border-radius: 12px;\n    border: 2px solid var(--2, #7B51F1);\n    background: var(--primary-color);\n    padding: 16px;\n}\n.sendmomey-details:last-child {\n    padding-bottom: 0;\n    border-bottom: 0;\n}\n/************************ 30.Taxes css ***************************/\n.tax-plus-btn {\n    width: 56px;\n    height: 56px;\n    background: var(--2, #7B51F1);\n    border-radius: 26px;\n    position: absolute;\n    bottom: 0;\n    right: 0;\n    margin-bottom: 50px;\n    margin-right: 16px;\n}\n#taxes-main .tax-plus-btn {\n    margin-bottom: 30px;\n}\n.tax-plus-btn img {\n    filter: brightness(0) saturate(100%) invert(100%) sepia(100%) saturate(0%) hue-rotate(299deg) brightness(106%) contrast(101%);\n}\n#taxes-main .sendmomey-details {\n    padding: 16px 0 !important;\n}\n#taxes-main .sendmomey-details:first-child {\n    padding-top: 0 !important;\n}\n#taxes-main .sendmomey-details span:first-child,\n#taxes-main .sendmomey-details span:last-child {\n    color: var(--text-color);\n    font-family: Poppins;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n}\n/************************ 31.Marketing css ***************************/\n.marketing-content p {\n    color: var(--sub-text-color);\n    font-family: Satoshi;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n}\n.marketing-content h2 {\n    color: var(--text-color);\n    font-family: Poppins;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 24px;\n}\n.marketing-content .notification-option-wrapper {\n    padding: 0;\n}\n.marketing-content .notification-option-name p {\n    color: var(--text-color);\n    font-family: Satoshi;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n}\n/************************ 32.Data privacy css ***************************/\n.data-privacy-content h1 {\n    color: var(--text-color);\n    font-family: Poppins;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 24px;\n}\n.privacy-content h2 {\n    color: var(--text-color);\n    font-family: Poppins;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 24px;\n}\n.privacy-content p {\n    color: var(--sub-text-color);\n    font-family: Satoshi;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 20px;\n}\n.privacy-content {\n    border-radius: 12px;\n    border: 2px solid var(--sub-bg-color);\n    background: var(--primary-color);\n    padding: 16px;\n}\n.manage-txt {\n    color: var(--text-color);\n    font-family: Poppins;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 24px;\n}\n.manage-data-sec {\n    border-radius: 12px;\n    border: 2px solid var(--sub-bg-color);\n    background: var(--primary-color);\n    padding: 16px;\n}\n.manage-data-title h3 {\n    color: var(--text-color);\n    font-family: Poppins;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 24px;\n}\n.manage-data-title p {\n    color: var(--sub-text-color);\n    font-family: Satoshi;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 20px;\n}\n/************************ 33.Delete deactivate css ***************************/\n.delete-content p {\n    color: var(--sub-text-color);\n    text-align: center;\n    font-family: Satoshi;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 20px;\n}\n/************************ 34.Send money review css ***************************/\n.purple-border {\n    border-bottom: 2px solid #7B51F1;\n}\n.review-note h2 {\n    color: var(--text-color);\n    font-family: Poppins;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 24px;\n}\n.review-note p {\n    color: var(--sub-text-color);\n    font-family: Satoshi;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n}\n#send-money-review .sendmomey-details {\n    padding-bottom: 16px;\n}\n.money-review-txt {\n    color: var(--text-color);\n    font-family: Satoshi;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n}\nform {\n    margin-block-end: 0px;\n}\n/************************ 35.Transfer to bank css ***************************/\n.transfer-first {\n    display: flex;\n    align-items: center;\n    column-gap: 16px;\n    border-bottom: 2px solid var(--sub-bg-color);\n    padding-bottom: 24px;\n    padding-top: 24px;\n}\n.bank-img {\n    border: 1px solid var(--sub-bg-color);\n    width: 74px;\n    height: 48px;\n    border-radius: 8px;\n}\n.bank-details h2 {\n    color: var(--text-color);\n    font-family: Satoshi;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 24px;\n}\n.bank-card span:first-child {\n    color: var(--7, #00A266);\n    font-family: Satoshi;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 20px;\n}\n.bank-card span:last-child {\n    color: var(--sub-text-color);\n    font-family: Satoshi;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 20px;\n}\n#bank-and-card-main .bank-active-sec,\n#payment-main .bank-active-sec,\n#transfer-to-bank-main .bank-active-sec {\n    margin-left: auto;\n}\n.bank-active-sec img {\n    filter: var(--icon-filter);\n}\n.bank-card {\n    margin-top: 4px;\n}\n.paid-button2 span img {\n    filter: brightness(0) saturate(100%) invert(35%) sepia(96%) saturate(2682%) hue-rotate(239deg) brightness(95%) contrast(100%);\n    margin-right: 8px;\n}\n#bank-and-card-main .verify-number-btn span img {\n    filter: brightness(0) saturate(100%) invert(100%) sepia(13%) saturate(0%) hue-rotate(79deg) brightness(101%) contrast(101%);\n    margin-right: 8px;\n}\n.pay-txt1 {\n    color: var(--7, #00A266);\n    text-align: right;\n    font-family: Satoshi;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 24px;\n}\n#payment-main .transfer-first {\n    padding-bottom: 16px;\n    padding-top: 16px;\n}\n.transfer-first:first-child {\n    padding-top: 0 !important;\n}\n#payment-main .bank-active-sec img {\n    filter: brightness(0) saturate(100%) invert(34%) sepia(31%) saturate(6894%) hue-rotate(144deg) brightness(102%) contrast(101%);\n}\n#payment-main .bank-details p {\n    color: var(--sub-text-color);\n    font-family: Satoshi;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 20px;\n    margin-top: 4px;\n}\n.ApplyPay {\n    filter: var(--icon-filter);\n}\n/************************ 36.Invite friend css ***************************/\n.invite-friend-wrapper {\n    display: flex;\n    align-items: center;\n    column-gap: 16px;\n}\n.friend-invite {\n    margin-left: auto;\n}\n.friend-select input {\n    display: none;\n}\n.custom-radio-sel-friend {\n    width: 61px;\n    height: 34px;\n    border-radius: 4px;\n    border: 2px solid #7B51F1;\n    cursor: pointer;\n    color: var(--2, #7B51F1);\n    text-align: center;\n    font-family: Satoshi;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 16px;\n}\n.friend-select input[type=\"checkbox\"]:checked+label {\n    border-radius: 4px;\n    border: 2px solid var(--2, #7B51F1);\n    background: var(--2, #7B51F1);\n    color: white;\n}\n.friend-name {\n    color: var(--text-color);\n    font-family: Satoshi;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 24px;\n}\n.friend-no a {\n    color: var(--sub-text-color);\n    font-family: Satoshi;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 18px;\n    margin-top: 4px;\n}\n.invite-img img {\n    border-radius: 50px;\n}\n.friend-no {\n    margin-top: 4px;\n}\n/************************ 37.Logout popup css ***************************/\n.offcanvas.offcanvas-bottom {\n    border-radius: 24px 24px 0 0;\n    padding: 12px 16px 30px 16px;\n    height: auto;\n}\n.offcanvas.offcanvas-bottom .offcanvas-header {\n    padding: 0;\n    cursor: pointer;\n}\n.offcanvas {\n    background: var(--primary-color);\n}\n.logout-main .offcanvas-body {\n    padding: 0 !important;\n}\n.logout-text-pop {\n    color: var(--text-color);\n    text-align: center;\n    font-family: Poppins;\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 30px;\n}\n.sm-txt {\n    color: var(--5, #5A5C5E);\n    text-align: center;\n    font-family: Satoshi;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n}\n.logout-button-main {\n    gap: 16px;\n}\n.logout-cancel {\n    color: var(--2, #7B51F1);\n    text-align: center;\n    font-family: Poppins;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n    width: 164px;\n    height: 48px;\n    border-radius: 12px;\n    background: var(--14, #F2EEFE);\n    border: none !important;\n}\n.yes-logot {\n    border-radius: 12px;\n    background: var(--2, #7B51F1);\n    color: var(--1, #FFF);\n    text-align: center;\n    font-family: Poppins;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n}\n.offcanvas-backdrop.show {\n    opacity: 1 !important;\n}\n.offcanvas-backdrop {\n    background: linear-gradient(180deg, rgba(33, 43, 70, 0.56) 0%, rgba(33, 43, 70, 0.24) 100%) !important;\n    backdrop-filter: blur(2px) !important;\n}\n.not-connect {\n    color: var(--4, #FF484D);\n}\nbutton.text-reset {\n    background: transparent;\n    color: var(--text-color) !important;\n    padding: 0;\n    border: 0;\n}\n/************************ 38.Personal info css ***************************/\n.profile-edit-img {\n    text-align: center;\n    position: relative;\n    width: 120px;\n    height: 120px;\n    margin: auto;\n}\n.profile-edit-img img {\n    border-radius: 60px;\n    max-width: 200px;\n    max-height: 200px;\n    width: 100%;\n    height: auto;\n}\n.image-input {\n    position: absolute;\n    bottom: 6px;\n    right: 0px;\n}\n.image-input input {\n    display: none;\n}\n.image-button {\n    background: black;\n    padding: 8px;\n    border-radius: 20px;\n    cursor: pointer;\n}\n.custom-icon-edit {\n    position: absolute;\n    right: 16px;\n    top: 35%;\n    cursor: pointer;\n    filter: var(--icon-filter);\n}\n.personal-name {\n    border-radius: 12px;\n    background: var(--sub-bg-color);\n    padding: 8px 16px;\n    position: relative;\n}\n.personal-name label {\n    color: var(--2, #7B51F1);\n    font-family: Satoshi;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 20px;\n}\n.personal-name input {\n    color: var(--text-color);\n    font-family: Satoshi;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n    border: 0;\n    width: 100%;\n    background: transparent;\n    padding-right: 35px;\n}\n/************************ 39.Activity css ***************************/\n.custom-tab-activity {\n    width: 100%;\n    width: calc(100% - 30px);\n    border-radius: 8px;\n    border: 2px solid var(--6, #FFAA01);\n    background: var(--1, #FFF);\n    position: absolute;\n    left: 0;\n    z-index: 99;\n    margin-top: 25px !important;\n    margin: 0 auto;\n    right: 0;\n}\n.custom-tab-activity button {\n    width: 33.33%;\n    border: 0 !important;\n    border-top-left-radius: 0 !important;\n    border-top-right-radius: 0 !important;\n    color: var(--6, #FFAA01);\n    text-align: center;\n    font-family: Poppins;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 24px;\n    padding: 12px !important;\n    border-right: 1px solid #ffaa01 !important;\n}\n.custom-tab-activity .nav-link.active {\n    background: var(--6, #FFAA01);\n    margin-bottom: auto !important;\n    color: var(--1, #FFF);\n}\n.custom-tab-activity button:hover {\n    color: var(--6, #FFAA01);\n}\n.custom-tab-activity button:last-child {\n    border-right: 0 !important;\n}\n.activity-date {\n    color: var(--text-color);\n    font-family: Poppins;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n}\n.all-details-name h3 {\n    color: var(--text-color);\n    font-family: Satoshi;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 24px;\n}\n.all-details-name p {\n    color: var(--sub-text-color);\n    font-family: Satoshi;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 20px;\n    margin-top: 4px;\n}\n.all-content-price p {\n    color: var(--7, #00A266);\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 24px;\n}\n.all-details-wrap {\n    display: flex;\n    justify-content: space-between;\n}\n/************************ 40.Delete account css ***************************/\n.delete-account-top h1 {\n    color: var(--text-color);\n    font-family: Poppins;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 24px;\n}\n.delete-account-top p {\n    color: var(--sub-text-color);\n    font-family: Satoshi;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 20px;\n}\n.delete-account-bottom {\n    display: flex;\n    justify-content: space-between;\n    padding: 16px 0;\n}\n.delete-account-bottom input,\n.bank-active-sec input {\n    width: 20px;\n    height: 20px;\n    border: 2px solid var(--text-color);\n    outline: 0;\n    margin: 0;\n}\n.delete-select {\n    display: flex;\n    align-items: center;\n}\n.delete-account-trapping p {\n    color: var(--sub-text-color);\n    font-family: Satoshi;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 20px;\n}\n.delete-account-trapping span {\n    color: var(--text-color);\n}\n.delete-account-trapping {\n    margin-top: 40px;\n}\n.delete-txt {\n    color: var(--text-color);\n    font-family: Satoshi;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n}\n/************************ 41.Add new card css ***************************/\n.demo-visa {\n    background-image: url(../images/payment/visa-card.png);\n    background-position: center;\n    background-repeat: no-repeat;\n    max-height: 200px;\n    height: 100%;\n    max-width: 343px;\n    width: 100%;\n    margin: 0 auto;\n    border-radius: 24px;\n    padding: 16px;\n    display: flex;\n    flex-direction: column;\n    gap: 40px;\n}\n.card-hidden-number {\n    color: var(--1, #FFF);\n    font-family: Satoshi;\n    font-size: 24px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 36px;\n    letter-spacing: 1.2px;\n}\n.card-name-jessica {\n    color: var(--1, #FFF);\n    font-family: Satoshi;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 24px;\n    letter-spacing: 0.8px;\n    text-transform: uppercase;\n    width: 100%;\n    max-width: 170px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n.card-date-cvv {\n    color: var(--1, #FFF);\n    text-align: right;\n    font-family: Satoshi;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 24px;\n    letter-spacing: 0.8px;\n    text-transform: uppercase;\n}\n.new_password_input .form-item input {\n    border-radius: 8px;\n    background: #F0F0F0;\n    border: navajowhite;\n    padding: 12px 16px;\n    width: 100%;\n    color: #212B46;\n    font-family: \"Space Grotesk\", sans-serif;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n    margin-top: 8px;\n}\n.info-person {\n    color: var(--3, #67696B);\n    font-family: \"League Spartan\", sans-serif;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 20px;\n    text-transform: uppercase;\n}\n.new_password_input .form-item input::placeholder {\n    color: #212B46;\n}\n.card-name-jessica-main {\n    display: flex;\n    justify-content: space-around;\n    column-gap: 25px;\n}\n.ui-datepicker-header a.ui-datepicker-next {\n    right: 0;\n    background: url(../images/payment/left-icon.png);\n    background-repeat: no-repeat;\n    background-size: 16px;\n    background-position: 50%;\n}\n.ui-datepicker-header a.ui-datepicker-prev {\n    left: 0;\n    background: url(../images/payment/left-icon.png);\n    background-repeat: no-repeat;\n    background-size: 16px;\n    background-position: 50%;\n    transform: rotate(180deg);\n}\n.ui-datepicker-header a>span {\n    display: none;\n}\n.card-name-jessica-main-sub {\n    display: flex;\n    justify-content: space-around;\n    column-gap: 25px;\n}\n#ui-datepicker-div {\n    display: none;\n    background-color: #fff;\n    box-shadow: 0 0.125rem 0.5rem rgba(0, 0, 0, 0.1);\n    margin-top: 0.25rem;\n    border-radius: 0.5rem;\n    padding: 0.5rem;\n}\ntable {\n    border-collapse: collapse;\n    border-spacing: 0;\n}\n.ui-datepicker-calendar thead th {\n    padding: 0.25rem 0;\n    text-align: center;\n    font-size: 0.75rem;\n    font-weight: 400;\n    color: #78909C;\n}\n.ui-datepicker-calendar tbody td {\n    width: 2.5rem;\n    text-align: center;\n    padding: 0;\n}\ndiv#ui-datepicker-div {\n    z-index: 500 !important;\n}\n.ui-datepicker-calendar tbody td a {\n    display: block;\n    border-radius: 0.25rem;\n    line-height: 2rem;\n    transition: 0.3s all;\n    color: #546E7A;\n    font-size: 0.875rem;\n    text-decoration: none;\n}\n.ui-datepicker-calendar tbody td a:hover {\n    background: rgb(159 130 240 / 20%);\n}\n.ui-datepicker-calendar tbody td a.ui-state-active {\n    background-color: #7B51F1;\n    color: white;\n}\n.ui-datepicker-header a.ui-corner-all {\n    cursor: pointer;\n    position: absolute;\n    top: 0;\n    width: 2rem;\n    height: 2rem;\n    margin: 0.5rem;\n    border-radius: 0.25rem;\n    transition: 0.3s all;\n}\n.ui-datepicker-title {\n    text-align: center;\n    line-height: 32px;\n    margin-bottom: 10px;\n    font-size: 16px;\n    font-weight: 500;\n}\n.expiry-date.mt-16 {\n    display: flex;\n    column-gap: 16px;\n}\n/************************ 42.Old invoice css ***************************/\n.old-invoice-edit {\n    margin-left: auto;\n}\n.old-invoice-edit img {\n    filter: brightness(0) saturate(100%) invert(100%) sepia(100%) saturate(0%) hue-rotate(201deg) brightness(105%) contrast(105%);\n}\n.old-invoice-icon {\n    margin-left: 8px;\n    width: 20px;\n    height: 20px;\n}\n#old-invoice .verify-number-btn {\n    background: var(--primary-color);\n    box-shadow: 0px -4px 4px 0px rgba(18, 18, 18, 0.04);\n    padding: 16px;\n}\n.old-invoice-add-content {\n    display: flex;\n    justify-content: space-between;\n}\n.old-invoice-add-content span {\n    color: var(--text-color);\n    font-family: Poppins;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 24px;\n}\n.add-item-btn a {\n    width: 100%;\n    border-radius: 12px;\n    border: 2px solid #7B51F1;\n    padding: 10px 0;\n    margin: auto;\n    max-width: 600px;\n    color: var(--2, #7B51F1);\n    text-align: center;\n    font-family: Poppins;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n}\n.add-item-btn img {\n    padding-right: 8px;\n}\n.txt2 {\n    color: var(--sub-text-color);\n    font-family: Poppins;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 20px;\n    margin-top: 8px;\n}\n.continue-txt {\n    color: var(--sub-text-color);\n    text-align: center;\n    font-family: Satoshi;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 20px;\n}\n.new-invoice-modal-content {\n    display: flex;\n    column-gap: 12px;\n}\n.new-invoice-modal-content {\n    display: flex;\n    column-gap: 12px;\n    border-bottom: 2px solid var(--sub-bg-color);\n    padding: 16px 0;\n}\n.new-invoive-pre-bnt {\n    margin-left: auto;\n}\n.new-invoive-pre-bnt img {\n    filter: var(--icon-filter);\n}\n.new-invoice-title p {\n    color: var(--text-color);\n    font-family: Satoshi;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n}\n.new-invoice-modal {\n    width: 100%;\n    margin-left: auto;\n    margin-right: auto;\n    max-width: 600px;\n}\n/************************ 43.Invoice css ***************************/\n.custom-tab-invoice button {\n    width: 25%;\n}\n.text-reset-share{\ntext-align: center;\n}\n.share-btn {\n    filter: var(--icon-filter) !important;\n    background: #000;\n}\n.all-details-name-invoice,\n.all-content-price-invoice {\n    display: flex;\n    justify-content: space-between;\n}\n.all-details-name-invoice span {\n    color: var(--text-color);\n    font-family: Satoshi;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 24px;\n}\n.all-content-price-invoice span {\n    color: var(--sub-text-color);\n    font-family: Satoshi;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 20px;\n    margin-top: 4px;\n}\n/************************ 44.Tracking css ***************************/\n.order-status-sec {\n    display: flex;\n    align-items: center;\n}\n.order-status-sec img {\n    filter: var(--icon-filter);\n}\n.order1 {\n    position: relative;\n}\n.order1::before {\n    content: \"\";\n    position: absolute;\n    width: 100%;\n    top: 50%;\n    left: 50%;\n    border-left: 2px dashed var(--text-color);\n    height: 40px;\n    margin-top: 14px;\n}\n.order2 {\n    margin-left: 12px;\n}\n.order-txt1 {\n    color: var(--text-color);\n    font-family: Satoshi;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 18px;\n}\n.order-txt2 {\n    color: var(--sub-text-color);\n    font-family: Satoshi;\n    font-size: 10px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 14px;\n    margin-top: 4px;\n}\n.track-order-third-sec-full h3 {\n    color: var(--text-color);\n    font-family: Poppins;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 24px;\n    padding-bottom: 18px;\n}\n/************************ 45.Preapproved-payment1 css ***************************/\n#preapproved-payment1 .send-money {\n    width: 25%;\n}\n#preapproved-payment1 .send-money:last-child p {\n    text-overflow: ellipsis;\n    overflow: hidden;\n    width: 74px;\n    white-space: nowrap;\n    margin-left: auto;\n    margin-right: auto;\n}\n#preapproved-payment1 .sendmoney-bottom-wrap {\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n    column-gap: 16px;\n}\n.refund-txt {\n    color: var(--text-color);\n    text-align: center;\n    font-family: Poppins;\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 30px;\n}\n/************************ 46.Spilt css ***************************/\n.spilt8-img {\n    margin-top: 20px;\n}\n.spilt3-editIcon {\n    filter: var(--icon-filter);\n}\n.split7-screen-content-top,\n.spilt8-img {\n    text-align: center;\n}\n.spilt8-img p {\n    color: var(--1, #FFF);\n    text-align: center;\n    font-family: Satoshi;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 18px;\n}\n.spilt8-btn {\n    gap: 16px;\n    position: fixed;\n    width: 100%;\n    bottom: 0;\n    left: 0;\n    right: 0;\n}\n.split3-btn {\n    background: var(--primary-color);\n    box-shadow: 0px -4px 4px 0px rgba(18, 18, 18, 0.04);\n    padding: 16px;\n}\n.social-media-content {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 16px;\n    max-width: 600px;\n    width: 100%;\n    margin-left: auto;\n    margin-right: auto;\n}\n.social-media-img {\n    text-align: center;\n}\n.social-media-img p {\n    color: var(--text-color);\n    text-align: center;\n    font-family: Satoshi;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 20px;\n    margin-top: 8px;\n}\n.split7-screen-content-top h1 {\n    color: var(--text-color);\n    text-align: center;\n    font-family: Poppins;\n    font-size: 24px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 36px;\n}\n.split7-screen-content-top p {\n    color: var(--sub-text-color);\n    text-align: center;\n    font-family: Satoshi;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 20px;\n}\n#spilt7-main .sendmomey-details,\n#spilt6-main .sendmomey-details {\n    padding: 12px 0;\n}\n.split6-screen-content-top h1 {\n    color: var(--text-color);\n    text-align: center;\n    font-family: Poppins;\n    font-size: 36px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 36px;\n}\n.split6-screen-content-top p {\n    color: var(--sub-text-color);\n    text-align: center;\n    font-family: Satoshi;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 20px;\n    margin-top: 12px;\n}\n.split3-screen-content {\n    display: flex;\n    align-items: center;\n    column-gap: 16px;\n}\n.split3-edit {\n    margin-left: auto;\n    display: flex;\n}\n.split3-edit span:first-child {\n    margin-right: 15px;\n}\n.split-bill2-top {\n    display: flex;\n    column-gap: 12px;\n    justify-content: space-between;\n    overflow-x: scroll;\n    margin-left: 16px;\n}\n.split-bill2-top-wrap {\n    position: relative;\n}\n.spilt-cancel-icon {\n    position: absolute;\n    right: 0;\n    bottom: 0;\n}\n.spilt-img img {\n    border-radius: 50px;\n}\n::-webkit-scrollbar {\n    display: none;\n}\n.split2-main .split-bill2-content .send-money-contact-tab {\n    padding: 0 !important;\n}\n.doneIocn {\n    filter: none;\n}\n/************************ 47.Transfer-to-bank-success css ***************************/\n.transfer-txt h1 {\n    color: var(--text-color);\n    text-align: center;\n    font-family: Poppins;\n    font-size: 24px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 36px;\n}\n.transfer-txt p {\n    color: var(--sub-text-color);\n    text-align: center;\n    font-family: Satoshi;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 20px;\n}\n.transfer-logo {\n    width: 74px;\n    height: 48px;\n    border: 1px solid #F2EEFE;\n    border-radius: 4px;\n}\n.first-content h2 {\n    color: var(--text-color);\n    font-family: Satoshi;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 24px;\n}\n.first-content p {\n    color: var(--sub-text-color);\n    font-family: Satoshi !important;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500 !important;\n    line-height: 20px;\n    margin-top: 4px;\n}\n.content-details {\n    display: flex;\n    column-gap: 16px;\n    border-bottom: 2px solid var(--sub-bg-color);\n    padding-bottom: 16px;\n}\n.transfer-content-details p {\n    color: var(--sub-text-color);\n    font-family: Poppins;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 20px;\n}\n#transfer-to-bank-review .sendmomey-details {\n    padding-top: 16px !important;\n    border-bottom: 2px solid #7B51F1;\n}\n#transfer-to-bank-review .sendmomey-details:last-child {\n    border-bottom: 0;\n}\n#transfer-to-bank-review .sendmomey-details:first-child {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n}\n.estimated-time h2 {\n    color: var(--text-color);\n    font-family: Poppins;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 24px;\n}\n.estimated-time p {\n    color: var(--sub-text-color);\n    font-family: Satoshi;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 20px;\n}\n.send-money4 h1 {\n    color: var(--text-color);\n    text-align: center;\n    font-family: Poppins;\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 30px;\n}\n/************************ 48.Line chart css ***************************/\n.chat-income-sec {\n    display: flex;\n    column-gap: 16px;\n    width: 100%;\n}\n.chat-income,\n.chat-expense {\n    width: 50%;\n    display: flex;\n    padding: 7px 8px;\n    height: 56px;\n    align-items: center;\n    column-gap: 9px;\n    border: 2px solid var(--6, #FFAA01);\n    border-radius: 8px;\n    background: white;\n}\n.chat-content {\n    width: calc(100% - 30px);\n    position: absolute;\n    left: 0;\n    z-index: 99;\n    margin-top: 16px !important;\n    max-width: 100%;\n    margin: 0 auto;\n    right: 0;\n}\n.chat-txt1 {\n    color: var(--7, #00A266);\n    font-family: Poppins;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 24px;\n}\n.chat-txt2 {\n    color: var(--sub-text-color);\n    font-family: Satoshi;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 18px;\n}\n.week-txt {\n    color: var(--sub-text-color);\n    font-family: Satoshi;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 20px\n}\n.price-txt {\n    color: var(--text-color);\n    font-family: Satoshi;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 24px;\n    margin-top: 4px;\n}\n.date-txt {\n    color: var(--sub-text-color);\n    font-family: Satoshi;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 18px;\n    margin-top: 4px;\n}\n.line-chart-data {\n    display: flex;\n}\n.data-details {\n    width: 50%;\n}\n.statistic-first h2 {\n    color: var(--text-color);\n    font-family: Poppins;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 24px;\n}\n.statistic-first p {\n    color: var(--sub-text-color);\n    font-family: Satoshi;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 20px;\n    margin-top: 4px;\n}\n.statistic-overview-content {\n    display: flex;\n    column-gap: 16px;\n}\n.chat-bottom-space {\n    padding-bottom: 110px;\n}\n.statistic-first {\n    width: 60%;\n}\n.statistic-second {\n    width: 40%;\n}\n.area-chat .custom-select-internet select {\n    border-radius: 4px;\n    background-color: var(--2, #7B51F1);\n    color: var(--1, #FFF);\n    font-family: Satoshi;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 16px;\n    padding: 12px;\n}\n.area-chat .arrow-icon {\n    background-image: url(../svg/white-up-icon.svg) !important;\n}\n/************************ 49.Homescreen css ***************************/\np.name {\n    color: var(--1, #FFF);\n    font-family: Poppins;\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 30px;\n}\np.balance {\n    color: var(--1, #FFF);\n    font-family: Satoshi;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n}\n.balance-data h1 {\n    color: var(--1, #FFF);\n    font-family: Poppins;\n    font-size: 36px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 36px;\n}\n.home-top-content {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-top: 36px;\n}\n.homepage-first {\n    display: flex;\n    justify-content: space-around;\n    border-radius: 24px;\n    background: var(--6, #FFAA01);\n    padding: 16px 0;\n}\n.first-details p {\n    color: var(--1, #FFF);\n    text-align: center;\n    font-family: Satoshi;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n    margin-top: 8px;\n}\n#homepage .send-money:last-child p,\n#homepage .send-money:first-child p {\n    text-overflow: ellipsis;\n    overflow: hidden;\n    width: 74px;\n    white-space: nowrap;\n    margin-left: auto;\n    margin-right: auto;\n}\n.home-activity-top span:first-child {\n    color: var(--text-color);\n    font-family: Poppins;\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 30px;\n}\n.home-activity-top {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n.home-activity-bottom-wrap {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n.home-first h3 {\n    color: var(--text-color);\n    font-family: Satoshi;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 24px;\n}\n.home-first p {\n    color: var(--sub-text-color);\n    font-family: Satoshi;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 20px;\n    margin-top: 4px;\n}\n.home-second h4 {\n    color: var(--7, #00A266);\n    text-align: right;\n    font-family: Satoshi;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 24px;\n}\n/************************ 50.Bottom tabbar css ***************************/\n.bottom-menu-svg-main {\n    position: relative;\n}\n.bottom-menu-svg {\n    position: fixed;\n    bottom: -40px;\n}\n.gol3 {\n    position: absolute;\n    left: 50%;\n    top: -10%;\n    transform: translateX(-50%);\n    width: 80px;\n    height: 80px;\n    background-color: #000000;\n    border-radius: 50%;\n    z-index: 99;\n}\n.add-to-cart-icon {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    display: flex;\n    align-items: center;\n}\n.home-icon {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n}\n.bottom-menu-svg-design {\n    max-width: 600px;\n    height: 160px;\n    width: 100%;\n    backdrop-filter: blur(12px);\n    background: var(--primary-color);\n}\n.navigation {\n    position: fixed;\n    bottom: 25px;\n    width: 100%;\n    padding: 0 32px;\n    max-width: 600px;\n}\n.navigation .listWrap {\n    list-style: none;\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n}\n.navigation .listWrap li a {\n    position: relative;\n    display: flex;\n    justify-content: center;\n}\n.navigation .listWrap li:active a .icon,\n.navigation .listWrap li.active a .icon {\n    filter: brightness(0) saturate(100%) invert(35%) sepia(56%) saturate(1672%) hue-rotate(232deg) brightness(95%) contrast(100%);\n    transform: translateY(-10px);\n}\n.navigation .listWrap li a .icon {\n    position: relative;\n    display: block;\n    text-align: center;\n    transition: 0.5s;\n    color: #FFF;\n}\n.icon img {\n    filter: var(--icon-filter);\n}\n#paint0_linear_1_13394 {\n    stop-color: #121212;\n}\n.navigation .listWrap li:active a .text,\n.navigation .listWrap li.active a .text {\n    opacity: 1;\n}\n.navigation .listWrap li a .text {\n    position: absolute;\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n    background-color: #7B51F1;\n    transition: 0.5s;\n    transform: translateY(20px);\n    opacity: 0;\n    z-index: 1;\n}\n/************************ 51.Face recognition css ***************************/\n.concentric-circles {\n    position: relative;\n    width: 300px;\n    height: 300px;\n    margin-top: 70px;\n    margin-left: auto;\n    margin-right: auto\n}\n.circle {\n    position: absolute;\n    border-radius: 50%;\n    animation: pulse 2s infinite;\n}\n.outer {\n    width: 100%;\n    height: 100%;\n    background-color: rgba(136, 84, 255, 0.1);\n    animation-delay: 0s;\n}\n.middle {\n    width: 220px;\n    height: 220px;\n    background-color: rgba(136, 84, 255, 0.2);\n    animation-delay: 0.5s;\n}\n.inner {\n    width: 120px;\n    height: 120px;\n    background-color: #8854FF;\n    animation-delay: 1s;\n}\n.inner img {\n    width: 50%;\n    height: 50%;\n}\n.chart-container {\n    width: 100%;\n    background: #FFF;\n    padding: 10px;\n}\n.bar-chart-container {\n    height: 300px;\n    margin: auto;\n}\n.request-content span:first-child {\n    color: var(--sub-text-color);\n    font-family: Poppins;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n}\n.request-content span:last-child {\n    color: var(--text-color);\n    text-align: right;\n    font-family: Poppins;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n}\n.request-txt {\n    color: var(--sub-text-color);\n    text-align: center;\n    font-family: Satoshi;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 20px;\n    border-bottom: 2px solid var(--sub-bg-color);\n    padding-bottom: 16px;\n}\n.request-btn {\n    position: relative;\n    padding: 0;\n}\n.request-content {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n.request-money-modal {\n    max-width: 600px;\n    margin: auto;\n}\n/************************ 52.QR code payment css ***************************/\n.name-txt {\n    color: var(--text-color);\n    text-align: center;\n    font-family: Poppins;\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 30px;\n}\n.email-txt {\n    color: var(--sub-text-color);\n    text-align: center;\n    font-family: Satoshi;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 20px;\n}\n.qr-price {\n    color: var(--text-color);\n    text-align: center;\n    font-family: Poppins;\n    font-size: 36px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 36px;\n}\n.qr-code-name input {\n    border-radius: 12px;\n    background: var(--sub-bg-color);\n    color: var(--sub-text-color);\n    text-align: center;\n    font-family: Poppins;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n    padding: 12px 24px;\n    border: 0;\n    width: 230px;\n    margin: auto;\n    display: flex;\n}\n.payment-method p {\n    color: var(--sub-text-color);\n    font-family: Satoshi;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 20px;\n}\n.payment-method {\n    padding-top: 50px;\n}\n.payment-method P {\n    color: var(--sub-text-color);\n    font-family: Satoshi;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 20px;\n}\n.profile-img-content img {\n    border-radius: 80px;\n}\n.line-scale>div {\n    background-color: #7B51F1;\n    width: 4px;\n    height: 35px;\n    border-radius: 2px;\n    margin: 2px;\n    -webkit-animation-fill-mode: both;\n    animation-fill-mode: both;\n    display: inline-block;\n}\n.line-scale>div:nth-child(1) {\n    -webkit-animation: line-scale 1s -0.4s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);\n    animation: line-scale 1s -0.4s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);\n}\n.line-scale>div:nth-child(2) {\n    -webkit-animation: line-scale 1s -0.3s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);\n    animation: line-scale 1s -0.3s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);\n}\n.line-scale>div:nth-child(3) {\n    -webkit-animation: line-scale 1s -0.2s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);\n    animation: line-scale 1s -0.2s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);\n}\n.line-scale>div:nth-child(4) {\n    -webkit-animation: line-scale 1s -0.1s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);\n    animation: line-scale 1s -0.1s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);\n}\n.line-scale>div:nth-child(5) {\n    -webkit-animation: line-scale 1s 0s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);\n    animation: line-scale 1s 0s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);\n}\n.loader {\n    position: fixed;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n}\n.overlay1 {\n    position: absolute;\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: 100% 100%;\n    width: 100%;\n    top: 0;\n    right: 0;\n    height: 100%;\n    border-radius: 24px 24px 0px 0px;\n    background: rgb(18 18 18 / 80%);\n}\n.scan1 .fingerprint1 {\n    position: relative;\n    width: 300px;\n    height: 300px;\n    background: url(../images/finger-print/scan-code1.png);\n    background-size: 300px;\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-color: white;\n}\n.scan1 {\n    position: relative;\n    background-image: url(../images/finger-print/print-border2.png);\n    width: 339px;\n    height: 339px;\n    background-size: 300px;\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-color: white;\n    margin-left: auto;\n    margin-right: auto;\n    margin-top: 70px;\n    border-radius: 25px;\n}\n.scan1 .fingerprint1::before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: url(../images/finger-print/scan-code1.png);\n    background-size: 300px;\n    background-repeat: no-repeat;\n    background-size: cover;\n    animation: animate 4s ease-in-out infinite;\n    background: linear-gradient(180deg, rgba(251, 73, 69, 0.00) 0%, rgba(251, 73, 69, 0.60) 100%);\n}\n.scan1 .fingerprint1::after {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 4px;\n    background: #FB4945;\n    border-radius: 8px;\n    filter: drop-shadow(0 0 20px #00D061) drop-shadow(0 0 60px #00D061);\n    animation: animate_line 4s ease-in-out infinite;\n}\n/************************ 53.Create new password CSS ***************************/\n#create-new-password-main .password-form input {\n    padding-right: 50px !important;\n}\n.password-form .form-floating>.form-control:focus~label {\n    color: var(--2, #7B51F1);\n    font-family: Satoshi;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 20px;\n}\n.password-form input {\n    color: var(--text-color) !important;\n    font-family: Satoshi;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n    border-radius: 12px;\n    background: var(--sub-bg-color);\n    border: 2px solid var(--sub-bg-color);\n    padding-right: 16px !important;\n}\ni#eye,\ni#eye1 {\n    font-size: 20px;\n    color: #5A5C5E;\n    position: absolute;\n    right: 16px;\n    top: 35%;\n    cursor: pointer;\n}\n.form-floating>.form-control:not(:placeholder-shown)~label {\n    color: #8854FF;\n}\n.password-form .form-floating>label {\n    color: var(--sub-text-color);\n    font-family: Satoshi;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n}\n.password-form .form-floating>.form-control:focus~label::after {\n    background: transparent;\n}\n.footer-checkbox-input+.footer-chec-txt:before {\n    content: \"\";\n    margin-right: 12px;\n    display: inline-block;\n    vertical-align: text-top;\n    width: 22px;\n    height: 22px;\n    border: 2px solid var(--text-color);\n    border-radius: 8px;\n}\n.footer-checkbox-input {\n    position: absolute;\n    opacity: 0;\n    width: fit-content;\n}\n.footer-checkbox-input:checked+.footer-chec-txt:after {\n    content: \"\";\n    position: absolute;\n    left: 6px;\n    top: 12px;\n    background: white;\n    width: 2px;\n    height: 2px;\n    box-shadow: 2px 0 0 white, 4px 0 0 white, 4px -2px 0 white, 4px -4px 0 white, 4px -6px 0 white, 4px -8px 0 white;\n    transform: rotate(45deg);\n}\n.footer-checkbox-input:checked+.footer-chec-txt:before {\n    background: black;\n    border: none;\n}\n.footer-checkbox-input+.footer-chec-txt {\n    position: relative;\n    cursor: pointer;\n    padding: 0;\n    color: var(--sub-text-color);\n    font-family: Satoshi;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n}\n.verify-txt h1 {\n    color: var(--text-color);\n    text-align: center;\n    font-family: Poppins;\n    font-size: 24px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 36px;\n}\n#empty-notification-main .verify-number-bottom {\n    padding-bottom: 30px;\n}\n/************************ 54.Keyframe Animation ***************************/\n@keyframes line-scale {\n    0% {\n        -webkit-transform: scaley(1);\n        transform: scaley(1);\n    }\n    50% {\n        -webkit-transform: scaley(0.4);\n        transform: scaley(0.4);\n    }\n    100% {\n        -webkit-transform: scaley(1);\n        transform: scaley(1);\n    }\n}\n@keyframes spin {\n    0% {\n        transform: rotate(0deg);\n    }\n    100% {\n        transform: rotate(360deg);\n    }\n}\n@keyframes animate {\n    0%,\n    100% {\n        height: 0%;\n    }\n    50% {\n        height: 100%;\n    }\n}\n@keyframes animate_line {\n    0%,\n    100% {\n        top: 0%;\n    }\n    50% {\n        top: 100%;\n    }\n}\n@keyframes pulse {\n    0%,\n    100% {\n        transform: scale(1);\n    }\n    50% {\n        transform: scale(1.1);\n    }\n}\n.offcanvas-title {\n    color: var(--text-color);\n}\n.btn-close {\n    filter: var(--icon-filter);\n}\n.diffrent-chat-dropdown {\n    max-height: 0;\n    overflow: hidden;\n    transition: max-height 0.4s ease, opacity 0.4s ease;\n    opacity: 0;\n}\n.diffrent-chat-dropdown.open {\n    max-height: 500px;\n    opacity: 1;\n}\n.pay-bill-img {\n    background: #00D061;\n}\n.upIconsSat {\n    transition: transform 0.3s ease;\n}\n.rotated {\n    transform: rotate(180deg);\n}\n.menu-canvas {\n    background: var(--primary-color);\n}\n/* Idetify Bottom Modal  */\n.modal-overlay {\n    position: fixed;\n    inset: 0;\n    background: rgba(0, 0, 0, 0.5);\n    display: flex;\n    justify-content: center;\n    align-items: flex-end;\n    z-index: 1000;\n}\n.photo-modal {\n    background: #fff;\n    border-radius: 16px 16px 0 0;\n    width: 100%;\n    max-width: 500px;\n    padding: 20px;\n    box-shadow: 0 -4px 10px rgba(0, 0, 0, 0.2);\n    animation: slideUp 0.3s ease;\n}\n@keyframes slideUp {\n    from {\n        transform: translateY(100%);\n    }\n    to {\n        transform: translateY(0);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
